/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
    bpSmall: false,
    hasSessionStorage: true,
    hasLocalStorage: true,
    mediaQuerySmall: `screen and (max-width: ${769}px)`,
    youTubeReady: false,
    vimeoReady: false,
    vimeoLoading: false,
    isTouch: !!(
        "ontouchstart" in window ||
        (window.DocumentTouch && window.document instanceof DocumentTouch) ||
        window.navigator.maxTouchPoints ||
        window.navigator.msMaxTouchPoints
    ),
    stickyHeader: false,
    rtl: document.documentElement.getAttribute("dir") == "rtl",
};
theme.recentlyViewedIds = [];

if (theme.config.isTouch) {
    document.documentElement.className += " supports-touch";
}

if (console && console.log) {
    console.log(
        `Expanse theme (${theme.settings.themeVersion}) by ARCHΞTYPE | Learn more at https://archetypethemes.co`
    );
}

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

(function () {
    theme.delegate = {
        on(event, callback, options) {
            if (!this.namespaces) {
                // save the namespaces on the DOM element itself
                this.namespaces = {};
            }

            this.namespaces[event] = callback;
            options = options || false;

            this.addEventListener(event.split(".")[0], callback, options);
            return this;
        },
        off(event) {
            if (!this.namespaces) {
                return;
            }
            this.removeEventListener(event.split(".")[0], this.namespaces[event]);
            delete this.namespaces[event];
            return this;
        },
    };

    // Extend the DOM with these above custom methods
    window.on = Element.prototype.on = theme.delegate.on;
    window.off = Element.prototype.off = theme.delegate.off;

    theme.utils = {
        defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        },

        wrap(el, wrapper) {
            el.parentNode.insertBefore(wrapper, el);
            wrapper.appendChild(el);
        },

        debounce(wait, callback, immediate) {
            let timeout;
            return function () {
                const context = this;
                const args = arguments;
                const later = function () {
                    timeout = null;
                    if (!immediate) callback.apply(context, args);
                };
                const callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) callback.apply(context, args);
            };
        },

        throttle(limit, callback) {
            let waiting = false;
            return function () {
                if (!waiting) {
                    callback.apply(this, arguments);
                    waiting = true;
                    setTimeout(() => {
                        waiting = false;
                    }, limit);
                }
            };
        },

        prepareTransition(el, callback) {
            el.addEventListener("transitionend", removeClass);

            function removeClass(evt) {
                el.classList.remove("is-transitioning");
                el.removeEventListener("transitionend", removeClass);
            }

            el.classList.add("is-transitioning");
            el.offsetWidth; // check offsetWidth to force the style rendering

            if (typeof callback === "function") {
                callback();
            }
        },

        // _.compact from lodash
        // Creates an array with all falsey values removed. The values `false`, `null`,
        // `0`, `""`, `undefined`, and `NaN` are falsey.
        // _.compact([0, 1, false, 2, '', 3]);
        // => [1, 2, 3]
        compact(array) {
            let index = -1;
            const length = array == null ? 0 : array.length;
            let resIndex = 0;
            const result = [];

            while (++index < length) {
                const value = array[index];
                if (value) {
                    result[resIndex++] = value;
                }
            }
            return result;
        },

        serialize(form) {
            const arr = [];
            Array.prototype.slice.call(form.elements).forEach(field => {
                if (
                    !field.name ||
                    field.disabled ||
                    ["file", "reset", "submit", "button"].indexOf(field.type) > -1
                )
                    return;
                if (field.type === "select-multiple") {
                    Array.prototype.slice.call(field.options).forEach(option => {
                        if (!option.selected) return;
                        arr.push(
                            `${encodeURIComponent(field.name)}=${encodeURIComponent(
                                option.value
                            )}`
                        );
                    });
                    return;
                }
                if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
                    return;
                arr.push(
                    `${encodeURIComponent(field.name)}=${encodeURIComponent(
                        field.value
                    )}`
                );
            });
            return arr.join("&");
        },
    };

    theme.a11y = {
        trapFocus(options) {
            const eventsName = {
                focusin: options.namespace
                    ? `focusin.${options.namespace}`
                    : "focusin",
                focusout: options.namespace
                    ? `focusout.${options.namespace}`
                    : "focusout",
                keydown: options.namespace
                    ? `keydown.${options.namespace}`
                    : "keydown.handleFocus",
            };

            // Get every possible visible focusable element
            const focusableEls = options.container.querySelectorAll(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
            );
            const elArray = [].slice.call(focusableEls);
            const focusableElements = elArray.filter(el => el.offsetParent !== null);

            const firstFocusable = focusableElements[0];
            const lastFocusable = focusableElements[focusableElements.length - 1];

            if (!options.elementToFocus) {
                options.elementToFocus = options.container;
            }

            options.container.setAttribute("tabindex", "-1");
            options.elementToFocus.focus();

            document.documentElement.off("focusin");
            document.documentElement.on(eventsName.focusout, () => {
                document.documentElement.off(eventsName.keydown);
            });

            document.documentElement.on(eventsName.focusin, evt => {
                if (evt.target !== lastFocusable && evt.target !== firstFocusable)
                    return;

                document.documentElement.on(eventsName.keydown, evt => {
                    _manageFocus(evt);
                });
            });

            function _manageFocus(evt) {
                if (evt.keyCode !== 9) return;
                /**
                 * On the first focusable element and tab backward,
                 * focus the last element
                 */
                if (evt.target === firstFocusable && evt.shiftKey) {
                    evt.preventDefault();
                    lastFocusable.focus();
                }
            }
        },
        removeTrapFocus(options) {
            const eventName = options.namespace
                ? `focusin.${options.namespace}`
                : "focusin";

            if (options.container) {
                options.container.removeAttribute("tabindex");
            }

            document.documentElement.off(eventName);
        },

        lockMobileScrolling(namespace, element) {
            const el = element || document.documentElement;
            document.documentElement.classList.add("lock-scroll");
            el.on(`touchmove${namespace}`, () => true);
        },

        unlockMobileScrolling(namespace, element) {
            document.documentElement.classList.remove("lock-scroll");
            const el = element || document.documentElement;
            el.off(`touchmove${namespace}`);
        },
    };

    // Add class when tab key starts being used to show outlines
    document.documentElement.on("keyup.tab", evt => {
        if (evt.keyCode === 9) {
            document.documentElement.classList.add("tab-outline");
            document.documentElement.off("keyup.tab");
        }
    });

    /**
     * Currency Helpers
     * -----------------------------------------------------------------------------
     * A collection of useful functions that help with currency formatting
     *
     * Current contents
     * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
     *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
     * - getBaseUnit - Splits unit price apart to get value + unit
     *
     */

    theme.Currency = (function () {
        const moneyFormat = "${{amount}}";
        const superScript =
            theme && theme.settings && theme.settings.superScriptPrice;

        function formatMoney(cents, format) {
            if (!format) {
                format = theme.settings.moneyFormat;
            }

            if (typeof cents === "string") {
                cents = cents.replace(".", "");
            }
            let value = "";
            const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            const formatString = format || moneyFormat;

            function formatWithDelimiters(number, precision, thousands, decimal) {
                precision = theme.utils.defaultTo(precision, 2);
                thousands = theme.utils.defaultTo(thousands, ",");
                decimal = theme.utils.defaultTo(decimal, ".");

                if (isNaN(number) || number == null) {
                    return 0;
                }

                number = (number / 100.0).toFixed(precision);

                const parts = number.split(".");
                const dollarsAmount = parts[0].replace(
                    /(\d)(?=(\d\d\d)+(?!\d))/g,
                    `$1${thousands}`
                );
                const centsAmount = parts[1] ? decimal + parts[1] : "";

                return dollarsAmount + centsAmount;
            }

            switch (formatString.match(placeholderRegex)[1]) {
                case "amount":
                    value = formatWithDelimiters(cents, 2);

                    if (superScript && value && value.includes(".")) {
                        value = `${value.replace(".", "<sup>")}</sup>`;
                    }

                    break;
                case "amount_no_decimals":
                    value = formatWithDelimiters(cents, 0);
                    break;
                case "amount_with_comma_separator":
                    value = formatWithDelimiters(cents, 2, ".", ",");

                    if (superScript && value && value.includes(".")) {
                        value = `${value.replace(",", "<sup>")}</sup>`;
                    }

                    break;
                case "amount_no_decimals_with_comma_separator":
                    value = formatWithDelimiters(cents, 0, ".", ",");
                    break;
                case "amount_no_decimals_with_space_separator":
                    value = formatWithDelimiters(cents, 0, " ");
                    break;
            }

            return formatString.replace(placeholderRegex, value);
        }

        function getBaseUnit(variant) {
            if (!variant) {
                return;
            }

            if (
                !variant.unit_price_measurement ||
                !variant.unit_price_measurement.reference_value
            ) {
                return;
            }

            return variant.unit_price_measurement.reference_value === 1
                ? variant.unit_price_measurement.reference_unit
                : variant.unit_price_measurement.reference_value +
                      variant.unit_price_measurement.reference_unit;
        }

        return {
            formatMoney,
            getBaseUnit,
        };
    })();

    theme.Images = (function () {
        /**
         * Find the Shopify image attribute size
         */
        function imageSize(src) {
            if (!src) {
                return "620x"; // default based on theme
            }

            const match = src.match(
                /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
            );

            if (match !== null) {
                return match[1];
            }
            return null;
        }

        /**
         * Adds a Shopify size attribute to a URL
         */
        function getSizedImageUrl(src, size) {
            if (!src) {
                return src;
            }

            if (size == null) {
                return src;
            }

            if (size === "master") {
                return this.removeProtocol(src);
            }

            const match = src.match(
                /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
            );

            if (match != null) {
                const prefix = src.split(match[0]);
                const suffix = match[0];

                return this.removeProtocol(`${prefix[0]}_${size}${suffix}`);
            }

            return null;
        }

        function removeProtocol(path) {
            return path.replace(/http(s)?:/, "");
        }

        function lazyloadImagePath(string) {
            let image;

            if (string !== null) {
                image = string.replace(/(\.[^.]*)$/, "_{width}x$1");
            }

            return image;
        }

        return {
            imageSize,
            getSizedImageUrl,
            removeProtocol,
            lazyloadImagePath,
        };
    })();

    theme.loadImageSection = function (container) {
        // Wait until images inside container have lazyloaded class
        function setAsLoaded() {
            container.classList.remove("loading", "loading--delayed");
            container.classList.add("loaded");
        }

        function checkForLazyloadedImage() {
            return container.querySelector(".lazyloaded");
        }

        // If it has SVGs it's in the onboarding state so set as loaded
        if (container.querySelector("svg")) {
            setAsLoaded();
            return;
        }

        if (checkForLazyloadedImage()) {
            setAsLoaded();
            return;
        }

        var interval = setInterval(() => {
            if (checkForLazyloadedImage()) {
                clearInterval(interval);
                setAsLoaded();
            }
        }, 25);
    };

    // Init section function when it's visible, then disable observer
    theme.initWhenVisible = function (options) {
        const threshold = options.threshold ? options.threshold : 0;

        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        if (typeof options.callback === "function") {
                            options.callback();
                            observer.unobserve(entry.target);
                        }
                    }
                });
            },
            { rootMargin: `0px 0px ${threshold}px 0px` }
        );

        observer.observe(options.element);
    };

    theme.LibraryLoader = (function () {
        const types = {
            link: "link",
            script: "script",
        };

        const status = {
            requested: "requested",
            loaded: "loaded",
        };

        const cloudCdn = "https://cdn.shopify.com/shopifycloud/";

        const libraries = {
            youtubeSdk: {
                tagId: "youtube-sdk",
                src: "https://www.youtube.com/iframe_api",
                type: types.script,
            },
            vimeo: {
                tagId: "vimeo-api",
                src: "https://player.vimeo.com/api/player.js",
                type: types.script,
            },
            shopifyXr: {
                tagId: "shopify-model-viewer-xr",
                src: `${cloudCdn}shopify-xr-js/assets/v1.0/shopify-xr.en.js`,
                type: types.script,
            },
            modelViewerUi: {
                tagId: "shopify-model-viewer-ui",
                src: `${cloudCdn}model-viewer-ui/assets/v1.0/model-viewer-ui.en.js`,
                type: types.script,
            },
            modelViewerUiStyles: {
                tagId: "shopify-model-viewer-ui-styles",
                src: `${cloudCdn}model-viewer-ui/assets/v1.0/model-viewer-ui.css`,
                type: types.link,
            },
        };

        function load(libraryName, callback) {
            const library = libraries[libraryName];

            if (!library) return;
            if (library.status === status.requested) return;

            callback = callback || function () {};
            if (library.status === status.loaded) {
                callback();
                return;
            }

            library.status = status.requested;

            let tag;

            switch (library.type) {
                case types.script:
                    tag = createScriptTag(library, callback);
                    break;
                case types.link:
                    tag = createLinkTag(library, callback);
                    break;
            }

            tag.id = library.tagId;
            library.element = tag;

            const firstScriptTag = document.getElementsByTagName(library.type)[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }

        function createScriptTag(library, callback) {
            const tag = document.createElement("script");
            tag.src = library.src;
            tag.addEventListener("load", () => {
                library.status = status.loaded;
                callback();
            });
            return tag;
        }

        function createLinkTag(library, callback) {
            const tag = document.createElement("link");
            tag.href = library.src;
            tag.rel = "stylesheet";
            tag.type = "text/css";
            tag.addEventListener("load", () => {
                library.status = status.loaded;
                callback();
            });
            return tag;
        }

        return {
            load,
        };
    })();

    theme.rteInit = function () {
        // Wrap tables so they become scrollable on small screens
        document.querySelectorAll(".rte table").forEach(table => {
            const wrapWith = document.createElement("div");
            wrapWith.classList.add("table-wrapper");
            theme.utils.wrap(table, wrapWith);
        });

        // Wrap video iframe embeds so they are responsive
        document
            .querySelectorAll('.rte iframe[src*="youtube.com/embed"]')
            .forEach(iframe => {
                wrapVideo(iframe);
            });
        document
            .querySelectorAll('.rte iframe[src*="player.vimeo"]')
            .forEach(iframe => {
                wrapVideo(iframe);
            });

        function wrapVideo(iframe) {
            // Reset the src attribute on each iframe after page load
            // for Chrome's "incorrect iFrame content on 'back'" bug.
            // https://code.google.com/p/chromium/issues/detail?id=395791
            iframe.src = iframe.src;
            const wrapWith = document.createElement("div");
            wrapWith.classList.add("video-wrapper");
            theme.utils.wrap(iframe, wrapWith);
        }

        // Remove CSS that adds animated underline under image links
        document.querySelectorAll(".rte a img").forEach(img => {
            img.parentNode.classList.add("rte__image");
        });
    };

    theme.Sections = function Sections() {
        this.constructors = {};
        this.instances = [];

        document.addEventListener(
            "shopify:section:load",
            this._onSectionLoad.bind(this)
        );
        document.addEventListener(
            "shopify:section:unload",
            this._onSectionUnload.bind(this)
        );
        document.addEventListener(
            "shopify:section:select",
            this._onSelect.bind(this)
        );
        document.addEventListener(
            "shopify:section:deselect",
            this._onDeselect.bind(this)
        );
        document.addEventListener(
            "shopify:block:select",
            this._onBlockSelect.bind(this)
        );
        document.addEventListener(
            "shopify:block:deselect",
            this._onBlockDeselect.bind(this)
        );
    };

    theme.Sections.prototype = {
        ...theme.Sections.prototype,
        _createInstance(container, constructor, scope) {
            const id = container.getAttribute("data-section-id");
            const type = container.getAttribute("data-section-type");

            constructor = constructor || this.constructors[type];

            if (typeof constructor === "undefined") {
                return;
            }

            // If custom scope passed, check to see if instance
            // is already initialized so we don't double up
            if (scope) {
                const instanceExists = this._findInstance(id);
                if (instanceExists) {
                    this._removeInstance(id);
                }
            }

            // If a section fails to init, handle the error without letting all subsequest section registers to fail
            try {
                const instance = Object.assign(new constructor(container), {
                    id,
                    type,
                    container,
                });
                this.instances.push(instance);
            } catch (e) {
                console.error(e);
            }
        },

        _findInstance(id) {
            for (let i = 0; i < this.instances.length; i++) {
                if (this.instances[i].id === id) {
                    return this.instances[i];
                }
            }
        },

        _removeInstance(id) {
            let i = this.instances.length;
            let instance;

            while (i--) {
                if (this.instances[i].id === id) {
                    instance = this.instances[i];
                    this.instances.splice(i, 1);
                    break;
                }
            }

            return instance;
        },

        _onSectionLoad(evt, subSection, subSectionId) {
            if (window.AOS) {
                AOS.refreshHard();
            }
            if (theme && theme.initGlobals) {
                theme.initGlobals();
            }

            const container = subSection || evt.target;
            const section =
                subSection || evt.target.querySelector("[data-section-id]");

            if (!section) {
                return;
            }

            this._createInstance(section);

            const instance = subSection
                ? subSectionId
                : this._findInstance(evt.detail.sectionId);

            // Check if we have subsections to load
            const haveSubSections = container.querySelectorAll("[data-subsection]");
            if (haveSubSections.length) {
                this.loadSubSections(container);
            }

            // Run JS only in case of the section being selected in the editor
            // before merchant clicks "Add"
            if (instance && typeof instance.onLoad === "function") {
                instance.onLoad(evt);
            }

            // Force editor to trigger scroll event when loading a section
            setTimeout(() => {
                window.dispatchEvent(new Event("scroll"));
            }, 200);
        },

        _onSectionUnload(evt) {
            this.instances = this.instances.filter(instance => {
                const isEventInstance = instance.id === evt.detail.sectionId;

                if (isEventInstance) {
                    if (typeof instance.onUnload === "function") {
                        instance.onUnload(evt);
                    }
                }

                return !isEventInstance;
            });
        },

        loadSubSections(scope) {
            if (!scope) {
                return;
            }

            const sections = scope.querySelectorAll("[data-section-id]");

            sections.forEach(el => {
                this._onSectionLoad(null, el, el.dataset.sectionId);
            });
        },

        _onSelect(evt) {
            const instance = this._findInstance(evt.detail.sectionId);

            if (
                typeof instance !== "undefined" &&
                typeof instance.onSelect === "function"
            ) {
                instance.onSelect(evt);
            }
        },

        _onDeselect(evt) {
            const instance = this._findInstance(evt.detail.sectionId);

            if (
                typeof instance !== "undefined" &&
                typeof instance.onDeselect === "function"
            ) {
                instance.onDeselect(evt);
            }
        },

        _onBlockSelect(evt) {
            const instance = this._findInstance(evt.detail.sectionId);

            if (
                typeof instance !== "undefined" &&
                typeof instance.onBlockSelect === "function"
            ) {
                instance.onBlockSelect(evt);
            }
        },

        _onBlockDeselect(evt) {
            const instance = this._findInstance(evt.detail.sectionId);

            if (
                typeof instance !== "undefined" &&
                typeof instance.onBlockDeselect === "function"
            ) {
                instance.onBlockDeselect(evt);
            }
        },

        register(type, constructor, scope) {
            this.constructors[type] = constructor;

            let sections = document.querySelectorAll(
                `[data-section-type="${type}"]`
            );

            if (scope) {
                sections = scope.querySelectorAll(`[data-section-type="${type}"]`);
            }

            sections.forEach(container => {
                this._createInstance(container, constructor, scope);
            });
        },

        reinit(section) {
            for (let i = 0; i < this.instances.length; i++) {
                const instance = this.instances[i];
                if (instance.type === section) {
                    if (typeof instance.forceReload === "function") {
                        instance.forceReload();
                    }
                }
            }
        },
    };

    /*
    Options:
      container
      enableHistoryState - enable when on single product page to update URL
      singleOptionSelector - selector for individual variant option (e.g. 'Blue' or 'Small')
      originalSelectorId - selector for base variant selector (visually hidden)
      variants - JSON parsed object of product variant info
   */
    theme.Variants = (function () {
        function Variants(options) {
            this.container = options.container;
            this.variants = options.variants;
            this.singleOptionSelector = options.singleOptionSelector;
            this.originalSelectorId = options.originalSelectorId;
            this.enableHistoryState = options.enableHistoryState;
            this.currentlySelectedValues = this._getCurrentOptions();
            this.currentVariant = this._getVariantFromOptions(
                this.currentlySelectedValues
            );

            this.container
                .querySelectorAll(this.singleOptionSelector)
                .forEach(el => {
                    el.addEventListener("change", this._onSelectChange.bind(this));
                });
        }

        Variants.prototype = {
            ...Variants.prototype,
            _getCurrentOptions() {
                let result = [];

                this.container
                    .querySelectorAll(this.singleOptionSelector)
                    .forEach(el => {
                        const type = el.getAttribute("type");

                        if (type === "radio" || type === "checkbox") {
                            if (el.checked) {
                                result.push({
                                    value: el.value,
                                    index: el.dataset.index,
                                });
                            }
                        } else {
                            result.push({
                                value: el.value,
                                index: el.dataset.index,
                            });
                        }
                    });

                // remove any unchecked input values if using radio buttons or checkboxes
                result = theme.utils.compact(result);

                return result;
            },

            _getVariantFromOptions(selectedValues) {
                const { variants } = this;
                let found = false;

                if (selectedValues.length !== variants[0].options.length)
                    return null;

                variants.forEach(variant => {
                    let match = true;
                    const { options } = variant;

                    selectedValues.forEach(option => {
                        if (match) {
                            match = variant[option.index] === option.value;
                        }
                    });

                    if (match) {
                        found = variant;
                    }
                });

                return found || null;
            },

            _onSelectChange(evt) {
                const el = evt.srcElement;
                const type = el.getAttribute("type");

                if (el.classList.contains("disabled")) {
                    this.container
                        .querySelectorAll(this.singleOptionSelector)
                        .forEach(input => {
                            if (type === "radio" || type === "checkbox") {
                                if (input !== el) {
                                    input.checked = false;
                                }
                            }
                        });
                }

                this.currentlySelectedValues = this._getCurrentOptions();
                const variant = this._getVariantFromOptions(
                    this.currentlySelectedValues
                );

                this.container.dispatchEvent(
                    new CustomEvent("variantChange", {
                        detail: {
                            variant,
                            currentlySelectedValues: this.currentlySelectedValues,
                            value: evt.srcElement.value,
                            index: evt.srcElement.parentElement.dataset.index,
                        },
                    })
                );

                document.dispatchEvent(
                    new CustomEvent("variant:change", {
                        detail: {
                            variant,
                            currentlySelectedValues: this.currentlySelectedValues,
                            value: evt.srcElement.value,
                            index: evt.srcElement.parentElement.dataset.index,
                        },
                    })
                );

                if (!variant) {
                    return;
                }

                this._updateMasterSelect(variant);
                this._updateImages(variant);
                this._updatePrice(variant);
                this._updateUnitPrice(variant);
                this._updateSKU(variant);
                this.currentVariant = variant;

                if (this.enableHistoryState) {
                    this._updateHistoryState(variant);
                }
            },

            _updateImages(variant) {
                const variantImage = variant.featured_image || {};
                const currentVariantImage =
                    (this.currentVariant && this.currentVariant.featured_image) ||
                    {};

                if (
                    !variant.featured_image ||
                    variantImage.src === currentVariantImage.src
                ) {
                    return;
                }

                this.container.dispatchEvent(
                    new CustomEvent("variantImageChange", {
                        detail: {
                            variant,
                        },
                    })
                );
            },

            _updatePrice(variant) {
                if (
                    this.currentVariant &&
                    variant.price === this.currentVariant.price &&
                    variant.compare_at_price === this.currentVariant.compare_at_price
                ) {
                    return;
                }

                this.container.dispatchEvent(
                    new CustomEvent("variantPriceChange", {
                        detail: {
                            variant,
                        },
                    })
                );
            },

            _updateUnitPrice(variant) {
                if (
                    this.currentVariant &&
                    variant.unit_price === this.currentVariant.unit_price
                ) {
                    return;
                }

                this.container.dispatchEvent(
                    new CustomEvent("variantUnitPriceChange", {
                        detail: {
                            variant,
                        },
                    })
                );
            },

            _updateSKU(variant) {
                if (this.currentVariant && variant.sku === this.currentVariant.sku) {
                    return;
                }

                this.container.dispatchEvent(
                    new CustomEvent("variantSKUChange", {
                        detail: {
                            variant,
                        },
                    })
                );
            },

            _updateHistoryState(variant) {
                if (!history.replaceState || !variant) {
                    return;
                }

                const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${variant.id}`;
                window.history.replaceState({ path: newurl }, "", newurl);
            },

            _updateMasterSelect(variant) {
                this.container.querySelector(this.originalSelectorId).value =
                    variant.id;
                // Force a change event so Shop Pay installments works after a variant is changed
                this.container
                    .querySelector(this.originalSelectorId)
                    .dispatchEvent(new Event("change", { bubbles: true }));
            },
        };

        return Variants;
    })();

    window.vimeoApiReady = function () {
        theme.config.vimeoLoading = true;

        // Because there's no way to check for the Vimeo API being loaded
        // asynchronously, we use this terrible timeout to wait for it being ready
        checkIfVimeoIsReady().then(() => {
            theme.config.vimeoReady = true;
            theme.config.vimeoLoading = false;
            document.dispatchEvent(new CustomEvent("vimeoReady"));
        });
    };

    function checkIfVimeoIsReady() {
        let wait;
        let timeout;

        const deferred = new Promise((resolve, reject) => {
            wait = setInterval(() => {
                if (!Vimeo) {
                    return;
                }

                clearInterval(wait);
                clearTimeout(timeout);
                resolve();
            }, 500);

            timeout = setTimeout(() => {
                clearInterval(wait);
                reject();
            }, 4000); // subjective. test up to 8 times over 4 seconds
        });

        return deferred;
    }

    theme.VimeoPlayer = (function () {
        const classes = {
            loading: "loading",
            loaded: "loaded",
            interactable: "video-interactable",
        };

        const defaults = {
            background: true,
            byline: false,
            controls: false,
            loop: true,
            muted: true,
            playsinline: true,
            portrait: false,
            title: false,
        };

        function VimeoPlayer(divId, videoId, options) {
            this.divId = divId;
            this.el = document.getElementById(divId);
            this.videoId = videoId;
            this.iframe = null;
            this.options = options;

            if (this.options && this.options.videoParent) {
                this.parent = this.el.closest(this.options.videoParent);
            }

            this.setAsLoading();

            if (theme.config.vimeoReady) {
                this.init();
            } else {
                theme.LibraryLoader.load("vimeo", window.vimeoApiReady);
                document.addEventListener("vimeoReady", this.init.bind(this));
            }
        }

        VimeoPlayer.prototype = {
            ...VimeoPlayer.prototype,
            init() {
                const args = defaults;
                args.id = this.videoId;

                this.videoPlayer = new Vimeo.Player(this.el, args);

                this.videoPlayer.ready().then(this.playerReady.bind(this));
            },

            playerReady() {
                this.iframe = this.el.querySelector("iframe");
                this.iframe.setAttribute("tabindex", "-1");

                this.videoPlayer.setMuted(true);

                this.setAsLoaded();

                // pause when out of view
                const observer = new IntersectionObserver(
                    (entries, observer) => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                this.play();
                            } else {
                                this.pause();
                            }
                        });
                    },
                    { rootMargin: "0px 0px 50px 0px" }
                );

                observer.observe(this.iframe);
            },

            setAsLoading() {
                if (!this.parent) return;
                this.parent.classList.add(classes.loading);
            },

            setAsLoaded() {
                if (!this.parent) return;
                this.parent.classList.remove(classes.loading);
                this.parent.classList.add(classes.loaded);
                if (Shopify && Shopify.designMode) {
                    if (window.AOS) {
                        AOS.refreshHard();
                    }
                }
            },

            enableInteraction() {
                if (!this.parent) return;
                this.parent.classList.add(classes.interactable);
            },

            play() {
                if (
                    this.videoPlayer &&
                    typeof this.videoPlayer.play === "function"
                ) {
                    this.videoPlayer.play();
                }
            },

            pause() {
                if (
                    this.videoPlayer &&
                    typeof this.videoPlayer.pause === "function"
                ) {
                    this.videoPlayer.pause();
                }
            },

            destroy() {
                if (
                    this.videoPlayer &&
                    typeof this.videoPlayer.destroy === "function"
                ) {
                    this.videoPlayer.destroy();
                }
            },
        };

        return VimeoPlayer;
    })();

    window.onYouTubeIframeAPIReady = function () {
        theme.config.youTubeReady = true;
        document.dispatchEvent(new CustomEvent("youTubeReady"));
    };

    /*= ===========================================================================
    YouTube SDK method
    Parameters:
      - player div id (required)
      - arguments
        - videoId (required)
        - videoParent (selector, optional for section loading state)
        - events (object, optional)
  ============================================================================== */
    theme.YouTube = (function () {
        const classes = {
            loading: "loading",
            loaded: "loaded",
            interactable: "video-interactable",
        };

        const defaults = {
            width: 1280,
            height: 720,
            playerVars: {
                autohide: 0,
                autoplay: 1,
                cc_load_policy: 0,
                controls: 0,
                fs: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1,
                rel: 0,
            },
        };

        function YouTube(divId, options) {
            this.divId = divId;
            this.iframe = null;

            this.attemptedToPlay = false;

            // API callback events
            defaults.events = {
                onReady: this.onVideoPlayerReady.bind(this),
                onStateChange: this.onVideoStateChange.bind(this),
            };

            this.options = { ...defaults, ...options };

            if (this.options) {
                if (this.options.videoParent) {
                    this.parent = document
                        .getElementById(this.divId)
                        .closest(this.options.videoParent);
                }

                // Most YT videos will autoplay. If in product media,
                // will handle in theme.Product instead
                if (!this.options.autoplay) {
                    this.options.playerVars.autoplay = this.options.autoplay;
                }

                if (this.options.style === "sound") {
                    this.options.playerVars.controls = 1;
                    this.options.playerVars.autoplay = 0;
                }
            }

            this.setAsLoading();

            if (theme.config.youTubeReady) {
                this.init();
            } else {
                theme.LibraryLoader.load("youtubeSdk");
                document.addEventListener("youTubeReady", this.init.bind(this));
            }
        }

        YouTube.prototype = {
            ...YouTube.prototype,
            init() {
                this.videoPlayer = new YT.Player(this.divId, this.options);
            },

            onVideoPlayerReady(evt) {
                this.iframe = document.getElementById(this.divId); // iframe once YT loads
                this.iframe.setAttribute("tabindex", "-1");

                if (this.options.style !== "sound") {
                    evt.target.mute();
                }

                // pause when out of view
                const observer = new IntersectionObserver(
                    (entries, observer) => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                this.play();
                            } else {
                                this.pause();
                            }
                        });
                    },
                    { rootMargin: "0px 0px 50px 0px" }
                );

                observer.observe(this.iframe);
            },

            onVideoStateChange(evt) {
                switch (evt.data) {
                    case -1: // unstarted
                        // Handle low power state on iOS by checking if
                        // video is reset to unplayed after attempting to buffer
                        if (this.attemptedToPlay) {
                            this.setAsLoaded();
                            this.enableInteraction();
                        }
                        break;
                    case 0: // ended, loop it
                        this.play(evt);
                        break;
                    case 1: // playing
                        this.setAsLoaded();
                        break;
                    case 3: // buffering
                        this.attemptedToPlay = true;
                        break;
                }
            },

            setAsLoading() {
                if (!this.parent) return;
                this.parent.classList.add(classes.loading);
            },

            setAsLoaded() {
                if (!this.parent) return;
                this.parent.classList.remove(classes.loading);
                this.parent.classList.add(classes.loaded);
                if (Shopify && Shopify.designMode) {
                    if (window.AOS) {
                        AOS.refreshHard();
                    }
                }
            },

            enableInteraction() {
                if (!this.parent) return;
                this.parent.classList.add(classes.interactable);
            },

            play() {
                if (
                    this.videoPlayer &&
                    typeof this.videoPlayer.playVideo === "function"
                ) {
                    this.videoPlayer.playVideo();
                }
            },

            pause() {
                if (
                    this.videoPlayer &&
                    typeof this.videoPlayer.pauseVideo === "function"
                ) {
                    this.videoPlayer.pauseVideo();
                }
            },

            destroy() {
                if (
                    this.videoPlayer &&
                    typeof this.videoPlayer.destroy === "function"
                ) {
                    this.videoPlayer.destroy();
                }
            },
        };

        return YouTube;
    })();

    // Prevent vertical scroll while using flickity sliders
    (function () {
        let e = !1;
        let t;

        document.body.addEventListener("touchstart", i => {
            if (!i.target.closest(".flickity-slider")) {
                return (e = !1);
                void 0;
            }
            e = !0;
            t = {
                x: i.touches[0].pageX,
                y: i.touches[0].pageY,
            };
        });

        document.body.addEventListener(
            "touchmove",
            i => {
                if (e && i.cancelable) {
                    const n = {
                        x: i.touches[0].pageX - t.x,
                        y: i.touches[0].pageY - t.y,
                    };
                    Math.abs(n.x) > Flickity.defaults.dragThreshold &&
                        i.preventDefault();
                }
            },
            { passive: !1 }
        );
    })();

    /**
     * Ajax Renderer
     * -----------------------------------------------------------------------------
     * Render sections without reloading the page.
     * @param {Object[]} sections - The section to update on render.
     * @param {string} sections[].sectionId - The ID of the section from Shopify.
     * @param {string} sections[].nodeId - The ID of the DOM node to replace.
     * @param {Function} sections[].onReplace (optional) - The custom render function.
     * @param {boolean} debug - Output logs to console for debugging.
     *
     */

    theme.AjaxRenderer = (function () {
        function AjaxRenderer({ sections, onReplace, debug } = {}) {
            this.sections = sections || [];
            this.cachedSections = [];
            this.onReplace = onReplace;
            this.debug = Boolean(debug);
        }

        AjaxRenderer.prototype = {
            ...AjaxRenderer.prototype,
            renderPage(basePath, newParams, updateURLHash = true) {
                const currentParams = new URLSearchParams(window.location.search);
                const updatedParams = this.getUpdatedParams(
                    currentParams,
                    newParams
                );

                const sectionRenders = this.sections.map(section => {
                    const url = `${basePath}?section_id=${
                        section.sectionId
                    }&${updatedParams.toString()}`;
                    const cachedSectionUrl = cachedSection =>
                        cachedSection.url === url;

                    return this.cachedSections.some(cachedSectionUrl)
                        ? this.renderSectionFromCache(cachedSectionUrl, section)
                        : this.renderSectionFromFetch(url, section);
                });

                if (updateURLHash) this.updateURLHash(updatedParams);

                return Promise.all(sectionRenders);
            },

            renderSectionFromCache(url, section) {
                const cachedSection = this.cachedSections.find(url);

                this.log(
                    `[AjaxRenderer] rendering from cache: url=${cachedSection.url}`
                );
                this.renderSection(cachedSection.html, section);
                return Promise.resolve(section);
            },

            renderSectionFromFetch(url, section) {
                this.log(`[AjaxRenderer] redering from fetch: url=${url}`);

                return new Promise((resolve, reject) => {
                    fetch(url)
                        .then(response => response.text())
                        .then(responseText => {
                            const html = responseText;
                            this.cachedSections = [
                                ...this.cachedSections,
                                { html, url },
                            ];
                            this.renderSection(html, section);
                            resolve(section);
                        })
                        .catch(err => reject(err));
                });
            },

            renderSection(html, section) {
                this.log(
                    `[AjaxRenderer] rendering section: section=${JSON.stringify(
                        section
                    )}`
                );

                const newDom = new DOMParser().parseFromString(html, "text/html");
                if (this.onReplace) {
                    this.onReplace(newDom, section);
                } else if (typeof section.nodeId === "string") {
                    const newContentEl = newDom.getElementById(section.nodeId);
                    if (!newContentEl) {
                        return;
                    }

                    document.getElementById(section.nodeId).innerHTML =
                        newContentEl.innerHTML;
                } else {
                    section.nodeId.forEach(id => {
                        document.getElementById(id).innerHTML =
                            newDom.getElementById(id).innerHTML;
                    });
                }

                return section;
            },

            getUpdatedParams(currentParams, newParams) {
                const clone = new URLSearchParams(currentParams);
                const preservedParams = ["sort_by", "q", "options[prefix]", "type"];

                // Find what params need to be removed
                // delete happens first as we cannot specify keys based off of values
                for (const [key, value] of clone.entries()) {
                    if (
                        !newParams.getAll(key).includes(value) &&
                        !preservedParams.includes(key)
                    ) {
                        clone.delete(key);
                    }
                }

                // Find what params need to be added
                for (const [key, value] of newParams.entries()) {
                    if (!clone.getAll(key).includes(value) && value !== "") {
                        clone.append(key, value);
                    }
                }

                return clone;
            },

            updateURLHash(searchParams) {
                history.pushState(
                    {},
                    "",
                    `${window.location.pathname}${
                        searchParams && "?".concat(searchParams)
                    }`
                );
            },

            log(...args) {
                if (this.debug) {
                    console.log(...args);
                }
            },
        };

        return AjaxRenderer;
    })();

    if (
        window.Shopify &&
        window.Shopify.theme &&
        navigator &&
        navigator.sendBeacon &&
        window.Shopify.designMode
    ) {
        navigator.sendBeacon(
            "https://api.archetypethemes.co/api/beacon",
            new URLSearchParams({
                shop: window.Shopify.shop,
                themeName:
                    window.theme &&
                    window.theme.settings &&
                    `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
                role: window.Shopify.theme.role,
                route: window.location.pathname,
                themeId: window.Shopify.theme.id,
                themeStoreId: window.Shopify.theme.theme_store_id || 0,
                isThemeEditor: !!window.Shopify.designMode,
            })
        );
    }
    theme.cart = {
        getCart() {
            const url = "".concat(theme.routes.cart, "?t=").concat(Date.now());
            return fetch(url, {
                credentials: "same-origin",
                method: "GET",
            }).then(response => response.json());
        },

        getCartProductMarkup() {
            let url = "".concat(theme.routes.cartPage, "?t=").concat(Date.now());

            url = url.indexOf("?") === -1 ? `${url}?view=ajax` : `${url}&view=ajax`;

            return fetch(url, {
                credentials: "same-origin",
                method: "GET",
            }).then(response => response.text());
        },

        changeItem(key, qty) {
            return this._updateCart({
                url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()),
                data: JSON.stringify({
                    id: key,
                    quantity: qty,
                }),
            });
        },

        _updateCart(params) {
            return fetch(params.url, {
                method: "POST",
                body: params.data,
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            })
                .then(response => response.json())
                .then(cart => cart);
        },

        updateAttribute(key, value) {
            return this._updateCart({
                url: "/cart/update.js",
                data: JSON.stringify({
                    attributes: {
                        [key]: theme.cart.attributeToString(value),
                    },
                }),
            });
        },

        updateNote(note) {
            return this._updateCart({
                url: "/cart/update.js",
                data: JSON.stringify({
                    note: theme.cart.attributeToString(note),
                }),
            });
        },

        attributeToString(attribute) {
            if (typeof attribute !== "string") {
                attribute += "";
                if (attribute === "undefined") {
                    attribute = "";
                }
            }
            return attribute.trim();
        },
    };

    /*= ===========================================================================
    CartForm
    - Prevent checkout when terms checkbox exists
    - Listen to quantity changes, rebuild cart (both widget and page)
  ============================================================================== */
    theme.CartForm = (function () {
        const selectors = {
            products: "[data-products]",
            qtySelector: ".js-qty__wrapper",
            discounts: "[data-discounts]",
            savings: "[data-savings]",
            subTotal: "[data-subtotal]",

            cartBubble: ".cart-link__bubble",
            cartNote: '[name="note"]',
            termsCheckbox: ".cart__terms-checkbox",
            checkoutBtn: ".cart__checkout",
        };

        const classes = {
            btnLoading: "btn--loading",
        };

        const config = {
            requiresTerms: false,
        };

        function CartForm(form) {
            if (!form) {
                return;
            }

            this.form = form;
            this.wrapper = form.parentNode;
            this.location = form.dataset.location;
            this.namespace = `.cart-${this.location}`;
            this.products = form.querySelector(selectors.products);
            this.submitBtn = form.querySelector(selectors.checkoutBtn);

            this.discounts = form.querySelector(selectors.discounts);
            this.savings = form.querySelector(selectors.savings);
            this.subtotal = form.querySelector(selectors.subTotal);
            this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
            this.noteInput = form.querySelector(selectors.cartNote);

            if (this.termsCheckbox) {
                config.requiresTerms = true;
            }

            this.init();
        }

        CartForm.prototype = {
            ...CartForm.prototype,
            init() {
                this.initQtySelectors();

                document.addEventListener(
                    `cart:quantity${this.namespace}`,
                    this.quantityChanged.bind(this)
                );

                this.form.on(`submit${this.namespace}`, this.onSubmit.bind(this));

                if (this.noteInput) {
                    this.noteInput.addEventListener("change", function () {
                        const newNote = this.value;
                        theme.cart.updateNote(newNote);
                    });
                }

                // Dev-friendly way to build the cart
                document.addEventListener("cart:build", () => {
                    this.buildCart();
                });
            },

            reInit() {
                this.initQtySelectors();
            },

            onSubmit(evt) {
                this.submitBtn.classList.add(classes.btnLoading);

                if (config.requiresTerms) {
                    if (this.termsCheckbox.checked) {
                        // continue to checkout
                    } else {
                        alert(theme.strings.cartTermsConfirmation);
                        this.submitBtn.classList.remove(classes.btnLoading);
                        evt.preventDefault();
                        return false;
                    }
                }
            },

            /*= ===========================================================================
        Query cart page to get markup
      ============================================================================== */
            _parseProductHTML(html) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");
                return {
                    items: doc.querySelector(".cart__items"),
                    discounts: doc.querySelector(".cart__discounts"),
                };
            },

            buildCart() {
                theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
            },

            cartMarkup(html) {
                const markup = this._parseProductHTML(html);
                const { items } = markup;
                const count = parseInt(items.dataset.count);
                const subtotal = items.dataset.cartSubtotal;
                const savings = items.dataset.cartSavings;

                this.updateCartDiscounts(markup.discounts);
                this.updateSavings(savings);

                if (count > 0) {
                    this.wrapper.classList.remove("is-empty");
                } else {
                    this.wrapper.classList.add("is-empty");
                }

                this.updateCount(count);

                // Append item markup
                this.products.innerHTML = "";
                this.products.append(items);

                // Update subtotal
                this.subtotal.innerHTML = theme.Currency.formatMoney(
                    subtotal,
                    theme.settings.moneyFormat
                );

                this.reInit();

                if (window.AOS) {
                    AOS.refreshHard();
                }

                if (Shopify && Shopify.StorefrontExpressButtons) {
                    Shopify.StorefrontExpressButtons.initialize();
                }
            },

            updateCartDiscounts(markup) {
                if (!this.discounts) {
                    return;
                }
                this.discounts.innerHTML = "";
                this.discounts.append(markup);
            },

            /*= ===========================================================================
        Quantity handling
      ============================================================================== */
            initQtySelectors() {
                this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
                    const selector = new theme.QtySelector(el, {
                        namespace: this.namespace,
                        isCart: true,
                    });
                });
            },

            quantityChanged(evt) {
                const key = evt.detail[0];
                const qty = evt.detail[1];
                const el = evt.detail[2];

                if (!key || !qty) {
                    return;
                }

                // Disable qty selector so multiple clicks can't happen while loading
                if (el) {
                    el.classList.add("is-loading");
                }

                theme.cart
                    .changeItem(key, qty)
                    .then(cart => {
                        if (cart.item_count > 0) {
                            this.wrapper.classList.remove("is-empty");
                        } else {
                            this.wrapper.classList.add("is-empty");
                        }

                        this.buildCart();

                        document.dispatchEvent(
                            new CustomEvent("cart:updated", {
                                detail: {
                                    cart,
                                },
                            })
                        );
                    })
                    .catch(XMLHttpRequest => {});
            },

            /*= ===========================================================================
        Update elements of the cart
      ============================================================================== */
            updateSubtotal(subtotal) {
                this.form.querySelector(selectors.subTotal).innerHTML =
                    theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
            },

            updateSavings(savings) {
                if (!this.savings) {
                    return;
                }

                if (savings > 0) {
                    const amount = theme.Currency.formatMoney(
                        savings,
                        theme.settings.moneyFormat
                    );
                    this.savings.classList.remove("hide");
                    this.savings.innerHTML = theme.strings.cartSavings.replace(
                        "[savings]",
                        amount
                    );
                } else {
                    this.savings.classList.add("hide");
                }
            },

            updateCount(count) {
                const countEls = document.querySelectorAll(".cart-link__bubble-num");

                if (countEls.length) {
                    countEls.forEach(el => {
                        el.innerText = count;
                    });
                }

                // show/hide bubble(s)
                const bubbles = document.querySelectorAll(selectors.cartBubble);
                if (bubbles.length) {
                    if (count > 0) {
                        bubbles.forEach(b => {
                            b.classList.add("cart-link__bubble--visible");
                        });
                    } else {
                        bubbles.forEach(b => {
                            b.classList.remove("cart-link__bubble--visible");
                        });
                    }
                }
            },
        };

        return CartForm;
    })();

    // Either collapsible containers all acting individually,
    // or tabs that can only have one open at a time
    theme.collapsibles = (function () {
        const selectors = {
            trigger: ".collapsible-trigger",
            module: ".collapsible-content",
            moduleInner: ".collapsible-content__inner",
            tabs: ".collapsible-trigger--tab",
        };

        const classes = {
            hide: "hide",
            open: "is-open",
            autoHeight: "collapsible--auto-height",
            tabs: "collapsible-trigger--tab",
        };

        const namespace = ".collapsible";

        let isTransitioning = false;

        function init(scope) {
            const el = scope || document;
            el.querySelectorAll(selectors.trigger).forEach(trigger => {
                const state = trigger.classList.contains(classes.open);
                trigger.setAttribute("aria-expanded", state);

                trigger.off(`click${namespace}`);
                trigger.on(`click${namespace}`, toggle);
            });
        }

        function toggle(evt) {
            if (isTransitioning) {
                return;
            }

            isTransitioning = true;

            const el = evt.currentTarget;
            const isOpen = el.classList.contains(classes.open);
            const isTab = el.classList.contains(classes.tabs);
            let moduleId = el.getAttribute("aria-controls");
            let container = document.getElementById(moduleId);

            if (!moduleId) {
                moduleId = el.dataset.controls;
            }

            // No ID, bail
            if (!moduleId) {
                return;
            }

            // If container=null, there isn't a matching ID.
            // Check if data-id is set instead. Could be multiple.
            // Select based on being in the same parent div.
            if (!container) {
                const multipleMatches = document.querySelectorAll(
                    `[data-id="${moduleId}"]`
                );
                if (multipleMatches.length > 0) {
                    container = el.parentNode.querySelector(
                        `[data-id="${moduleId}"]`
                    );
                }
            }

            if (!container) {
                isTransitioning = false;
                return;
            }

            let height = container.querySelector(selectors.moduleInner).offsetHeight;
            const isAutoHeight = container.classList.contains(classes.autoHeight);
            const parentCollapsibleEl = container.parentNode.closest(
                selectors.module
            );
            const childHeight = height;

            if (isTab) {
                if (isOpen) {
                    isTransitioning = false;
                    return;
                }

                let newModule;
                document
                    .querySelectorAll(
                        `${selectors.tabs}[data-id="${el.dataset.id}"]`
                    )
                    .forEach(el => {
                        el.classList.remove(classes.open);
                        newModule = document.querySelector(
                            `#${el.getAttribute("aria-controls")}`
                        );
                        setTransitionHeight(newModule, 0, true);
                    });
            }

            // If isAutoHeight, set the height to 0 just after setting the actual height
            // so the closing animation works nicely
            if (isOpen && isAutoHeight) {
                setTimeout(() => {
                    height = 0;
                    setTransitionHeight(container, height, isOpen, isAutoHeight);
                }, 0);
            }

            if (isOpen && !isAutoHeight) {
                height = 0;
            }

            el.setAttribute("aria-expanded", !isOpen);
            if (isOpen) {
                el.classList.remove(classes.open);
            } else {
                el.classList.add(classes.open);
            }

            setTransitionHeight(container, height, isOpen, isAutoHeight);

            // If we are in a nested collapsible element like the mobile nav,
            // also set the parent element's height
            if (parentCollapsibleEl) {
                const totalHeight = isOpen
                    ? parentCollapsibleEl.offsetHeight - childHeight
                    : height + parentCollapsibleEl.offsetHeight;

                setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
            }

            // If Shopify Product Reviews app installed,
            // resize container on 'Write review' click
            // that shows form
            if (window.SPR) {
                const btn = container.querySelector(
                    ".spr-summary-actions-newreview"
                );
                if (!btn) {
                    return;
                }
                btn.off(`click${namespace}`);
                btn.on(`click${namespace}`, () => {
                    height = container.querySelector(
                        selectors.moduleInner
                    ).offsetHeight;
                    setTransitionHeight(container, height, isOpen, isAutoHeight);
                });
            }
        }

        function setTransitionHeight(container, height, isOpen, isAutoHeight) {
            container.classList.remove(classes.hide);
            theme.utils.prepareTransition(container, () => {
                container.style.height = `${height}px`;
                if (isOpen) {
                    container.classList.remove(classes.open);
                } else {
                    container.classList.add(classes.open);
                }
            });

            if (!isOpen && isAutoHeight) {
                const o = container;
                window.setTimeout(() => {
                    o.css("height", "auto");
                    isTransitioning = false;
                }, 500);
            } else {
                isTransitioning = false;
            }
        }

        return {
            init,
        };
    })();

    // Shopify-built select-like popovers for currency and language selection
    theme.Disclosure = (function () {
        const selectors = {
            disclosureForm: "[data-disclosure-form]",
            disclosureList: "[data-disclosure-list]",
            disclosureToggle: "[data-disclosure-toggle]",
            disclosureInput: "[data-disclosure-input]",
            disclosureOptions: "[data-disclosure-option]",
        };

        const classes = {
            listVisible: "disclosure-list--visible",
        };

        function Disclosure(disclosure) {
            this.container = disclosure;
            this._cacheSelectors();
            this._setupListeners();
        }

        Disclosure.prototype = {
            ...Disclosure.prototype,
            _cacheSelectors() {
                this.cache = {
                    disclosureForm: this.container.closest(selectors.disclosureForm),
                    disclosureList: this.container.querySelector(
                        selectors.disclosureList
                    ),
                    disclosureToggle: this.container.querySelector(
                        selectors.disclosureToggle
                    ),
                    disclosureInput: this.container.querySelector(
                        selectors.disclosureInput
                    ),
                    disclosureOptions: this.container.querySelectorAll(
                        selectors.disclosureOptions
                    ),
                };
            },

            _setupListeners() {
                this.eventHandlers = this._setupEventHandlers();

                this.cache.disclosureToggle.addEventListener(
                    "click",
                    this.eventHandlers.toggleList
                );

                this.cache.disclosureOptions.forEach(function (disclosureOption) {
                    disclosureOption.addEventListener(
                        "click",
                        this.eventHandlers.connectOptions
                    );
                }, this);

                this.container.addEventListener(
                    "keyup",
                    this.eventHandlers.onDisclosureKeyUp
                );

                this.cache.disclosureList.addEventListener(
                    "focusout",
                    this.eventHandlers.onDisclosureListFocusOut
                );

                this.cache.disclosureToggle.addEventListener(
                    "focusout",
                    this.eventHandlers.onDisclosureToggleFocusOut
                );

                document.body.addEventListener(
                    "click",
                    this.eventHandlers.onBodyClick
                );
            },

            _setupEventHandlers() {
                return {
                    connectOptions: this._connectOptions.bind(this),
                    toggleList: this._toggleList.bind(this),
                    onBodyClick: this._onBodyClick.bind(this),
                    onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
                    onDisclosureListFocusOut:
                        this._onDisclosureListFocusOut.bind(this),
                    onDisclosureToggleFocusOut:
                        this._onDisclosureToggleFocusOut.bind(this),
                };
            },

            _connectOptions(event) {
                event.preventDefault();

                this._submitForm(event.currentTarget.dataset.value);
            },

            _onDisclosureToggleFocusOut(event) {
                const disclosureLostFocus =
                    this.container.contains(event.relatedTarget) === false;

                if (disclosureLostFocus) {
                    this._hideList();
                }
            },

            _onDisclosureListFocusOut(event) {
                const childInFocus = event.currentTarget.contains(
                    event.relatedTarget
                );

                const isVisible = this.cache.disclosureList.classList.contains(
                    classes.listVisible
                );

                if (isVisible && !childInFocus) {
                    this._hideList();
                }
            },

            _onDisclosureKeyUp(event) {
                if (event.which !== 27) return;
                this._hideList();
                this.cache.disclosureToggle.focus();
            },

            _onBodyClick(event) {
                const isOption = this.container.contains(event.target);
                const isVisible = this.cache.disclosureList.classList.contains(
                    classes.listVisible
                );

                if (isVisible && !isOption) {
                    this._hideList();
                }
            },

            _submitForm(value) {
                this.cache.disclosureInput.value = value;
                this.cache.disclosureForm.submit();
            },

            _hideList() {
                this.cache.disclosureList.classList.remove(classes.listVisible);
                this.cache.disclosureToggle.setAttribute("aria-expanded", false);
            },

            _toggleList() {
                const ariaExpanded =
                    this.cache.disclosureToggle.getAttribute("aria-expanded") ===
                    "true";
                this.cache.disclosureList.classList.toggle(classes.listVisible);
                this.cache.disclosureToggle.setAttribute(
                    "aria-expanded",
                    !ariaExpanded
                );
            },

            destroy() {
                this.cache.disclosureToggle.removeEventListener(
                    "click",
                    this.eventHandlers.toggleList
                );

                this.cache.disclosureOptions.forEach(function (disclosureOption) {
                    disclosureOption.removeEventListener(
                        "click",
                        this.eventHandlers.connectOptions
                    );
                }, this);

                this.container.removeEventListener(
                    "keyup",
                    this.eventHandlers.onDisclosureKeyUp
                );

                this.cache.disclosureList.removeEventListener(
                    "focusout",
                    this.eventHandlers.onDisclosureListFocusOut
                );

                this.cache.disclosureToggle.removeEventListener(
                    "focusout",
                    this.eventHandlers.onDisclosureToggleFocusOut
                );

                document.body.removeEventListener(
                    "click",
                    this.eventHandlers.onBodyClick
                );
            },
        };

        return Disclosure;
    })();

    theme.Modals = (function () {
        function Modal(id, name, options) {
            const defaults = {
                close: ".js-modal-close",
                open: `.js-modal-open-${name}`,
                openClass: "modal--is-active",
                closingClass: "modal--is-closing",
                bodyOpenClass: ["modal-open"],
                bodyOpenSolidClass: "modal-open--solid",
                bodyClosingClass: "modal-closing",
                closeOffContentClick: true,
            };

            this.id = id;
            this.modal = document.getElementById(id);

            if (!this.modal) {
                return false;
            }

            this.modalContent = this.modal.querySelector(".modal__inner");

            this.config = Object.assign(defaults, options);
            this.modalIsOpen = false;
            this.focusOnOpen = this.config.focusIdOnOpen
                ? document.getElementById(this.config.focusIdOnOpen)
                : this.modal;
            this.isSolid = this.config.solid;

            this.init();
        }

        Modal.prototype.init = function () {
            document.querySelectorAll(this.config.open).forEach(btn => {
                btn.setAttribute("aria-expanded", "false");
                btn.addEventListener("click", this.open.bind(this));
            });

            this.modal.querySelectorAll(this.config.close).forEach(btn => {
                btn.addEventListener("click", this.close.bind(this));
            });

            // Close modal if a drawer is opened
            document.addEventListener("drawerOpen", () => {
                this.close();
            });
        };

        Modal.prototype.open = function (evt) {
            // Keep track if modal was opened from a click, or called by another function
            let externalCall = false;

            // don't open an opened modal
            if (this.modalIsOpen) {
                return;
            }

            // Prevent following href if link is clicked
            if (evt) {
                evt.preventDefault();
            } else {
                externalCall = true;
            }

            // Without this, the modal opens, the click event bubbles up to $nodes.page
            // which closes the modal.
            if (evt && evt.stopPropagation) {
                evt.stopPropagation();
                // save the source of the click, we'll focus to this on close
                this.activeSource = evt.currentTarget.setAttribute(
                    "aria-expanded",
                    "true"
                );
            }

            if (this.modalIsOpen && !externalCall) {
                this.close();
            }

            this.modal.classList.add(this.config.openClass);

            document.documentElement.classList.add(...this.config.bodyOpenClass);

            if (this.isSolid) {
                document.documentElement.classList.add(
                    this.config.bodyOpenSolidClass
                );
            }

            this.modalIsOpen = true;

            theme.a11y.trapFocus({
                container: this.modal,
                elementToFocus: this.focusOnOpen,
                namespace: "modal_focus",
            });

            document.dispatchEvent(new CustomEvent("modalOpen"));
            document.dispatchEvent(new CustomEvent(`modalOpen.${this.id}`));

            this.bindEvents();
        };

        Modal.prototype.close = function (evt) {
            // don't close a closed modal
            if (!this.modalIsOpen) {
                return;
            }

            // Do not close modal if click happens inside modal content
            if (evt) {
                if (evt.target.closest(".js-modal-close")) {
                    // Do not close if using the modal close button
                } else if (evt.target.closest(".modal__inner")) {
                    return;
                }
            }

            // deselect any focused form elements
            document.activeElement.blur();

            this.modal.classList.remove(this.config.openClass);
            this.modal.classList.add(this.config.closingClass);

            document.documentElement.classList.remove(...this.config.bodyOpenClass);
            document.documentElement.classList.add(this.config.bodyClosingClass);

            window.setTimeout(() => {
                document.documentElement.classList.remove(
                    this.config.bodyClosingClass
                );
                this.modal.classList.remove(this.config.closingClass);
                if (
                    this.activeSource &&
                    this.activeSource.getAttribute("aria-expanded")
                ) {
                    this.activeSource.setAttribute("aria-expanded", "false").focus();
                }
            }, 500); // modal close css transition

            if (this.isSolid) {
                document.documentElement.classList.remove(
                    this.config.bodyOpenSolidClass
                );
            }

            this.modalIsOpen = false;

            theme.a11y.removeTrapFocus({
                container: this.modal,
                namespace: "modal_focus",
            });

            document.dispatchEvent(new CustomEvent(`modalClose.${this.id}`));

            this.unbindEvents();
        };

        Modal.prototype.bindEvents = function () {
            window.on("keyup.modal", evt => {
                if (evt.keyCode === 27) {
                    this.close();
                }
            });

            if (this.config.closeOffContentClick) {
                // Clicking outside of the modal content also closes it
                this.modal.on("click.modal", this.close.bind(this));
            }
        };

        Modal.prototype.unbindEvents = function () {
            document.documentElement.off(".modal");

            if (this.config.closeOffContentClick) {
                this.modal.off(".modal");
            }
        };

        return Modal;
    })();

    window.onpageshow = function (evt) {
        // Removes unload class when returning to page via history
        if (evt.persisted) {
            document.body.classList.remove("unloading");
            document.querySelectorAll(".cart__checkout").forEach(el => {
                el.classList.remove("btn--loading");
            });
        }
    };

    // Used in Motion and Expanse to fade between pages.
    // initialize in theme.js with theme.pageTransitions();
    theme.pageTransitions = function () {
        if (document.body.dataset.transitions === "true") {
            // Hack test to fix Safari page cache issue.
            // window.onpageshow doesn't always run when navigating
            // back to the page, so the unloading class remains, leaving
            // a white page. Setting a timeout to remove that class when leaving
            // the page actually finishes running when they come back.
            if (navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
                document.querySelectorAll("a").forEach(a => {
                    window.setTimeout(() => {
                        document.body.classList.remove("unloading");
                    }, 1200);
                });
            }

            // Disable the page transition feature on some links
            // by adding class `js-no-transition`
            document
                .querySelectorAll(
                    'a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"], a[download]'
                )
                .forEach(el => {
                    el.classList.add("js-no-transition");
                });

            // Add class `unloading` to body for page transition on all
            // anchor tags, unless they have `js-no-transition` class
            document.querySelectorAll("a:not(.js-no-transition)").forEach(el => {
                el.addEventListener("click", evt => {
                    if (evt.metaKey) return true;
                    evt.preventDefault();
                    document.body.classList.add("unloading");
                    const src = el.getAttribute("href");
                    window.setTimeout(() => {
                        location.href = src;
                    }, 50);
                });
            });

            // Close the mobile nav drawer after clicking on a nav link
            document.querySelectorAll("a.mobile-nav__link").forEach(el => {
                el.addEventListener("click", () => {
                    theme.NavDrawer.close();
                });
            });
        }
    };

    theme.parallaxSections = {};

    theme.Parallax = (function () {
        const speed = 0.85;
        let reset = false;

        function parallax(container, args) {
            this.isInit = false;
            this.isVisible = false;
            this.container = container;
            this.image = container.querySelector(".parallax-image");
            this.namespace = args.namespace;
            this.desktopOnly = args.desktopOnly;

            if (!this.container || !this.image) {
                return;
            }

            // If set for desktop only, setup listeners for disabling
            // on mobile and re-enabling on desktop
            if (this.desktopOnly) {
                document.addEventListener("matchSmall", () => {
                    this.destroy();
                });

                document.addEventListener("unmatchSmall", () => {
                    this.init(true);
                });
            }

            this.init(this.desktopOnly);
        }

        parallax.prototype = {
            ...parallax.prototype,
            init(desktopOnly) {
                // Reset in case initialized again
                if (this.isInit) {
                    this.destroy();
                }

                this.isInit = true;

                // Do not setup scroll event if on mobile
                if (desktopOnly && theme.config.bpSmall) {
                    return;
                }

                // Set position on page load
                this.setSizes();
                this.scrollHandler();

                const observer = new IntersectionObserver(
                    (entries, observer) => {
                        entries.forEach(entry => {
                            this.isVisible = entry.isIntersecting;
                            if (this.isVisible) {
                                window.on(
                                    `scroll${this.namespace}`,
                                    this.onScroll.bind(this)
                                );
                            } else {
                                window.off(`scroll${this.namespace}`);
                            }
                        });
                    },
                    { rootMargin: "200px 0px 200px 0px" }
                );

                observer.observe(this.container);

                window.on(
                    `resize${this.namespace}`,
                    theme.utils.debounce(250, this.setSizes.bind(this))
                );

                document.addEventListener(
                    "shopify:section:reorder",
                    theme.utils.debounce(250, this.onReorder.bind(this))
                );
            },

            onScroll() {
                if (!this.isVisible) {
                    return;
                }

                // If a scroll event finds Shopify's review app,
                // update parallax scroll positions because of page reflows
                if (window.SPR && !reset) {
                    this.setSizes();
                    reset = true;
                }

                requestAnimationFrame(this.scrollHandler.bind(this));
            },

            scrollHandler() {
                const shiftDistance = (window.scrollY - this.elTop) * speed;
                this.image.style.transform = `translate3d(0, ${shiftDistance}px, 0)`;
            },

            setSizes() {
                const rect = this.container.getBoundingClientRect();
                this.elTop = rect.top + window.scrollY;
            },

            onReorder() {
                this.setSizes();
                this.onScroll();
            },

            destroy() {
                this.image.style.transform = "none";
                window.off(`scroll${this.namespace}`);
                window.off(`resize${this.namespace}`);
            },
        };

        return parallax;
    })();

    if (typeof window.noUiSlider === "undefined") {
        throw new Error(
            "theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js"
        );
    }

    theme.PriceRange = (function () {
        const defaultStep = 10;
        const selectors = {
            priceRange: ".price-range",
            priceRangeSlider: ".price-range__slider",
            priceRangeInputMin: ".price-range__input-min",
            priceRangeInputMax: ".price-range__input-max",
            priceRangeDisplayMin: ".price-range__display-min",
            priceRangeDisplayMax: ".price-range__display-max",
        };

        function PriceRange(
            container,
            { onChange, onUpdate, ...sliderOptions } = {}
        ) {
            this.container = container;
            this.onChange = onChange;
            this.onUpdate = onUpdate;
            this.sliderOptions = sliderOptions || {};

            return this.init();
        }

        PriceRange.prototype = {
            ...PriceRange.prototype,
            init() {
                if (!this.container.classList.contains("price-range")) {
                    throw new Error(
                        "You must instantiate PriceRange with a valid container"
                    );
                }

                this.formEl = this.container.closest("form");
                this.sliderEl = this.container.querySelector(
                    selectors.priceRangeSlider
                );
                this.inputMinEl = this.container.querySelector(
                    selectors.priceRangeInputMin
                );
                this.inputMaxEl = this.container.querySelector(
                    selectors.priceRangeInputMax
                );
                this.displayMinEl = this.container.querySelector(
                    selectors.priceRangeDisplayMin
                );
                this.displayMaxEl = this.container.querySelector(
                    selectors.priceRangeDisplayMax
                );

                this.minRange = parseFloat(this.container.dataset.min) || 0;
                this.minValue = parseFloat(this.container.dataset.minValue) || 0;
                this.maxRange = parseFloat(this.container.dataset.max) || 100;
                this.maxValue =
                    parseFloat(this.container.dataset.maxValue) || this.maxRange;

                return this.createPriceRange();
            },

            createPriceRange() {
                if (
                    this.sliderEl &&
                    this.sliderEl.noUiSlider &&
                    typeof this.sliderEl.noUiSlider.destroy === "function"
                ) {
                    this.sliderEl.noUiSlider.destroy();
                }

                const slider = noUiSlider.create(this.sliderEl, {
                    connect: true,
                    step: defaultStep,
                    ...this.sliderOptions,
                    // Do not allow overriding these options
                    start: [this.minValue, this.maxValue],
                    range: {
                        min: this.minRange,
                        max: this.maxRange,
                    },
                });

                slider.on("update", values => {
                    this.displayMinEl.innerHTML = theme.Currency.formatMoney(
                        values[0],
                        theme.settings.moneyFormat
                    );
                    this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
                        values[1],
                        theme.settings.moneyFormat
                    );

                    if (this.onUpdate) {
                        this.onUpdate(values);
                    }
                });

                slider.on("change", values => {
                    this.inputMinEl.value = values[0];
                    this.inputMaxEl.value = values[1];

                    if (this.onChange) {
                        const formData = new FormData(this.formEl);
                        this.onChange(formData);
                    }
                });

                return slider;
            },
        };

        return PriceRange;
    })();

    theme.AjaxProduct = (function () {
        const status = {
            loading: false,
        };

        function ProductForm(form, submit, args) {
            this.form = form;
            this.args = args;

            const submitSelector = submit || ".add-to-cart";

            if (this.form) {
                this.addToCart = form.querySelector(submitSelector);
                this.form.addEventListener(
                    "submit",
                    this.addItemFromForm.bind(this)
                );
            }
        }

        ProductForm.prototype = {
            ...ProductForm.prototype,
            addItemFromForm(evt, callback) {
                evt.preventDefault();

                if (status.loading) {
                    return;
                }

                // Loading indicator on add to cart button
                this.addToCart.classList.add("btn--loading");

                status.loading = true;

                const data = theme.utils.serialize(this.form);

                fetch(theme.routes.cartAdd, {
                    method: "POST",
                    body: data,
                    credentials: "same-origin",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "X-Requested-With": "XMLHttpRequest",
                    },
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.status === 422) {
                            this.error(data);
                        } else {
                            const product = data;
                            this.success(product);
                        }

                        status.loading = false;
                        this.addToCart.classList.remove("btn--loading");

                        // Reload page if adding product from a section on the cart page
                        if (document.body.classList.contains("template-cart")) {
                            window.scrollTo(0, 0);
                            location.reload();
                        }
                    });
            },

            success(product) {
                const errors = this.form.querySelector(".errors");
                if (errors) {
                    errors.remove();
                }

                document.dispatchEvent(
                    new CustomEvent("ajaxProduct:added", {
                        detail: {
                            product,
                            addToCartBtn: this.addToCart,
                        },
                    })
                );

                if (this.args && this.args.scopedEventId) {
                    document.dispatchEvent(
                        new CustomEvent(
                            `ajaxProduct:added:${this.args.scopedEventId}`,
                            {
                                detail: {
                                    product,
                                    addToCartBtn: this.addToCart,
                                },
                            }
                        )
                    );
                }
            },

            error(error) {
                if (!error.description) {
                    console.warn(error);
                    return;
                }

                const errors = this.form.querySelector(".errors");
                if (errors) {
                    errors.remove();
                }

                const errorDiv = document.createElement("div");
                errorDiv.classList.add("errors", "text-center");
                errorDiv.textContent = error.description;
                this.form.append(errorDiv);

                document.dispatchEvent(
                    new CustomEvent("ajaxProduct:error", {
                        detail: {
                            errorMessage: error.description,
                        },
                    })
                );

                if (this.args && this.args.scopedEventId) {
                    document.dispatchEvent(
                        new CustomEvent(
                            `ajaxProduct:error:${this.args.scopedEventId}`,
                            {
                                detail: {
                                    errorMessage: error.description,
                                },
                            }
                        )
                    );
                }
            },
        };

        return ProductForm;
    })();

    theme.ProductMedia = (function () {
        const modelJsonSections = {};
        const models = {};
        const xrButtons = {};

        const selectors = {
            mediaGroup: "[data-product-single-media-group]",
            xrButton: "[data-shopify-xr]",
        };

        function init(modelViewerContainers, sectionId) {
            modelJsonSections[sectionId] = {
                loaded: false,
            };

            modelViewerContainers.forEach((container, index) => {
                const { mediaId } = container.dataset;
                const modelViewerElement = container.querySelector("model-viewer");
                const { modelId } = modelViewerElement.dataset;

                if (index === 0) {
                    const mediaGroup = container.closest(selectors.mediaGroup);
                    const xrButton = mediaGroup.querySelector(selectors.xrButton);
                    xrButtons[sectionId] = {
                        element: xrButton,
                        defaultId: modelId,
                    };
                }

                models[mediaId] = {
                    modelId,
                    sectionId,
                    container,
                    element: modelViewerElement,
                };
            });

            window.Shopify.loadFeatures([
                {
                    name: "shopify-xr",
                    version: "1.0",
                    onLoad: setupShopifyXr,
                },
                {
                    name: "model-viewer-ui",
                    version: "1.0",
                    onLoad: setupModelViewerUi,
                },
            ]);

            theme.LibraryLoader.load("modelViewerUiStyles");
        }

        function setupShopifyXr(errors) {
            if (errors) return;

            if (!window.ShopifyXR) {
                document.addEventListener("shopify_xr_initialized", () => {
                    setupShopifyXr();
                });
                return;
            }

            for (const sectionId in modelJsonSections) {
                if (modelJsonSections.hasOwnProperty(sectionId)) {
                    const modelSection = modelJsonSections[sectionId];

                    if (modelSection.loaded) continue;

                    const modelJson = document.querySelector(
                        `#ModelJson-${sectionId}`
                    );

                    window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
                    modelSection.loaded = true;
                }
            }
            window.ShopifyXR.setupXRElements();
        }

        function setupModelViewerUi(errors) {
            if (errors) return;

            for (const key in models) {
                if (models.hasOwnProperty(key)) {
                    const model = models[key];
                    if (!model.modelViewerUi && Shopify) {
                        model.modelViewerUi = new Shopify.ModelViewerUI(
                            model.element
                        );
                    }
                    setupModelViewerListeners(model);
                }
            }
        }

        function setupModelViewerListeners(model) {
            const xrButton = xrButtons[model.sectionId];

            model.container.addEventListener("mediaVisible", () => {
                xrButton.element.setAttribute(
                    "data-shopify-model3d-id",
                    model.modelId
                );
                if (theme.config.isTouch) return;
                model.modelViewerUi.play();
            });

            model.container.addEventListener("mediaHidden", () => {
                xrButton.element.setAttribute(
                    "data-shopify-model3d-id",
                    xrButton.defaultId
                );
                model.modelViewerUi.pause();
            });

            model.container.addEventListener("xrLaunch", () => {
                model.modelViewerUi.pause();
            });
        }

        function removeSectionModels(sectionId) {
            for (const key in models) {
                if (models.hasOwnProperty(key)) {
                    const model = models[key];
                    if (model.sectionId === sectionId) {
                        delete models[key];
                    }
                }
            }
            delete modelJsonSections[sectionId];
        }

        return {
            init,
            removeSectionModels,
        };
    })();

    theme.QtySelector = (function () {
        const selectors = {
            input: ".js-qty__num",
            plus: ".js-qty__adjust--plus",
            minus: ".js-qty__adjust--minus",
        };

        function QtySelector(el, options) {
            this.wrapper = el;
            this.plus = el.querySelector(selectors.plus);
            this.minus = el.querySelector(selectors.minus);
            this.input = el.querySelector(selectors.input);
            this.minValue = this.input.getAttribute("min") || 1;

            const defaults = {
                namespace: null,
                isCart: false,
                key: this.input.dataset.id,
            };

            this.options = { ...defaults, ...options };

            this.init();
        }

        QtySelector.prototype = {
            ...QtySelector.prototype,
            init() {
                this.plus.addEventListener("click", () => {
                    const qty = this._getQty();
                    this._change(qty + 1);
                });

                this.minus.addEventListener("click", () => {
                    const qty = this._getQty();
                    this._change(qty - 1);
                });

                this.input.addEventListener("change", evt => {
                    this._change(this._getQty());
                });
            },

            _getQty() {
                let qty = this.input.value;
                if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
                    // We have a valid number!
                } else {
                    // Not a number. Default to 1.
                    qty = 1;
                }
                return parseInt(qty);
            },

            _change(qty) {
                if (qty <= this.minValue) {
                    qty = this.minValue;
                }

                this.input.value = qty;

                if (this.options.isCart) {
                    document.dispatchEvent(
                        new CustomEvent(`cart:quantity${this.options.namespace}`, {
                            detail: [this.options.key, qty, this.wrapper],
                        })
                    );
                }
            },
        };

        return QtySelector;
    })();

    // theme.Slideshow handles all flickity based sliders
    // Child navigation is only setup to work on product images
    theme.Slideshow = (function () {
        const classes = {
            animateOut: "animate-out",
            isPaused: "is-paused",
            isActive: "is-active",
        };

        const selectors = {
            allSlides: ".slideshow__slide",
            currentSlide: ".is-selected",
            wrapper: ".slideshow-wrapper",
            pauseButton: ".slideshow__pause",
        };

        const productSelectors = {
            thumb: ".product__thumb-item:not(.hide)",
            links: ".product__thumb-item:not(.hide) a",
            arrow: ".product__thumb-arrow",
        };

        const defaults = {
            adaptiveHeight: false,
            autoPlay: false,
            avoidReflow: false, // custom by Archetype
            childNav: null, // element. Custom by Archetype instead of asNavFor
            childNavScroller: null, // element
            childVertical: false,
            dragThreshold: 7,
            fade: false,
            friction: 0.8,
            initialIndex: 0,
            pageDots: false,
            pauseAutoPlayOnHover: false,
            prevNextButtons: false,
            rightToLeft: theme.config.rtl,
            selectedAttraction: 0.14,
            setGallerySize: true,
            wrapAround: true,
        };

        function slideshow(el, args) {
            this.el = el;
            this.args = { ...defaults, ...args };

            // Setup listeners as part of arguments
            this.args.on = {
                ready: this.init.bind(this),
                change: this.slideChange.bind(this),
                settle: this.afterChange.bind(this),
            };

            if (this.args.childNav) {
                this.childNavEls = this.args.childNav.querySelectorAll(
                    productSelectors.thumb
                );
                this.childNavLinks = this.args.childNav.querySelectorAll(
                    productSelectors.links
                );
                this.arrows = this.args.childNav.querySelectorAll(
                    productSelectors.arrow
                );
                if (this.childNavLinks.length) {
                    this.initChildNav();
                }
            }

            if (this.args.avoidReflow) {
                avoidReflow(el);
            }

            this.slideshow = new Flickity(el, this.args);

            if (this.args.autoPlay) {
                const wrapper = el.closest(selectors.wrapper);
                this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
                if (this.pauseBtn) {
                    this.pauseBtn.addEventListener(
                        "click",
                        this._togglePause.bind(this)
                    );
                }
            }

            // Reset dimensions on resize
            window.on(
                "resize",
                theme.utils.debounce(300, () => {
                    this.resize();
                })
            );

            // Set flickity-viewport height to first element to
            // avoid awkward page reflows while initializing.
            // Must be added in a `style` tag because element does not exist yet.
            // Slideshow element must have an ID
            function avoidReflow(el) {
                if (!el.id) return;
                let { firstChild } = el;
                while (firstChild != null && firstChild.nodeType == 3) {
                    // skip TextNodes
                    firstChild = firstChild.nextSibling;
                }
                const style = document.createElement("style");
                style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
                document.head.appendChild(style);
            }
        }

        slideshow.prototype = {
            ...slideshow.prototype,
            init(el) {
                this.currentSlide = this.el.querySelector(selectors.currentSlide);

                // Optional onInit callback
                if (this.args.callbacks && this.args.callbacks.onInit) {
                    if (typeof this.args.callbacks.onInit === "function") {
                        this.args.callbacks.onInit(this.currentSlide);
                    }
                }

                if (window.AOS) {
                    AOS.refresh();
                }
            },

            slideChange(index) {
                // Outgoing fade styles
                if (this.args.fade && this.currentSlide) {
                    this.currentSlide.classList.add(classes.animateOut);
                    this.currentSlide.addEventListener("transitionend", () => {
                        this.currentSlide.classList.remove(classes.animateOut);
                    });
                }

                // Match index with child nav
                if (this.args.childNav) {
                    this.childNavGoTo(index);
                }

                // Optional onChange callback
                if (this.args.callbacks && this.args.callbacks.onChange) {
                    if (typeof this.args.callbacks.onChange === "function") {
                        this.args.callbacks.onChange(index);
                    }
                }

                // Show/hide arrows depending on selected index
                if (this.arrows && this.arrows.length) {
                    this.arrows[0].classList.toggle("hide", index === 0);
                    this.arrows[1].classList.toggle(
                        "hide",
                        index === this.childNavLinks.length - 1
                    );
                }
            },
            afterChange(index) {
                // Remove all fade animation classes after slide is done
                if (this.args.fade) {
                    this.el.querySelectorAll(selectors.allSlides).forEach(slide => {
                        slide.classList.remove(classes.animateOut);
                    });
                }

                this.currentSlide = this.el.querySelector(selectors.currentSlide);

                // Match index with child nav (in case slider height changed first)
                if (this.args.childNav) {
                    this.childNavGoTo(this.slideshow.selectedIndex);
                }
            },
            destroy() {
                if (this.args.childNav && this.childNavLinks.length) {
                    this.childNavLinks.forEach(a => {
                        a.classList.remove(classes.isActive);
                    });
                }
                this.slideshow.destroy();
            },
            reposition() {
                this.slideshow.reposition();
            },
            _togglePause() {
                if (this.pauseBtn.classList.contains(classes.isPaused)) {
                    this.pauseBtn.classList.remove(classes.isPaused);
                    this.slideshow.playPlayer();
                } else {
                    this.pauseBtn.classList.add(classes.isPaused);
                    this.slideshow.pausePlayer();
                }
            },
            resize() {
                this.slideshow.resize();
            },
            play() {
                this.slideshow.playPlayer();
            },
            pause() {
                this.slideshow.pausePlayer();
            },
            goToSlide(i) {
                this.slideshow.select(i);
            },
            setDraggable(enable) {
                this.slideshow.options.draggable = enable;
                this.slideshow.updateDraggable();
            },

            initChildNav() {
                this.childNavLinks[this.args.initialIndex].classList.add(
                    "is-active"
                );

                // Setup events
                this.childNavLinks.forEach((link, i) => {
                    // update data-index because image-set feature may be enabled
                    link.setAttribute("data-index", i);

                    link.addEventListener("click", evt => {
                        evt.preventDefault();
                        this.goToSlide(this.getChildIndex(evt.currentTarget));
                    });
                    link.addEventListener("focus", evt => {
                        this.goToSlide(this.getChildIndex(evt.currentTarget));
                    });
                    link.addEventListener("keydown", evt => {
                        if (evt.keyCode === 13) {
                            this.goToSlide(this.getChildIndex(evt.currentTarget));
                        }
                    });
                });

                // Setup optional arrows
                if (this.arrows.length) {
                    this.arrows.forEach(arrow => {
                        arrow.addEventListener("click", this.arrowClick.bind(this));
                    });
                }
            },

            getChildIndex(target) {
                return parseInt(target.dataset.index);
            },

            childNavGoTo(index) {
                this.childNavLinks.forEach(a => {
                    a.blur();
                    a.classList.remove(classes.isActive);
                });

                const el = this.childNavLinks[index];
                el.classList.add(classes.isActive);

                if (!this.args.childNavScroller) {
                    return;
                }

                if (this.args.childVertical) {
                    const elTop = el.offsetTop;
                    this.args.childNavScroller.scrollTop = elTop - 100;
                } else {
                    const elLeft = el.offsetLeft;
                    this.args.childNavScroller.scrollLeft = elLeft - 100;
                }
            },

            arrowClick(evt) {
                if (
                    evt.currentTarget.classList.contains(
                        "product__thumb-arrow--prev"
                    )
                ) {
                    this.slideshow.previous();
                } else {
                    this.slideshow.next();
                }
            },
        };

        return slideshow;
    })();

    /*= ===========================================================================
    VariantAvailability
    - Cross out sold out or unavailable variants
    - To disable, set dynamicVariantsEnable to false in theme.liquid
    - Required markup:
      - class=variant-input-wrap to wrap select or button group
      - class=variant-input to wrap button/label
  ============================================================================== */

    theme.VariantAvailability = (function () {
        const classes = {
            disabled: "disabled",
        };

        function availability(args) {
            this.type = args.type;
            this.variantsObject = args.variantsObject;
            this.currentVariantObject = args.currentVariantObject;
            this.container = args.container;
            this.namespace = args.namespace;

            this.init();
        }

        availability.prototype = {
            ...availability.prototype,
            init() {
                this.container.on(
                    `variantChange${this.namespace}`,
                    this.setAvailability.bind(this)
                );

                // Set default state based on current selected variant
                this.setInitialAvailability();
            },

            // Create a list of all options. If any variant exists and is in stock with that option, it's considered available
            createAvailableOptionsTree(
                variants,
                lastSelectedIndex,
                lastSelectedValue,
                currentlySelectedValues = []
            ) {
                // Reduce variant array into option availability tree
                return variants.reduce(
                    (options, variant) => {
                        const numberOfOptionTypes = variant.options.length;

                        // Check each option group (e.g. option1, option2, option3) of the variant
                        Object.keys(options).forEach(index => {
                            if (variant[index] === null) return;

                            let entry = options[index].find(
                                option => option.value === variant[index]
                            );

                            if (typeof entry === "undefined") {
                                // If option has yet to be added to the options tree, add it
                                entry = { value: variant[index], soldOut: true };
                                options[index].push(entry);
                            }

                            if (currentlySelectedValues.length > 0) {
                                // If the user has selected a value
                                if (numberOfOptionTypes === 1) {
                                    // If we're dealing with a single variant selector, enable options that are available
                                    entry.soldOut =
                                        entry.soldOut && variant.available
                                            ? false
                                            : entry.soldOut;
                                } else if (numberOfOptionTypes === 2) {
                                    // If we're dealing with a double variant selector
                                    if (
                                        currentlySelectedValues.some(
                                            ({ value, index }) =>
                                                variant[index] === value
                                        )
                                    ) {
                                        // Only enable options that have at least one match (.some()) with an available variant
                                        entry.soldOut =
                                            entry.soldOut && variant.available
                                                ? false
                                                : entry.soldOut;
                                    }
                                } else if (numberOfOptionTypes === 3) {
                                    // If we're dealing with a triple variant selector
                                    if (currentlySelectedValues.length === 1) {
                                        // If only one value has been selected
                                        if (index !== lastSelectedIndex) {
                                            // If we're checking an option that is not part of the group that was just selected
                                            if (
                                                currentlySelectedValues.every(
                                                    ({ value, index }) =>
                                                        variant[index] === value
                                                )
                                            ) {
                                                // Only enable options from variants that match the currently selected value
                                                entry.soldOut =
                                                    entry.soldOut &&
                                                    variant.available
                                                        ? false
                                                        : entry.soldOut;
                                            }
                                        } else {
                                            // Other options in the same group of the one that was selected should remain unchanged
                                            entry.soldOut =
                                                entry.soldOut && variant.available
                                                    ? false
                                                    : entry.soldOut;
                                        }
                                    } else if (
                                        currentlySelectedValues.length === 2
                                    ) {
                                        // If only two values have been selected
                                        if (
                                            currentlySelectedValues.every(
                                                ({ value, index }) =>
                                                    variant[index] === value
                                            )
                                        ) {
                                            // Only enable options from variants that match the 2 currently selected values
                                            entry.soldOut =
                                                entry.soldOut && variant.available
                                                    ? false
                                                    : entry.soldOut;
                                        }
                                    } else if (
                                        currentlySelectedValues.length === 3
                                    ) {
                                        // If all three values have been selected
                                        // Check how many selected option values match a variant
                                        const variantOptionsThatMatchCurrent =
                                            currentlySelectedValues.reduce(
                                                (count, { value, index }) =>
                                                    variant[index] === value
                                                        ? count + 1
                                                        : count,
                                                0
                                            );

                                        // Only enable an option if an available variant matches any 2 currently selected values
                                        if (variantOptionsThatMatchCurrent >= 2) {
                                            entry.soldOut =
                                                entry.soldOut && variant.available
                                                    ? false
                                                    : entry.soldOut;
                                        }
                                    }
                                }
                            } else {
                                // If the user has not selected a value yet, show all options that are available.
                                // An option will only initially appear disabled if it is out of stock/unavailable across all variants
                                entry.soldOut =
                                    entry.soldOut && variant.available
                                        ? false
                                        : entry.soldOut;
                            }
                        });

                        return options;
                    },
                    { option1: [], option2: [], option3: [] }
                );
            },

            setInitialAvailability() {
                this.container
                    .querySelectorAll(".variant-input-wrap")
                    .forEach(group => {
                        this.disableVariantGroup(group);
                    });

                const initialOptions = this.createAvailableOptionsTree(
                    this.variantsObject
                );

                for (const [option, values] of Object.entries(initialOptions)) {
                    this.manageOptionState(option, values);
                }
            },

            setAvailability(evt) {
                const {
                    value: lastSelectedValue,
                    index: lastSelectedIndex,
                    currentlySelectedValues,
                } = evt.detail;

                // Object to hold all options by value.
                // This will be what sets a button/dropdown as
                // sold out or unavailable (not a combo set as purchasable)
                const valuesToManage = this.createAvailableOptionsTree(
                    this.variantsObject,
                    lastSelectedIndex,
                    lastSelectedValue,
                    currentlySelectedValues
                );

                // Disable all options to start.
                // If coming from a variant change event, do not disable
                // options inside current index group
                this.container
                    .querySelectorAll(".variant-input-wrap")
                    .forEach(group => {
                        this.disableVariantGroup(group);
                    });

                // Loop through all option levels and send each
                // value w/ args to function that determines to show/hide/enable/disable
                for (const [option, values] of Object.entries(valuesToManage)) {
                    this.manageOptionState(option, values, lastSelectedValue);
                }
            },

            manageOptionState(option, values, selectedValue) {
                const group = this.container.querySelector(
                    `.variant-input-wrap[data-index="${option}"]`
                );

                // Loop through each option value
                values.forEach(obj => {
                    this.enableVariantOption(group, obj, selectedValue);
                });
            },

            enableVariantOption(group, obj, selectedValue) {
                // Selecting by value so escape it
                const value = obj.value.replace(
                    /([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,
                    "\\$1"
                );

                if (this.type === "dropdown") {
                    group.querySelector(`option[value="${value}"]`).disabled = false;
                } else {
                    const buttonGroup = group.querySelector(
                        `.variant-input[data-value="${value}"]`
                    );
                    const input = buttonGroup.querySelector("input");
                    const label = buttonGroup.querySelector("label");

                    // Variant exists - enable & show variant
                    input.classList.remove(classes.disabled);
                    label.classList.remove(classes.disabled);

                    // Variant sold out - cross out option (remains selectable)
                    if (obj.soldOut) {
                        input.classList.add(classes.disabled);
                        label.classList.add(classes.disabled);

                        if (value !== selectedValue) {
                            input.checked = false;
                        }
                    }
                }
            },

            disableVariantGroup(group) {
                if (this.type === "dropdown") {
                    group.querySelectorAll("option").forEach(option => {
                        option.disabled = true;
                    });
                } else {
                    group.querySelectorAll("input").forEach(input => {
                        input.classList.add(classes.disabled);
                    });
                    group.querySelectorAll("label").forEach(label => {
                        label.classList.add(classes.disabled);
                    });
                }
            },
        };

        return availability;
    })();

    // Video modal will auto-initialize for any anchor link that points to YouTube
    // MP4 videos must manually be enabled with:
    //   - .product-video-trigger--mp4 (trigger button)
    //   - .product-video-mp4-sound video player element (cloned into modal)
    //     - see media.liquid for example of this
    theme.videoModal = function () {
        let youtubePlayer;

        const videoHolderId = "VideoHolder";
        const selectors = {
            youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
            mp4Trigger: ".product-video-trigger--mp4",
            mp4Player: ".product-video-mp4-sound",
        };

        const youtubeTriggers = document.querySelectorAll(selectors.youtube);
        const mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);

        if (!youtubeTriggers.length && !mp4Triggers.length) {
            return;
        }

        const videoHolderDiv = document.getElementById(videoHolderId);

        if (youtubeTriggers.length) {
            theme.LibraryLoader.load("youtubeSdk");
        }

        const modal = new theme.Modals("VideoModal", "video-modal", {
            closeOffContentClick: true,
            bodyOpenClass: ["modal-open", "video-modal-open"],
            solid: true,
        });

        youtubeTriggers.forEach(btn => {
            btn.addEventListener("click", triggerYouTubeModal);
        });

        mp4Triggers.forEach(btn => {
            btn.addEventListener("click", triggerMp4Modal);
        });

        document.addEventListener("modalClose.VideoModal", closeVideoModal);

        function triggerYouTubeModal(evt) {
            // If not already loaded, treat as normal link
            if (!theme.config.youTubeReady) {
                return;
            }

            evt.preventDefault();
            emptyVideoHolder();

            modal.open(evt);

            const videoId = getYoutubeVideoId(
                evt.currentTarget.getAttribute("href")
            );
            youtubePlayer = new theme.YouTube(videoHolderId, {
                videoId,
                style: "sound",
                events: {
                    onReady: onYoutubeReady,
                },
            });
        }

        function triggerMp4Modal(evt) {
            emptyVideoHolder();

            const el = evt.currentTarget;
            const player = el.parentNode.querySelector(selectors.mp4Player);

            // Clone video element and place it in the modal
            const playerClone = player.cloneNode(true);
            playerClone.classList.remove("hide");

            videoHolderDiv.append(playerClone);
            modal.open(evt);

            // Play new video element
            videoHolderDiv.querySelector("video").play();
        }

        function onYoutubeReady(evt) {
            evt.target.unMute();
            evt.target.playVideo();
        }

        function getYoutubeVideoId(url) {
            const regExp =
                /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
            const match = url.match(regExp);
            return match && match[7].length == 11 ? match[7] : false;
        }

        function emptyVideoHolder() {
            videoHolderDiv.innerHTML = "";
        }

        function closeVideoModal() {
            if (youtubePlayer && typeof youtubePlayer.destroy === "function") {
                youtubePlayer.destroy();
            } else {
                emptyVideoHolder();
            }
        }
    };

    /*= ===========================================================================
    ToolTip
  ============================================================================== */

    class ToolTip extends HTMLElement {
        constructor() {
            super();
            this.el = this;
            this.inner = this.querySelector("[data-tool-tip-inner]");
            this.closeButton = this.querySelector("[data-tool-tip-close]");
            this.toolTipContent = this.querySelector("[data-tool-tip-content]");

            this.triggers = document.querySelectorAll("[data-tool-tip-trigger]");

            document.addEventListener("tooltip:open", e => {
                this._open(e.detail.context, e.detail.content);
            });
        }

        _open(context, insertedHtml) {
            this.toolTipContent.innerHTML = insertedHtml;

            theme.a11y.trapFocus({
                container: this.el,
                namespace: "tooltip_focus",
            });

            if (this.closeButton) {
                this.closeButton.on("click" + ".tooltip-close", () => {
                    this._close();
                });
            }

            document.documentElement.on("click" + ".tooltip-outerclick", event => {
                if (
                    this.el.dataset.toolTipOpen === "true" &&
                    !this.inner.contains(event.target)
                )
                    this._close();
            });

            document.documentElement.on("keydown" + ".tooltip-esc", event => {
                if (event.code === "Escape") this._close();
            });

            this.el.dataset.toolTipOpen = true;
            this.el.dataset.toolTip = context;
        }

        _close() {
            this.toolTipContent.innerHTML = "";
            this.el.dataset.toolTipOpen = "false";
            this.el.dataset.toolTip = "";

            theme.a11y.removeTrapFocus({
                container: this.el,
                namespace: "tooltip_focus",
            });

            this.closeButton.off("click" + ".tooltip-close");
            document.documentElement.off("click" + ".tooltip-outerclick");
            document.documentElement.off("keydown" + ".tooltip-esc");
        }
    }

    customElements.define("tool-tip", ToolTip);

    /*= ===========================================================================
    ToolTipTrigger
  ============================================================================== */

    class ToolTipTrigger extends HTMLElement {
        constructor() {
            super();
            this.el = this;
            this.toolTipContent = this.querySelector("[data-tool-tip-content]");

            this.init();
        }

        init() {
            // Create and dispatch customEvent
            const toolTipOpen = new CustomEvent("tooltip:open", {
                detail: {
                    context: this.dataset.toolTip,
                    content: this.toolTipContent.innerHTML,
                },
                bubbles: true,
            });

            this.el.addEventListener("click", e => {
                e.stopPropagation();
                this.dispatchEvent(toolTipOpen);
            });
        }
    }

    customElements.define("tool-tip-trigger", ToolTipTrigger);

    theme.announcementBar = (function () {
        const args = {
            autoPlay: 5000,
            avoidReflow: true,
            cellAlign: theme.config.rtl ? "right" : "left",
            fade: true,
        };
        let bar;
        let flickity;

        function init() {
            bar = document.getElementById("AnnouncementSlider");
            if (!bar) {
                return;
            }

            unload();

            if (bar.dataset.blockCount === 1) {
                return;
            }

            flickity = new theme.Slideshow(bar, args);
        }

        // Go to slide if selected in the editor
        function onBlockSelect(id) {
            const slide = bar.querySelector(`#AnnouncementSlide-${id}`);
            const index = parseInt(slide.dataset.index);

            if (flickity && typeof flickity.pause === "function") {
                flickity.goToSlide(index);
                flickity.pause();
            }
        }

        function onBlockDeselect() {
            if (flickity && typeof flickity.play === "function") {
                flickity.play();
            }
        }

        function unload() {
            if (flickity && typeof flickity.destroy === "function") {
                flickity.destroy();
            }
        }

        return {
            init,
            onBlockSelect,
            onBlockDeselect,
            unload,
        };
    })();

    theme.customerTemplates = function () {
        checkUrlHash();
        initEventListeners();
        resetPasswordSuccess();
        customerAddressForm();

        function checkUrlHash() {
            const { hash } = window.location;

            // Allow deep linking to recover password form
            if (hash === "#recover") {
                toggleRecoverPasswordForm();
            }
        }

        function toggleRecoverPasswordForm() {
            const passwordForm = document
                .getElementById("RecoverPasswordForm")
                .classList.toggle("hide");
            const loginForm = document
                .getElementById("CustomerLoginForm")
                .classList.toggle("hide");
        }

        function initEventListeners() {
            // Show reset password form
            const recoverForm = document.getElementById("RecoverPassword");
            if (recoverForm) {
                recoverForm.addEventListener("click", evt => {
                    evt.preventDefault();
                    toggleRecoverPasswordForm();
                });
            }

            // Hide reset password form
            const hideRecoverPassword = document.getElementById(
                "HideRecoverPasswordLink"
            );
            if (hideRecoverPassword) {
                hideRecoverPassword.addEventListener("click", evt => {
                    evt.preventDefault();
                    toggleRecoverPasswordForm();
                });
            }
        }

        function resetPasswordSuccess() {
            const formState = document.querySelector(".reset-password-success");

            // check if reset password form was successfully submitted
            if (!formState) {
                return;
            }

            // show success message
            document.getElementById("ResetSuccess").classList.remove("hide");
        }

        function customerAddressForm() {
            const newAddressForm = document.getElementById("AddressNewForm");
            const addressForms = document.querySelectorAll(".js-address-form");

            if (!newAddressForm || !addressForms.length) {
                return;
            }

            // Country/province selector can take a short time to load
            setTimeout(() => {
                document.querySelectorAll(".js-address-country").forEach(el => {
                    const { countryId } = el.dataset;
                    const { provinceId } = el.dataset;
                    const { provinceContainerId } = el.dataset;

                    new Shopify.CountryProvinceSelector(countryId, provinceId, {
                        hideElement: provinceContainerId,
                    });
                });
            }, 1000);

            // Toggle new/edit address forms
            document.querySelectorAll(".address-new-toggle").forEach(el => {
                el.addEventListener("click", () => {
                    newAddressForm.classList.toggle("hide");
                });
            });

            document.querySelectorAll(".address-edit-toggle").forEach(el => {
                el.addEventListener("click", evt => {
                    const { formId } = evt.currentTarget.dataset;
                    document
                        .getElementById(`EditAddress_${formId}`)
                        .classList.toggle("hide");
                });
            });

            document.querySelectorAll(".address-delete").forEach(el => {
                el.addEventListener("click", evt => {
                    const { formId } = evt.currentTarget.dataset;
                    const { confirmMessage } = evt.currentTarget.dataset;

                    if (
                        confirm(
                            confirmMessage ||
                                "Are you sure you wish to delete this address?"
                        )
                    ) {
                        if (Shopify) {
                            Shopify.postLink(`/account/addresses/${formId}`, {
                                parameters: { _method: "delete" },
                            });
                        }
                    }
                });
            });
        }
    };

    theme.headerNav = (function () {
        const selectors = {
            wrapper: "#HeaderWrapper",
            siteHeader: "#SiteHeader",
            logo: "#LogoContainer img",
            megamenu: ".megamenu",
            navigation: ".site-navigation",
            navItems: ".site-nav__item",
            navLinks: ".site-nav__link",
            navLinksWithDropdown: ".site-nav__link--has-dropdown",
            navDropdownLinks: ".site-nav__dropdown-link--second-level",
            triggerCollapsedMenu: ".site-nav__compress-menu",
            collapsedMenu: '[data-type="nav"]',
            bottomSearch: '[data-type="search"]',
        };

        const classes = {
            hasDropdownClass: "site-nav--has-dropdown",
            hasSubDropdownClass: "site-nav__deep-dropdown-trigger",
            dropdownActive: "is-focused",
            headerCompressed: "header-wrapper--compressed",
            overlay: "header-wrapper--overlay",
            overlayStyle: "is-light",
        };

        const config = {
            namespace: ".siteNav",
            wrapperOverlayed: false,
            stickyEnabled: false,
            stickyActive: false,
            subarPositionInit: false,
            threshold: 0,
        };

        // Elements used in resize functions, defined in init
        let wrapper;
        let siteHeader;
        let bottomNav;
        let bottomSearch;

        function init() {
            wrapper = document.querySelector(selectors.wrapper);
            siteHeader = document.querySelector(selectors.siteHeader);
            bottomNav = wrapper.querySelector(selectors.collapsedMenu);
            bottomSearch = wrapper.querySelector(selectors.bottomSearch);

            // Trigger collapsed state at top of header
            config.threshold = wrapper.getBoundingClientRect().top;

            config.subarPositionInit = false;
            config.stickyEnabled = siteHeader.dataset.sticky === "true";
            if (config.stickyEnabled) {
                config.wrapperOverlayed = wrapper.classList.contains(
                    classes.overlayStyle
                );
                stickyHeaderCheck();
            } else {
                disableSticky();
            }

            theme.settings.overlayHeader = siteHeader.dataset.overlay === "true";
            // Disable overlay header if on collection template with no collection image
            if (theme.settings.overlayHeader && Shopify && Shopify.designMode) {
                if (
                    document.body.classList.contains("template-collection") &&
                    !document.querySelector(".collection-hero")
                ) {
                    this.disableOverlayHeader();
                }
            }

            // Position menu and search bars absolutely, offsetting their height
            // with an invisible div to prevent reflows
            setAbsoluteBottom();
            window.on(
                `resize${config.namespace}`,
                theme.utils.debounce(250, setAbsoluteBottom)
            );

            const collapsedNavTrigger = wrapper.querySelector(
                selectors.triggerCollapsedMenu
            );
            if (collapsedNavTrigger) {
                collapsedNavTrigger.on("click", () => {
                    collapsedNavTrigger.classList.toggle("is-active");
                    theme.utils.prepareTransition(bottomNav, () => {
                        bottomNav.classList.toggle("is-active");
                    });
                });
            }

            accessibleDropdowns();

            const navigation = siteHeader.querySelector(selectors.navigation);
            if (navigation.querySelectorAll(".grid-product")) {
                new theme.QuickAdd(navigation);
                new theme.QuickShop(navigation);
            }

            window.on(`load${config.namespace}`, resizeLogo);
            window.on(
                `resize${config.namespace}`,
                theme.utils.debounce(150, resizeLogo)
            );
        }

        // Measure sub menu bar, set site header's bottom padding to it.
        // Set sub bars as absolute to avoid page jumping on collapsed state change.
        function setAbsoluteBottom() {
            if (theme.settings.overlayHeader) {
                document
                    .querySelector(".header-section")
                    .classList.add("header-section--overlay");
            }

            const activeSubBar = theme.config.bpSmall
                ? document.querySelector(
                      '.site-header__element--sub[data-type="search"]'
                  )
                : document.querySelector(
                      '.site-header__element--sub[data-type="nav"]'
                  );

            if (activeSubBar) {
                const h = activeSubBar.offsetHeight;
                // If height is 0, it was measured when hidden so ignore it.
                // Very likely it's on mobile when the address bar is being
                // hidden and triggers a resize
                if (h !== 0) {
                    document.documentElement.style.setProperty(
                        "--header-padding-bottom",
                        `${h}px`
                    );
                }

                // If not setup before, set active class on wrapper so subbars become absolute
                if (!config.subarPositionInit) {
                    wrapper.classList.add("header-wrapper--init");
                    config.subarPositionInit = true;
                }
            }
        }

        // If the header setting to overlay the menu on the collection image
        // is enabled but the collection setting is disabled, we need to undo
        // the init of the sticky nav
        function disableOverlayHeader() {
            wrapper.classList.remove(
                config.overlayEnabledClass,
                classes.overlayStyle
            );
            config.wrapperOverlayed = false;
            theme.settings.overlayHeader = false;
        }

        function stickyHeaderCheck() {
            // Disable sticky header if any mega menu is taller than window
            theme.config.stickyHeader = doesMegaMenuFit();

            if (theme.config.stickyHeader) {
                config.forceStopSticky = false;
                stickyHeader();
            } else {
                config.forceStopSticky = true;
                disableSticky();
            }
        }

        function disableSticky() {
            document.querySelector(".header-section").style.position = "relative";
        }

        function removeOverlayClass() {
            if (config.wrapperOverlayed) {
                wrapper.classList.remove(classes.overlayStyle);
            }
        }

        function doesMegaMenuFit() {
            let largestMegaNav = 0;
            siteHeader.querySelectorAll(selectors.megamenu).forEach(nav => {
                const h = nav.offsetHeight;
                if (h > largestMegaNav) {
                    largestMegaNav = h;
                }
            });

            // 120 ~ space of visible header when megamenu open
            if (window.innerHeight < largestMegaNav + 120) {
                return false;
            }

            return true;
        }

        function stickyHeader() {
            if (window.scrollY > config.threshold) {
                stickyHeaderScroll();
            }

            window.on(`scroll${config.namespace}`, stickyHeaderScroll);
        }

        function stickyHeaderScroll() {
            if (!config.stickyEnabled) {
                return;
            }

            if (config.forceStopSticky) {
                return;
            }

            requestAnimationFrame(scrollHandler);
        }

        function scrollHandler() {
    const currentY = Math.max(0, window.scrollY);
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    let shouldCompress = currentY > config.threshold;

    if (isMobile) {
        const previousY = config.playluxPreviousY ?? currentY;
        const delta = currentY - previousY;

        config.playluxPreviousY = currentY;

        const focusedElement = document.activeElement;

        const typingInSearch =
            focusedElement &&
            focusedElement.matches('input[type="search"]') &&
            siteHeader.contains(focusedElement);

        const interactionOpen =
            document.documentElement.classList.contains("mobile-nav-open") ||
            document.documentElement.classList.contains("cart-open") ||
            typingInSearch;

        if (currentY <= config.threshold || interactionOpen) {
            shouldCompress = false;
            config.playluxScrollDistance = 0;
        } else {
            const previousDistance = config.playluxScrollDistance || 0;

            // Reiniciar la distancia al cambiar de dirección.
            if (delta !== 0) {
                config.playluxScrollDistance =
                    Math.sign(delta) === Math.sign(previousDistance)
                        ? previousDistance + delta
                        : delta;
            }

            const distance = config.playluxScrollDistance || 0;

            // Evitar cambios con movimientos pequeños.
            shouldCompress = config.stickyActive;

            if (distance <= -16) {
                shouldCompress = false;
            } else if (distance >= 32) {
                shouldCompress = true;
            }
        }
    } else {
    shouldCompress = false;
    config.playluxPreviousY = currentY;
    config.playluxScrollDistance = 0;
}

    if (shouldCompress === config.stickyActive) {
        return;
    }

    if (bottomNav) {
        theme.utils.prepareTransition(bottomNav);
    }

    if (bottomSearch) {
        theme.utils.prepareTransition(bottomSearch);
    }

    config.stickyActive = shouldCompress;
    wrapper.classList.toggle(classes.headerCompressed, shouldCompress);

    if (config.wrapperOverlayed) {
        wrapper.classList.toggle(classes.overlayStyle, !shouldCompress);
    }

    document.dispatchEvent(new CustomEvent("headerStickyChange"));
}

        function accessibleDropdowns() {
            let hasActiveDropdown = false;
            let hasActiveSubDropdown = false;
            let closeOnClickActive = false;

            // Touch devices open dropdown on first click, navigate to link on second
            if (theme.config.isTouch) {
                document
                    .querySelectorAll(selectors.navLinksWithDropdown)
                    .forEach(el => {
                        el.on(`touchend${config.namespace}`, evt => {
                            const parent = evt.currentTarget.parentNode;
                            if (!parent.classList.contains(classes.dropdownActive)) {
                                evt.preventDefault();
                                closeDropdowns();
                                openFirstLevelDropdown(evt.currentTarget);
                            } else {
                                window.location.replace(
                                    evt.currentTarget.getAttribute("href")
                                );
                            }
                        });
                    });
            }

            // Open/hide top level dropdowns
            document.querySelectorAll(selectors.navLinks).forEach(el => {
                el.on(`focusin${config.namespace}`, accessibleMouseEvent);
                el.on(`mouseover${config.namespace}`, accessibleMouseEvent);
                el.on(`mouseleave${config.namespace}`, closeDropdowns);
            });

            document.querySelectorAll(selectors.navDropdownLinks).forEach(el => {
                if (theme.config.isTouch) {
                    el.on(`touchend${config.namespace}`, evt => {
                        const parent = evt.currentTarget.parentNode;

                        // Open third level menu or go to link based on active state
                        if (parent.classList.contains(classes.hasSubDropdownClass)) {
                            if (!parent.classList.contains(classes.dropdownActive)) {
                                evt.preventDefault();
                                closeThirdLevelDropdown();
                                openSecondLevelDropdown(evt.currentTarget);
                            } else {
                                window.location.replace(
                                    evt.currentTarget.getAttribute("href")
                                );
                            }
                        } else {
                            // No third level nav, go to link
                            window.location.replace(
                                evt.currentTarget.getAttribute("href")
                            );
                        }
                    });
                }

                // Open/hide sub level dropdowns
                el.on(`focusin${config.namespace}`, evt => {
                    closeThirdLevelDropdown();
                    openSecondLevelDropdown(evt.currentTarget, true);
                });
            });

            // Clicking outside of the megamenu should close it
            if (theme.config.isTouch) {
                document.body.on(`touchend${config.namespace}`, () => {
                    closeDropdowns();
                });

                // Exception to above: clicking anywhere on the megamenu content will NOT close it
                siteHeader.querySelectorAll(selectors.megamenu).forEach(el => {
                    el.on(`touchend${config.namespace}`, evt => {
                        evt.stopImmediatePropagation();
                    });
                });
            }

            function accessibleMouseEvent(evt) {
                if (hasActiveDropdown) {
                    closeSecondLevelDropdown();
                }

                if (hasActiveSubDropdown) {
                    closeThirdLevelDropdown();
                }

                openFirstLevelDropdown(evt.currentTarget);
            }

            // Private dropdown functions
            function openFirstLevelDropdown(el) {
                const parent = el.parentNode;
                if (parent.classList.contains(classes.hasDropdownClass)) {
                    parent.classList.add(classes.dropdownActive);
                    hasActiveDropdown = true;
                }

                if (!theme.config.isTouch) {
                    if (!closeOnClickActive) {
                        const eventType = theme.config.isTouch
                            ? "touchend"
                            : "click";
                        closeOnClickActive = true;
                        document.documentElement.on(
                            eventType + config.namespace,
                            () => {
                                closeDropdowns();
                                document.documentElement.off(
                                    eventType + config.namespace
                                );
                                closeOnClickActive = false;
                            }
                        );
                    }
                }
            }

            function openSecondLevelDropdown(el, skipCheck) {
                const parent = el.parentNode;
                if (
                    parent.classList.contains(classes.hasSubDropdownClass) ||
                    skipCheck
                ) {
                    parent.classList.add(classes.dropdownActive);
                    hasActiveSubDropdown = true;
                }
            }

            function closeDropdowns() {
                closeSecondLevelDropdown();
                closeThirdLevelDropdown();
            }

            function closeSecondLevelDropdown() {
                document.querySelectorAll(selectors.navItems).forEach(el => {
                    el.classList.remove(classes.dropdownActive);
                });
            }

            function closeThirdLevelDropdown() {
                document.querySelectorAll(selectors.navDropdownLinks).forEach(el => {
                    el.parentNode.classList.remove(classes.dropdownActive);
                });
            }
        }

        function resizeLogo(evt) {
            document.querySelectorAll(selectors.logo).forEach(logo => {
                const logoWidthOnScreen = logo.clientWidth;
                const containerWidth = logo.closest(".header-item").clientWidth;

                // If image exceeds container, let's make it smaller
                if (logoWidthOnScreen > containerWidth) {
                    logo.style.maxWidth = containerWidth;
                } else {
                    logo.removeAttribute("style");
                }
            });
        }
        return {
            init,
            removeOverlayClass,
            disableOverlayHeader,
        };
    })();

    /*= ===========================================================================
    MobileNav has two uses:
    - Dropdown from header on small screens
    - Duplicated into footer, initialized as separate entity in theme.HeaderSection
  ============================================================================== */
    theme.MobileNav = (function () {
        const selectors = {
            wrapper: ".slide-nav__wrapper",
            nav: ".slide-nav",
            childList: ".slide-nav__dropdown",
            allLinks: "a.slide-nav__link",
            subNavToggleBtn: ".js-toggle-submenu",

            // Trigger to open header nav
            openBtn: ".mobile-nav-trigger",
        };

        const classes = {
            isActive: "is-active",
        };

        const defaults = {
            isOpen: false,
            menuLevel: 1,
            inHeader: false,
        };

        function MobileNav(args) {
            this.config = { ...defaults, ...args };
            this.namespace = `.nav-header-${args.id}`;

            this.container = document.getElementById(this.config.id);
            if (!this.container) {
                return;
            }

            this.wrapper = this.container.querySelector(selectors.wrapper);
            if (!this.wrapper) {
                return;
            }
            this.nav = this.wrapper.querySelector(selectors.nav);
            this.openTriggers = document.querySelectorAll(selectors.openBtn);

            this.init();
        }

        MobileNav.prototype = {
            ...MobileNav.prototype,
            init() {
                // Open/close mobile nav
                if (this.openTriggers.length) {
                    this.openTriggers.forEach(btn => {
                        btn.addEventListener("click", () => {
                            if (this.config.isOpen) {
                                this.close();
                            } else {
                                this.open();
                            }
                        });
                    });
                }

                // Toggle between menu levels
                this.nav.querySelectorAll(selectors.subNavToggleBtn).forEach(btn => {
                    btn.addEventListener("click", this.toggleSubNav.bind(this));
                });

                // Close nav when a normal link is clicked
                this.nav.querySelectorAll(selectors.allLinks).forEach(link => {
                    link.addEventListener("click", this.close.bind(this));
                });

                if (this.inHeader) {
                    document.addEventListener("unmatchSmall", () => {
                        this.close(null, true);
                    });

                    document.addEventListener(
                        "CartDrawer:open",
                        this.close.bind(this)
                    );

                    // Dev-friendly way to open/close mobile nav
                    document.addEventListener(
                        "mobileNav:open",
                        this.open.bind(this)
                    );
                    document.addEventListener(
                        "mobileNav:close",
                        this.close.bind(this)
                    );
                }
            },

            /*= ===========================================================================
        Open/close mobile nav drawer in header
      ============================================================================== */
            open(evt) {
                if (evt) {
                    evt.preventDefault();
                }

                theme.sizeDrawer();

                this.openTriggers.forEach(btn => {
                    btn.classList.add("is-active");
                });

                theme.utils.prepareTransition(this.container, () => {
                    this.container.classList.add("is-active");
                });

                // Esc closes cart popup
                window.on(`keyup${this.namespace}`, evt => {
                    if (evt.keyCode === 27) {
                        this.close();
                    }
                });

                theme.headerNav.removeOverlayClass();

                document.documentElement.classList.add("mobile-nav-open");
                window.dispatchEvent(new Event("scroll"));
                document.dispatchEvent(new CustomEvent("MobileNav:open"));

                this.config.isOpen = true;

                // Clicking out of menu closes it. Timeout to prevent immediate bubbling
                setTimeout(() => {
                    window.on(`click${this.namespace}`, evt => {
                        this.close(evt);
                    });
                }, 0);
            },

            close(evt, noAnimate) {
                let forceClose = false;
                // Do not close if click event came from inside drawer,
                // unless it is a normal link with no children
                if (
                    evt &&
                    evt.target.closest &&
                    evt.target.closest(".site-header__drawer")
                ) {
                    // If normal link, continue to close drawer
                    if (evt.currentTarget && evt.currentTarget.classList) {
                        if (
                            evt.currentTarget.classList.contains("slide-nav__link")
                        ) {
                            forceClose = true;
                        }
                    }

                    if (!forceClose) {
                        return;
                    }
                }

                this.openTriggers.forEach(btn => {
                    btn.classList.remove("is-active");
                });

                if (noAnimate) {
                    this.container.classList.remove("is-active");
                } else {
                    theme.utils.prepareTransition(this.container, () => {
                        this.container.classList.remove("is-active");
                    });
                }

                document.documentElement.classList.remove("mobile-nav-open");
                document.dispatchEvent(new CustomEvent("MobileNav:close"));

                window.off(`keyup${this.namespace}`);
                window.off(`click${this.namespace}`);

                this.config.isOpen = false;
            },

            /*= ===========================================================================
        Handle switching between nav levels
      ============================================================================== */
            toggleSubNav(evt) {
                const btn = evt.currentTarget;
                this.goToSubnav(btn.dataset.target);
            },

            // If a level is sent we are going up, so target list doesn't matter
            goToSubnav(target) {
                // Activate new list if a target is passed
                const targetMenu = this.nav.querySelector(
                    `${selectors.childList}[data-parent="${target}"]`
                );
                if (targetMenu) {
                    this.config.menuLevel = targetMenu.dataset.level;

                    // Hide all level 3 menus if going to level 2
                    if (this.config.menuLevel == 2) {
                        this.nav
                            .querySelectorAll(
                                `${selectors.childList}[data-level="3"]`
                            )
                            .forEach(list => {
                                list.classList.remove(classes.isActive);
                            });
                    }

                    targetMenu.classList.add(classes.isActive);
                    this.setWrapperHeight(targetMenu.offsetHeight);
                } else {
                    // Going to top level, reset
                    this.config.menuLevel = 1;
                    this.wrapper.removeAttribute("style");
                    this.nav.querySelectorAll(selectors.childList).forEach(list => {
                        list.classList.remove(classes.isActive);
                    });
                }

                this.wrapper.dataset.level = this.config.menuLevel;
            },

            setWrapperHeight(h) {
                this.wrapper.style.height = `${h}px`;
                this.scrollTopElement();
            },

            scrollTopElement() {
                const scrollElement =
                    document.querySelectorAll(".slide-nav__wrapper");

                scrollElement.forEach(element => {
                    element.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                });
            },
        };

        return MobileNav;
    })();

    theme.headerSearch = (function () {
        let currentString = "";
        let isLoading = false;
        let searchTimeout;

        const selectors = {
            form: ".site-header__search-form",
            input: 'input[type="search"]',

            searchInlineContainer: ".site-header__search-container",
            searchInlineBtn: ".js-search-header",

            searchButton: "[data-predictive-search-button]",
            closeSearch: ".site-header__search-btn--cancel",

            wrapper: "#SearchResultsWrapper",
            topSearched: "#TopSearched",
            predictiveWrapper: "#PredictiveWrapper",
            resultDiv: "#PredictiveResults",
        };

        const cache = {};
        let activeForm;

        const classes = {
            isActive: "predicitive-active",
        };

        const config = {
            namespace: ".search",
            topSearched: false,
            predictiveSearch: false,
            imageSize: "square",
        };

        const keys = {
            esc: 27,
            up_arrow: 38,
            down_arrow: 40,
            tab: 9,
        };

        function init() {
            initInlineSearch();

            cache.wrapper = document.querySelector(selectors.wrapper);
            if (!cache.wrapper) {
                return;
            }

            cache.topSearched = document.querySelector(selectors.topSearched);
            if (cache.topSearched) {
                config.topSearched = true;
            }

            if (theme.settings.predictiveSearch) {
                // Only some languages support predictive search
                if (document.getElementById("shopify-features")) {
                    const supportedShopifyFeatures = JSON.parse(
                        document.getElementById("shopify-features").innerHTML
                    );
                    if (supportedShopifyFeatures.predictiveSearch) {
                        config.predictiveSearch = true;
                    }
                }
            }

            if (config.predictiveSearch) {
                cache.predictiveWrapper = document.querySelector(
                    selectors.predictiveWrapper
                );
                config.imageSize = cache.predictiveWrapper.dataset.imageSize;
                cache.results = document.querySelector(selectors.resultDiv);
                cache.submit = cache.predictiveWrapper.querySelector(
                    selectors.searchButton
                );
                cache.submit.on(`click${config.namespace}`, triggerSearch);
            }

            document.querySelectorAll(selectors.form).forEach(form => {
                initForm(form);
            });
        }

        function initForm(form) {
            form.setAttribute("autocomplete", "off");
            form.on(`submit${config.namespace}`, submitSearch);

            const input = form.querySelector(selectors.input);
            input.on(`focus${config.namespace}`, handleFocus);
            if (config.predictiveSearch) {
                input.on(`keyup${config.namespace}`, handleKeyup);
            }
        }

        function reset() {
            if (config.predictiveSearch) {
                cache.predictiveWrapper.classList.add("hide");
                cache.results.innerHTML = "";
                clearTimeout(searchTimeout);
            }

            if (config.topSearched) {
                cache.topSearched.classList.remove("hide");
            } else {
                cache.wrapper.classList.add("hide");
            }
        }

        function close(evt) {
            // If close button is clicked, close as expected.
            // Otherwise, ignore clicks in search results, search form, or container elements
            if (evt && evt.target.closest) {
                if (evt.target.closest(selectors.closeSearch)) {
                } else {
                    if (evt.target.closest(".site-header__search-form")) {
                        return;
                    }
                    if (evt.target.closest(".site-header__element--sub")) {
                        return;
                    }
                    if (evt.target.closest("#SearchResultsWrapper")) {
                        return;
                    }
                    if (evt.target.closest(".site-header__search-container")) {
                        return;
                    }
                }
            }

            // deselect any focused form elements
            document.activeElement.blur();

            cache.wrapper.classList.add("hide");

            if (config.topSearched) {
                cache.topSearched.classList.remove("hide");
            }

            if (config.predictiveSearch) {
                cache.predictiveWrapper.classList.add("hide");
                clearTimeout(searchTimeout);
            }

            if (cache.inlineSearchContainer) {
                cache.inlineSearchContainer.classList.remove("is-active");
            }

            document.querySelectorAll(selectors.form).forEach(form => {
                form.classList.remove("is-active");
            });

            window.off(`click${config.namespace}`);
        }

        function initInlineSearch() {
            cache.inlineSearchContainer = document.querySelector(
                selectors.searchInlineContainer
            );
            document.querySelectorAll(selectors.searchInlineBtn).forEach(btn => {
                btn.addEventListener("click", openInlineSearch);
            });
        }

        function openInlineSearch(evt) {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            const container = document.querySelector(
                selectors.searchInlineContainer
            );
            container.classList.add("is-active");
            container.querySelector(".site-header__search-input").focus();

            enableCloseListeners();
        }

        function triggerSearch() {
            if (activeForm) {
                activeForm.submit();
            }
        }

        // Append * wildcard to search
        function submitSearch(evt) {
            evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false);

            const obj = {};
            const formData = new FormData(evt.target);
            for (const key of formData.keys()) {
                obj[key] = formData.get(key);
            }

            if (obj.q) {
                obj.q += "*";
            }

            const params = paramUrl(obj);

            window.location.href = `${theme.routes.search}?${params}`;
            return false;
        }

        function handleKeyup(evt) {
            activeForm = evt.currentTarget.closest("form");

            if (evt.keyCode === keys.up_arrow) {
                return;
            }

            if (evt.keyCode === keys.down_arrow) {
                return;
            }

            if (evt.keyCode === keys.tab) {
                return;
            }

            if (evt.keyCode === keys.esc) {
                close();
                return;
            }

            search(evt.currentTarget);
        }

        function handleFocus(evt) {
            evt.currentTarget.parentNode.classList.add("is-active");
            if (config.topSearched) {
                cache.wrapper.classList.remove("hide");
            }

            enableCloseListeners();
        }

        function enableCloseListeners() {
            // Clicking out of search area closes it. Timeout to prevent immediate bubbling
            setTimeout(() => {
                window.on(`click${config.namespace}`, evt => {
                    close(evt);
                });
            }, 0);

            // Esc key also closes search
            window.on("keyup", evt => {
                if (evt.keyCode === 27) {
                    close();
                }
            });
        }

        function search(input) {
            const keyword = input.value;

            if (keyword === "") {
                reset();
                return;
            }

            const q = _normalizeQuery(keyword);

            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
                predictQuery(q);
            }, 500);
        }

        function predictQuery(q) {
            if (isLoading) {
                return;
            }

            // Do not re-search the same thing
            if (currentString === q) {
                return;
            }

            currentString = q;
            isLoading = true;

            const searchObj = {
                "q": q,
                "resources[type]": theme.settings.predictiveSearchType,
                "resources[limit]": 4,
                "resources[options][unavailable_products]": "last",
                "resources[options][fields]":
                    "title,product_type,variants.title,vendor",
            };

            const params = paramUrl(searchObj);

            fetch(`/search/suggest.json?${params}`)
                .then(response => response.json())
                .then(suggestions => {
                    isLoading = false;
                    const data = {};
                    let resultCount = 0;

                    if (cache.topSearched) {
                        cache.topSearched.classList.add("hide");
                    }
                    cache.predictiveWrapper.classList.remove("hide");
                    const resultTypes = Object.entries(
                        suggestions.resources.results
                    );

                    Object.keys(resultTypes).forEach(i => {
                        const obj = resultTypes[i];
                        const type = obj[0];
                        const results = obj[1];
                        resultCount += results.length;

                        switch (type) {
                            case "products":
                                data[type] = buildProducts(results);
                                break;
                            case "collections":
                                data[type] = buildCollections(results);
                                break;
                            case "pages":
                                data[type] = buildPages(results);
                                break;
                            case "articles":
                                data[type] = buildArticles(results);
                                break;
                        }
                    });

                    if (resultCount === 0) {
                        reset();
                        return;
                    }

                    // Build and append result markup
                    const output = buildOutput(data);
                    cache.results.innerHTML = "";
                    cache.results.innerHTML = output;

                    cache.wrapper.classList.remove("hide");
                });
        }

        function buildProducts(results) {
            let output = "";
            const products = [];

            results.forEach(product => {
                const new_product = {
                    title: product.title,
                    url: product.url,
                    image_responsive_url: theme.Images.lazyloadImagePath(
                        product.image
                    ),
                    image_aspect_ratio: product.featured_image.aspect_ratio,
                };

                products.push(new_product);
            });

            if (products.length) {
                const markup = theme.buildProductGridItem(
                    products,
                    config.imageSize
                );

                output = `
          <div data-type-products>
            <div class="new-grid product-grid" data-view="small">
              ${markup}
            </div>
          </div>
        `;
            }

            return output;
        }

        function buildCollections(collections) {
            let output = "";

            if (collections.length) {
                const markup = theme.buildCollectionItem(collections);

                output = `
          <div data-type-collections>
            <p class="h6 predictive__label">${theme.strings.searchCollections}</p>
            <ul class="no-bullets">
              ${markup}
            </ul>
          </div>
        `;
            }

            return output;
        }

        function buildPages(pages) {
            let output = "";

            if (pages.length) {
                const markup = theme.buildPageItem(pages);

                output = `
          <div data-type-pages>
            <p class="h6 predictive__label">${theme.strings.searchPages}</p>
            <ul class="no-bullets">
              ${markup}
            </ul>
          </div>
        `;
            }

            return output;
        }

        // Overwrite full sized image returned form API
        // with lazyloading-friendly path
        function buildArticles(articles) {
            let output = "";

            articles.forEach(article => {
                if (article.image) {
                    article.image = theme.Images.getSizedImageUrl(
                        article.image,
                        "200x200_crop_center"
                    );
                }
            });

            if (articles.length) {
                const markup = theme.buildArticleItem(articles, config.imageSize);

                output = `
          <div data-type-articles>
            <p class="h6 predictive__label">${theme.strings.searchArticles}</p>
            <div class="grid grid--uniform grid--no-gutters">
              ${markup}
            </div>
          </div>
        `;
            }

            return output;
        }

        // Combine all search result markup and print to page
        function buildOutput(data) {
            let output = "";

            if (data.products && data.products !== "") {
                output += data.products;
            }

            if (data.collections && data.collections !== "") {
                output += data.collections;
            }

            if (data.pages && data.pages !== "") {
                output += data.pages;
            }

            if (data.articles && data.articles !== "") {
                output += data.articles;
            }

            return output;
        }

        function _normalizeQuery(string) {
            if (typeof string !== "string") {
                return null;
            }

            return string.trim().replace(/\ /g, "-").toLowerCase();
        }

        function paramUrl(obj) {
            return Object.keys(obj)
                .map(key => `${key}=${encodeURIComponent(obj[key])}`)
                .join("&");
        }

        return {
            init,
        };
    })();

    theme.HeaderCart = (function () {
        const selectors = {
            cartTrigger: "#HeaderCartTrigger",
            cart: "#HeaderCart",

            closeBtn: ".js-close-header-cart",
            noteBtn: ".add-note",
        };

        const classes = {
            hidden: "hide",
        };

        const config = {
            cartOpen: false,
            namespace: ".cart-header",
        };

        function HeaderCart() {
            this.wrapper = document.querySelector(selectors.cart);
            if (!this.wrapper) {
                return;
            }
            this.trigger = document.querySelector(selectors.cartTrigger);
            this.noteBtn = this.wrapper.querySelector(selectors.noteBtn);
            this.form = this.wrapper.querySelector("form");

            // Close header cart
            document.addEventListener("MobileNav:open", this.close.bind(this));
            document.addEventListener("modalOpen", this.close.bind(this));

            this.init();
        }

        HeaderCart.prototype = {
            ...HeaderCart.prototype,
            init() {
                this.cartForm = new theme.CartForm(this.form);
                this.quickAdd = new theme.QuickAdd(this.wrapper);
                this.quickShop = new theme.QuickShop(this.wrapper);
                this.cartForm.buildCart();

                this.trigger.on("click", this.open.bind(this));

                document.querySelectorAll(selectors.closeBtn).forEach(btn => {
                    btn.addEventListener("click", () => {
                        this.close();
                    });
                });

                if (this.noteBtn) {
                    this.noteBtn.addEventListener("click", () => {
                        this.noteBtn.classList.toggle("is-active");
                        this.wrapper
                            .querySelector(".cart__note")
                            .classList.toggle("hide");
                    });
                }

                document.addEventListener("ajaxProduct:added", evt => {
                    this.cartForm.buildCart();
                    if (!config.cartOpen) {
                        this.open();
                    }
                });

                // Dev-friendly way to open cart
                document.addEventListener("cart:open", this.open.bind(this));
                document.addEventListener("cart:close", this.close.bind(this));
            },

            open(evt) {
                if (theme.settings.cartType !== "dropdown") {
                    return;
                }

                if (evt) {
                    evt.preventDefault();
                }

                theme.sizeDrawer();

                theme.utils.prepareTransition(this.wrapper, () => {
                    this.wrapper.classList.add("is-active");
                    this.wrapper.scrollTop = 0;
                });

                document.documentElement.classList.add("cart-open");

                // Don't lock mobile scrolling if sticky header isn't present
                if (!theme.config.bpSmall && theme.settings.overlayHeader) {
                    theme.a11y.lockMobileScrolling(config.namespace);
                }

                // Esc closes cart popup
                window.on(`keyup${config.namespace}`, evt => {
                    if (evt.keyCode === 27) {
                        this.close();
                    }
                });

                theme.headerNav.removeOverlayClass();

                document.dispatchEvent(new CustomEvent("CartDrawer:open"));
                document.dispatchEvent(new CustomEvent("drawerOpen"));

                // Clicking out of cart closes it. Timeout to prevent immediate bubbling
                setTimeout(() => {
                    window.on(`click${config.namespace}`, evt => {
                        this.close(evt);
                    });
                }, 0);

                config.cartOpen = true;
            },

            close(evt) {
                if (theme.settings.cartType !== "dropdown") {
                    return;
                }

                // Do not close if click event came from inside drawer
                if (
                    evt &&
                    evt.target.closest &&
                    evt.target.closest(".site-header__cart")
                ) {
                    return;
                }

                if (!config.cartOpen) {
                    return;
                }

                // If custom event, close without transition
                if (evt && evt.type === "MobileNav:open") {
                    this.wrapper.classList.remove("is-active");
                } else {
                    theme.utils.prepareTransition(this.wrapper, () => {
                        this.wrapper.classList.remove("is-active");
                    });
                }

                window.off(`keyup${config.namespace}`);
                window.off(`click${config.namespace}`);

                if (!theme.config.bpSmall && theme.settings.overlayHeader) {
                    theme.a11y.unlockMobileScrolling(config.namespace);
                }

                document.documentElement.classList.remove("cart-open");

                config.cartOpen = false;
            },
        };

        return HeaderCart;
    })();

    /*= ===========================================================================
    QuickAdd
    - Setup quick add buttons/forms on a product grid item
  ============================================================================== */
    theme.QuickAdd = (function () {
        const selectors = {
            quickAddBtn: ".js-quick-add-btn",
            quickAddForm: ".js-quick-add-form",
            quickAddHolder: "#QuickAddHolder",
        };

        let modalInitailized = false;
        let modal;

        function QuickAdd(container) {
            if (!container) {
                return;
            }

            if (!theme.settings.quickAdd) {
                return;
            }

            this.container = container;
            this.init();
        }

        QuickAdd.prototype = {
            ...QuickAdd.prototype,
            init() {
                // When a single variant, auto add it to cart
                const quickAddBtns = this.container.querySelectorAll(
                    selectors.quickAddBtn
                );
                if (quickAddBtns) {
                    quickAddBtns.forEach(btn => {
                        btn.addEventListener("click", this.addToCart.bind(this));
                    });
                }

                // Button loads form when 1+ variants
                const quickAddForms = this.container.querySelectorAll(
                    selectors.quickAddForm
                );

                if (quickAddForms.length) {
                    this.quickAddHolder = document.querySelector(
                        selectors.quickAddHolder
                    );
                    if (!modalInitailized) {
                        modal = new theme.Modals("QuickAddModal", "quick-add");
                        modalInitailized = true;

                        // Empty cart form when closed
                        document.addEventListener("modalClose.QuickAddModal", () => {
                            setTimeout(() => {
                                this.quickAddHolder.innerHTML = "";
                            }, 350);
                        });
                    }

                    quickAddForms.forEach(btn => {
                        btn.addEventListener(
                            "click",
                            this.loadQuickAddForm.bind(this)
                        );
                    });
                }
            },

            addToCart(evt) {
                const btn = evt.currentTarget;
                const visibleBtn = btn.querySelector(".btn");
                visibleBtn.classList.add("btn--loading");
                const { id } = btn.dataset;

                const data = {
                    items: [
                        {
                            id,
                            quantity: 1,
                        },
                    ],
                };

                fetch(theme.routes.cartAdd, {
                    method: "POST",
                    body: JSON.stringify(data),
                    credentials: "same-origin",
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.status === 422 || data.status === "bad_request") {
                        } else {
                            const product = data;
                            document.dispatchEvent(
                                new CustomEvent("ajaxProduct:added", {
                                    detail: {
                                        product,
                                        addToCartBtn: btn,
                                    },
                                })
                            );
                        }

                        visibleBtn.classList.remove("btn--loading");
                    });
            },

            loadQuickAddForm(evt) {
                this.quickAddHolder.innerHTML = "";

                const btn = evt.currentTarget;
                const gridItem = evt.currentTarget.closest(".grid-product");
                const handle = gridItem.getAttribute("data-product-handle");
                const prodId = gridItem.getAttribute("data-product-id");

                let url = `${theme.routes.home}/products/${handle}?view=form`;

                // remove double `/` in case shop might have /en or language in URL
                url = url.replace("//", "/");

                fetch(url)
                    .then(response => response.text())
                    .then(html => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, "text/html");
                        const div = doc.querySelector(
                            `.product-section[data-product-handle="${handle}"]`
                        );

                        this.quickAddHolder.append(div);

                        // Register product template inside modal
                        theme.sections.register(
                            "product",
                            theme.Product,
                            this.quickAddHolder
                        );

                        if (Shopify && Shopify.PaymentButton) {
                            Shopify.PaymentButton.init();
                        }

                        window.dispatchEvent(
                            new CustomEvent(`quickadd:loaded:${prodId}`)
                        );

                        document.dispatchEvent(
                            new CustomEvent("quickadd:loaded", {
                                detail: {
                                    productId: prodId,
                                    handle,
                                },
                            })
                        );

                        modal.open();
                    });
            },
        };

        return QuickAdd;
    })();

    /*= ===========================================================================
    QuickShop
    - Setup quick shop modals anywhere a product grid item exists
    - Duplicate product modals will be condensed down to one workable one
  ============================================================================== */
    theme.QuickShop = (function () {
        const loadedIds = [];
        const selectors = {
            product: ".grid-product",
            triggers: ".quick-product__btn",
            modalContainer: "#ProductModals",
        };

        function QuickShop(container) {
            if (!theme.settings.quickView) {
                return;
            }

            this.container = container;
            this.init();
        }

        function getData(el) {
            return {
                id: el.dataset.productId,
                handle: el.dataset.productHandle,
            };
        }

        function productMouseover(evt) {
            const el = evt.currentTarget;

            // No quick view on mobile breakpoint
            if (theme.config.bpSmall) {
                return;
            }

            // No product or onboarding content, bail
            if (!el || !el.dataset.productId) {
                return;
            }

            const data = getData(el);
            el.removeEventListener("mouseover", productMouseover);

            preloadProductModal(data);
        }

        function preloadProductModal(data) {
            const modals = document.querySelectorAll(
                `.modal--quick-shop[data-product-id="${data.id}"]`
            );

            if (!modals.length) {
                return;
            }

            // If already loaded, no need to refetch info
            if (loadedIds.indexOf(data.id) > -1) {
                removeDuplicateModals(modals);
                enableTriggers(data);
            } else {
                // Move modal to storage element so animations work regardless
                // of where original markup is. Will also remove duplicates.
                moveModal(modals);

                const holder = document.getElementById(
                    `QuickShopHolder-${data.handle}`
                );
                let url = `${theme.routes.home}/products/${data.handle}?view=modal`;

                // remove double `/` in case shop might have /en or language in URL
                url = url.replace("//", "/");

                fetch(url)
                    .then(response => response.text())
                    .then(html => {
                        // Convert the HTML string into a document object
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, "text/html");
                        const div = doc.querySelector(
                            `.product-section[data-product-handle="${data.handle}"]`
                        );

                        if (!holder) {
                            return;
                        }

                        holder.append(div);

                        // Register product template inside quick view
                        theme.sections.register("product", theme.Product, holder);

                        // Register collapsible elements
                        theme.collapsibles.init();

                        // Register potential video modal links (when video has sound)
                        theme.videoModal();

                        // There may be multiple triggers for the same modal, so enable them all
                        enableTriggers(data);
                    });
            }

            // Add ID to global array so we don't double-load
            loadedIds.push(data.id);
        }

        function moveModal(modals) {
            const el = modals[0];
            if (!el) {
                return;
            }

            // If we have multiple modals, keep the first and remove all the rest
            if (modals.length > 1) {
                modals.forEach((m, i) => {
                    if (i > 0) {
                        m.remove();
                    }
                });
            }

            const container = document.querySelector(selectors.modalContainer);
            container.appendChild(el);
        }

        // Remove any modal not already in #ProductModals
        function removeDuplicateModals(modals) {
            if (modals.length > 1) {
                modals.forEach((m, i) => {
                    if (!m.closest("#ProductModals")) {
                        m.remove();
                    }
                });
            }
        }

        function enableTriggers(data) {
            // Setup quick view modal
            const modalId = `QuickShopModal-${data.id}`;
            const name = `quick-modal-${data.id}`;
            new theme.Modals(modalId, name);

            const triggers = document.querySelectorAll(
                `${selectors.triggers}[data-handle="${data.handle}"]`
            );

            if (!triggers.length) {
                return;
            }

            triggers.forEach(trigger => {
                trigger.classList.remove("quick-product__btn--not-ready");
            });
        }

        QuickShop.prototype = {
            ...QuickShop.prototype,
            init() {
                const products = this.container.querySelectorAll(selectors.product);

                if (!products.length) {
                    return;
                }

                products.forEach(product => {
                    product.addEventListener("mouseover", productMouseover);
                });
            },
        };

        return QuickShop;
    })();

    theme.buildProductGridItem = function (items, imageSize) {
        let output = "";

        items.forEach(product => {
            const image = theme.buildProductImage(product, imageSize);
            const markup = `
        <div class="grid-item grid-product">
          <div class="grid-item__content">
            <a href="${product.url}" class="grid-item__link">
              <div class="grid-product__image-wrap">
                ${image}
              </div>
              <div class="grid-item__meta">
                <div class="grid-product__title">${product.title}</div>
              </div>
            </a>
          </div>
        </div>
      `;

            output += markup;
        });

        return output;
    };

    theme.buildProductImage = function (product, imageSize) {
        const size = imageSize || theme.settings.productImageSize;
        let output = "";

        if (size === "natural") {
            output = `
        <div class="image-wrap" style="height: 0; padding-bottom: ${product.image_aspect_ratio}%;">
          <img class="grid-product__image lazyload"
            data-src="${product.image_responsive_url}"
            data-widths="[180, 360, 540, 720, 900]"
            data-aspectratio="${product.image_aspect_ratio}"
            data-sizes="auto"
            alt="${product.title}">
        </div>`;
        } else {
            let classes = "lazyload";
            if (!theme.settings.productImageCover) {
                classes += " grid__image-contain";
            }
            output = `
        <div class="grid__image-ratio grid__image-ratio--${size}">
          <img class="${classes}"
              data-src="${product.image_responsive_url}"
              data-widths="[360, 540, 720, 900, 1080]"
              data-aspectratio="${product.aspect_ratio}"
              data-sizes="auto"
              alt="${product.title}">
        </div>
      `;
        }

        return output;
    };

    theme.buildCollectionItem = function (items) {
        let output = "";

        items.forEach(collection => {
            const markup = `
        <li>
          <a href="${collection.url}">
            ${collection.title}
          </a>
        </li>
      `;

            output += markup;
        });

        return output;
    };

    theme.buildPageItem = function (items) {
        let output = "";

        items.forEach(page => {
            const markup = `
        <li>
          <a href="${page.url}">
            ${page.title}
          </a>
        </li>
      `;

            output += markup;
        });

        return output;
    };

    theme.buildArticleItem = function (items, imageSize) {
        let output = "";

        items.forEach(article => {
            const image = theme.buildPredictiveImage(article);
            const markup = `
        <div class="grid__item small--one-half medium-up--one-quarter">
          <a href="${article.url}" class="grid-item__link grid-item__link--inline">
            <div class="grid-product__image-wrap">
              <div
                class="grid__image-ratio grid__image-ratio--object grid__image-ratio--${imageSize}">
                <div class="predictive__image-wrap">
                  ${image}
                </div>
              </div>
            </div>
            <div class="grid-item__meta">
              ${article.title}
            </div>
          </a>
        </div>
      `;

            output += markup;
        });

        return output;
    };

    theme.buildPredictiveImage = function (obj) {
        let imageMarkup = "";
        if (obj.image) {
            imageMarkup = `<img class="lazyload"
            data-src="${obj.image}"
            data-widths="[360, 540, 720]"
            data-sizes="auto">`;
        }
        return imageMarkup;
    };

    // Observer that adds visible class to animated elements
    theme.animationObserver = function () {
        const els = document.querySelectorAll(".animation-contents");

        els.forEach(el => {
            const observer = new IntersectionObserver(
                (entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            entry.target.classList.add("is-visible");
                            observer.unobserve(entry.target);
                        }
                    });
                },
                { threshold: 1 }
            );

            observer.observe(el);
        });
    };

    theme.Maps = (function () {
        const config = {
            zoom: 14,
        };
        let apiStatus = null;
        const mapsToLoad = [];

        let errors = {};

        const selectors = {
            section: '[data-section-type="map"]',
            map: "[data-map]",
            mapOverlay: ".map-section__overlay",
        };

        // Global function called by Google on auth errors.
        // Show an auto error message on all map instances.
        window.gm_authFailure = function () {
            if (!Shopify.designMode) {
                return;
            }

            document.querySelectorAll(selectors.section).forEach(section => {
                section.classList.add("map-section--load-error");
            });

            document.querySelectorAll(selectors.map).forEach(map => {
                map.parentNode.removeChild(map);
            });

            window.mapError(theme.strings.authError);
        };

        window.mapError = function (error) {
            const message = document.createElement("div");
            message.classList.add("map-section__error", "errors", "text-center");
            message.innerHTML = error;
            document.querySelectorAll(selectors.mapOverlay).forEach(overlay => {
                overlay.parentNode.prepend(message);
            });
            document.querySelectorAll(".map-section__link").forEach(link => {
                link.classList.add("hide");
            });
        };

        function Map(container) {
            this.container = container;
            this.sectionId = this.container.getAttribute("data-section-id");
            this.namespace = `.map-${this.sectionId}`;
            this.map = container.querySelector(selectors.map);
            this.key = this.map.dataset.apiKey;

            errors = {
                addressNoResults: theme.strings.addressNoResults,
                addressQueryLimit: theme.strings.addressQueryLimit,
                addressError: theme.strings.addressError,
                authError: theme.strings.authError,
            };

            if (!this.key) {
                return;
            }

            theme.initWhenVisible({
                element: this.container,
                callback: this.prepMapApi.bind(this),
                threshold: 20,
            });
        }

        // API has loaded, load all Map instances in queue
        function initAllMaps() {
            mapsToLoad.forEach(instance => {
                instance.createMap();
            });
        }

        function geolocate(map) {
            const geocoder = new google.maps.Geocoder();

            if (!map) {
                return;
            }

            const address = map.dataset.addressSetting;

            const deferred = new Promise((resolve, reject) => {
                geocoder.geocode({ address }, (results, status) => {
                    if (status !== google.maps.GeocoderStatus.OK) {
                        reject(status);
                    }
                    resolve(results);
                });
            });

            return deferred;
        }

        Map.prototype = {
            ...Map.prototype,
            prepMapApi() {
                if (apiStatus === "loaded") {
                    this.createMap();
                } else {
                    mapsToLoad.push(this);

                    if (apiStatus !== "loading") {
                        apiStatus = "loading";
                        if (
                            typeof window.google === "undefined" ||
                            typeof window.google.maps === "undefined"
                        ) {
                            const script = document.createElement("script");
                            script.onload = function () {
                                apiStatus = "loaded";
                                initAllMaps();
                            };
                            script.src = `https://maps.googleapis.com/maps/api/js?key=${this.key}`;
                            document.head.appendChild(script);
                        }
                    }
                }
            },

            createMap() {
                const mapDiv = this.map;

                return geolocate(mapDiv)
                    .then(results => {
                        const mapOptions = {
                            zoom: config.zoom,
                            backgroundColor: "none",
                            center: results[0].geometry.location,
                            draggable: false,
                            clickableIcons: false,
                            scrollwheel: false,
                            disableDoubleClickZoom: true,
                            disableDefaultUI: true,
                        };

                        const map = (this.map = new google.maps.Map(
                            mapDiv,
                            mapOptions
                        ));
                        const center = (this.center = map.getCenter());

                        const marker = new google.maps.Marker({
                            map,
                            position: map.getCenter(),
                        });

                        google.maps.event.addDomListener(
                            window,
                            "resize",
                            theme.utils.debounce(250, () => {
                                google.maps.event.trigger(map, "resize");
                                map.setCenter(center);
                                mapDiv.removeAttribute("style");
                            })
                        );

                        if (Shopify.designMode) {
                            if (window.AOS) {
                                AOS.refreshHard();
                            }
                        }
                    })
                    .catch(status => {
                        let errorMessage;

                        switch (status) {
                            case "ZERO_RESULTS":
                                errorMessage = errors.addressNoResults;
                                break;
                            case "OVER_QUERY_LIMIT":
                                errorMessage = errors.addressQueryLimit;
                                break;
                            case "REQUEST_DENIED":
                                errorMessage = errors.authError;
                                break;
                            default:
                                errorMessage = errors.addressError;
                                break;
                        }

                        // Show errors only to merchant in the editor.
                        if (Shopify.designMode) {
                            window.mapError(errorMessage);
                        }
                    });
            },

            onUnload() {
                if (this.map.length === 0) {
                    return;
                }
                // Causes a harmless JS error when a section without an active map is reloaded
                if (google && google.maps && google.maps.event) {
                    google.maps.event.clearListeners(this.map, "resize");
                }
            },
        };

        return Map;
    })();

    theme.NewsletterPopup = (function () {
        function NewsletterPopup(container) {
            this.container = container;
            const sectionId = this.container.getAttribute("data-section-id");
            this.cookieName = `newsletter-${sectionId}`;

            if (!container) {
                return;
            }

            // Prevent popup on Shopify robot challenge page
            if (window.location.pathname === "/challenge") {
                return;
            }

            // Prevent popup on password page
            if (window.location.pathname === "/password") {
                return;
            }

            this.data = {
                secondsBeforeShow: container.dataset.delaySeconds,
                daysBeforeReappear: container.dataset.delayDays,
                cookie: Cookies.get(this.cookieName),
                testMode: container.dataset.testMode,
            };

            this.modal = new theme.Modals(
                `NewsletterPopup-${sectionId}`,
                "newsletter-popup-modal"
            );

            // Set cookie if optional button is clicked
            const btn = container.querySelector(".popup-cta a");
            if (btn) {
                btn.addEventListener("click", () => {
                    this.closePopup(true);
                });
            }

            // Open modal if errors or success message exist
            if (
                container.querySelector(".errors") ||
                container.querySelector(".note--success")
            ) {
                this.modal.open();
            }

            // Set cookie as opened if success message
            if (container.querySelector(".note--success")) {
                this.closePopup(true);
                return;
            }

            document.addEventListener(
                `modalClose.${container.id}`,
                this.closePopup.bind(this)
            );

            if (!this.data.cookie || this.data.testMode === "true") {
                this.initPopupDelay();
            }
        }

        NewsletterPopup.prototype = {
            ...NewsletterPopup.prototype,
            initPopupDelay() {
                if (Shopify && Shopify.designMode) {
                    return;
                }
                setTimeout(() => {
                    this.modal.open();
                }, this.data.secondsBeforeShow * 1000);
            },

            closePopup(success) {
                // Remove a cookie in case it was set in test mode
                if (this.data.testMode === "true") {
                    Cookies.remove(this.cookieName, { path: "/" });
                    return;
                }

                const expiry = success ? 200 : this.data.daysBeforeReappear;
                Cookies.set(this.cookieName, "opened", {
                    path: "/",
                    expires: expiry,
                });
            },

            onLoad() {
                this.modal.open();
            },

            onSelect() {
                this.modal.open();
            },

            onDeselect() {
                this.modal.close();
            },
        };

        return NewsletterPopup;
    })();

    theme.PasswordHeader = (function () {
        function PasswordHeader() {
            this.init();
        }

        PasswordHeader.prototype = {
            ...PasswordHeader.prototype,
            init() {
                if (!document.querySelector("#LoginModal")) {
                    return;
                }

                const passwordModal = new theme.Modals("LoginModal", "login-modal", {
                    focusIdOnOpen: "password",
                    solid: true,
                });

                // Open modal if errors exist
                if (document.querySelectorAll(".errors").length) {
                    passwordModal.open();
                }
            },
        };

        return PasswordHeader;
    })();

    theme.Photoswipe = (function () {
        const selectors = {
            trigger: ".js-photoswipe__zoom",
            images: ".photoswipe__image",
            slideshowTrack: ".flickity-viewport ",
            activeImage: ".is-selected",
        };

        function Photoswipe(container, sectionId) {
            this.container = container;
            this.sectionId = sectionId;
            this.namespace = `.photoswipe-${this.sectionId}`;
            this.gallery;
            this.images;
            this.items;
            this.inSlideshow = false;

            if (!container || container.dataset.zoom === "false") {
                return;
            }

            this.init();
        }

        Photoswipe.prototype = {
            ...Photoswipe.prototype,
            init() {
                this.container
                    .querySelectorAll(selectors.trigger)
                    .forEach(trigger => {
                        trigger.on(
                            `click${this.namespace}`,
                            this.triggerClick.bind(this)
                        );
                    });
            },

            triggerClick(evt) {
                // Streamline changes between a slideshow and
                // stacked images, so recheck if we are still
                // working with a slideshow when initializing zoom
                if (
                    this.container.dataset &&
                    this.container.dataset.hasSlideshow === "true"
                ) {
                    this.inSlideshow = true;
                } else {
                    this.inSlideshow = false;
                }

                this.items = this.getImageData();

                const image = this.inSlideshow
                    ? this.container.querySelector(selectors.activeImage)
                    : evt.currentTarget;

                const index = this.inSlideshow
                    ? this.getChildIndex(image)
                    : image.dataset.index;

                this.initGallery(this.items, index);
            },

            // Because of image set feature, need to get index based on location in parent
            getChildIndex(el) {
                let i = 0;
                while ((el = el.previousSibling) != null) {
                    i++;
                }

                // 1-based index required
                return i + 1;
            },

            getImageData() {
                this.images = this.inSlideshow
                    ? this.container.querySelectorAll(
                          selectors.slideshowTrack + selectors.images
                      )
                    : this.container.querySelectorAll(selectors.images);

                const items = [];
                const options = {};

                this.images.forEach(el => {
                    const item = {
                        msrc: el.currentSrc || el.src,
                        src: el.getAttribute("data-photoswipe-src"),
                        w: el.getAttribute("data-photoswipe-width"),
                        h: el.getAttribute("data-photoswipe-height"),
                        el,
                        initialZoomLevel: 0.5,
                    };

                    items.push(item);
                });

                return items;
            },

            initGallery(items, index) {
                const pswpElement = document.querySelectorAll(".pswp")[0];

                const options = {
                    allowPanToNext: false,
                    captionEl: false,
                    closeOnScroll: false,
                    counterEl: false,
                    history: false,
                    index: index - 1,
                    pinchToClose: false,
                    preloaderEl: false,
                    scaleMode: "zoom",
                    shareEl: false,
                    tapToToggleControls: false,
                    getThumbBoundsFn(index) {
                        const pageYScroll =
                            window.pageYOffset || document.documentElement.scrollTop;
                        const thumbnail = items[index].el;
                        const rect = thumbnail.getBoundingClientRect();
                        return {
                            x: rect.left,
                            y: rect.top + pageYScroll,
                            w: rect.width,
                        };
                    },
                };

                this.gallery = new PhotoSwipe(
                    pswpElement,
                    PhotoSwipeUI_Default,
                    items,
                    options
                );
                this.gallery.listen("afterChange", this.afterChange.bind(this));
                this.gallery.init();

                this.preventiOS15Scrolling();
            },

            afterChange() {
                const index = this.gallery.getCurrentIndex();
                this.container.dispatchEvent(
                    new CustomEvent("photoswipe:afterChange", {
                        detail: {
                            index,
                        },
                    })
                );
            },

            syncHeight() {
                document.documentElement.style.setProperty(
                    "--window-inner-height",
                    `${window.innerHeight}px`
                );
            },

            // Fix poached from https://gist.github.com/dimsemenov/0b8c255c0d87f2989e8ab876073534ea
            preventiOS15Scrolling() {
                let initialScrollPos;

                if (!/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) return;

                this.syncHeight();

                // Store scroll position to restore it later
                initialScrollPos = window.scrollY;

                // Add class to root element when PhotoSwipe opens
                document.documentElement.classList.add("pswp-open-in-ios");

                window.addEventListener("resize", this.syncHeight);

                this.gallery.listen("destroy", () => {
                    document.documentElement.classList.remove("pswp-open-in-ios");
                    window.scrollTo(0, initialScrollPos);
                });
            },
        };

        return Photoswipe;
    })();

    theme.Recommendations = (function () {
        const selectors = {
            placeholder: ".product-recommendations-placeholder",
            sectionClass: " .product-recommendations",
            productResults: ".grid-product",
        };

        function Recommendations(container) {
            this.container = container;
            this.sectionId = container.getAttribute("data-section-id");
            this.url = container.dataset.url;

            selectors.recommendations = `Recommendations-${this.sectionId}`;

            theme.initWhenVisible({
                element: container,
                callback: this.init.bind(this),
                threshold: 500,
            });
        }

        Recommendations.prototype = {
            ...Recommendations.prototype,
            init() {
                const section = document.getElementById(selectors.recommendations);

                if (!section || section.dataset.enable === "false") {
                    return;
                }

                const id = section.dataset.productId;
                const { limit } = section.dataset;

                const url = `${this.url}?section_id=product-recommendations&limit=${limit}&product_id=${id}`;

                // When section his hidden and shown, make sure it starts empty
                if (Shopify.designMode) {
                    const wrapper = section.querySelector(selectors.sectionClass);
                    if (wrapper) {
                        wrapper.innerHTML = "";
                    }
                }

                fetch(url)
                    .then(response => response.text())
                    .then(html => {
                        // Convert the HTML string into a document object
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, "text/html");
                        const div = doc.querySelector(selectors.sectionClass);
                        const placeholder = section.querySelector(
                            selectors.placeholder
                        );
                        if (!placeholder) {
                            return;
                        }

                        placeholder.innerHTML = "";

                        if (!div) {
                            this.container.classList.add("hide");
                            if (AOS) {
                                AOS.refreshHard();
                            }
                            return;
                        }

                        placeholder.appendChild(div);

                        theme.reinitProductGridItem(section);

                        document.dispatchEvent(
                            new CustomEvent("recommendations:loaded", {
                                detail: {
                                    section,
                                },
                            })
                        );

                        // If no results, hide the entire section
                        const results = div.querySelectorAll(
                            selectors.productResults
                        );
                        if (results.length === 0) {
                            this.container.classList.add("hide");
                        }
                    });
            },
        };

        return Recommendations;
    })();

    theme.SlideshowSection = (function () {
        const selectors = {
            parallaxContainer: ".parallax-container",
        };

        function SlideshowSection(container) {
            this.container = container;
            const sectionId = container.getAttribute("data-section-id");
            this.slideshow = container.querySelector(`#Slideshow-${sectionId}`);
            this.namespace = `.${sectionId}`;

            this.initialIndex = 0;

            if (!this.slideshow) {
                return;
            }

            // Get shopify-created div that section markup lives in,
            // then get index of it inside its parent
            const sectionEl = container.parentElement;
            const sectionIndex = [].indexOf.call(
                sectionEl.parentElement.children,
                sectionEl
            );

            if (sectionIndex === 0) {
                this.init();
            } else {
                theme.initWhenVisible({
                    element: this.container,
                    callback: this.init.bind(this),
                });
            }
        }

        SlideshowSection.prototype = {
            ...SlideshowSection.prototype,
            init() {
                const slides = this.slideshow.querySelectorAll(".slideshow__slide");

                if (this.container.hasAttribute("data-immediate-load")) {
                    this.slideshow.classList.remove("loading", "loading--delayed");
                    this.slideshow.classList.add("loaded");
                } else {
                    // Wait for image to load before marking as done
                    theme.loadImageSection(this.slideshow);
                }

                if (slides.length > 1) {
                    const sliderArgs = {
                        prevNextButtons: this.slideshow.hasAttribute("data-arrows"),
                        pageDots: this.slideshow.hasAttribute("data-dots"),
                        fade: true,
                        setGallerySize: false,
                        initialIndex: this.initialIndex,
                        autoPlay:
                            this.slideshow.dataset.autoplay === "true"
                                ? parseInt(this.slideshow.dataset.speed)
                                : false,
                    };

                    this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
                } else {
                    // Add loaded class to first slide
                    slides[0].classList.add("is-selected");
                }

                if (this.container.hasAttribute("data-parallax")) {
                    // Create new parallax for each slideshow image
                    this.container
                        .querySelectorAll(selectors.parallaxContainer)
                        .forEach((el, i) => {
                            new theme.Parallax(el, {
                                namespace: `${this.namespace}-parallax-${i}`,
                            });
                        });
                }
            },

            forceReload() {
                this.onUnload();
                this.init();
            },

            onUnload() {
                if (this.flickity && typeof this.flickity.destroy === "function") {
                    this.flickity.destroy();
                }
            },

            onDeselect() {
                if (this.flickity && typeof this.flickity.play === "function") {
                    this.flickity.play();
                }
            },

            onBlockSelect(evt) {
                const slide = this.slideshow.querySelector(
                    `.slideshow__slide--${evt.detail.blockId}`
                );
                const index = parseInt(slide.dataset.index);

                if (this.flickity && typeof this.flickity.pause === "function") {
                    this.flickity.goToSlide(index);
                    this.flickity.pause();
                } else {
                    // If section reloads, slideshow might not have been setup yet, wait a second and try again
                    this.initialIndex = index;
                    setTimeout(() => {
                        if (
                            this.flickity &&
                            typeof this.flickity.pause === "function"
                        ) {
                            this.flickity.pause();
                        }
                    }, 1000);
                }
            },

            onBlockDeselect() {
                if (this.flickity && typeof this.flickity.play === "function") {
                    if (this.flickity.args.autoPlay) {
                        this.flickity.play();
                    }
                }
            },
        };

        return SlideshowSection;
    })();

    theme.StoreAvailability = (function () {
        const selectors = {
            drawerOpenBtn: ".js-drawer-open-availability",
            modalOpenBtn: ".js-modal-open-availability",
            productTitle: "[data-availability-product-title]",
        };

        function StoreAvailability(container) {
            this.container = container;
            this.baseUrl = container.dataset.baseUrl;
            this.productTitle = container.dataset.productName;
        }

        StoreAvailability.prototype = {
            ...StoreAvailability.prototype,
            updateContent(variantId) {
                const variantSectionUrl = `${this.baseUrl}/variants/${variantId}/?section_id=store-availability`;

                const self = this;

                fetch(variantSectionUrl)
                    .then(response => response.text())
                    .then(function (html) {
                        if (html.trim() === "") {
                            this.container.innerHTML = "";
                            return;
                        }

                        self.container.innerHTML = html;
                        self.container.innerHTML =
                            self.container.firstElementChild.innerHTML;

                        // Setup drawer if have open button
                        if (self.container.querySelector(selectors.drawerOpenBtn)) {
                            self.drawer = new theme.Drawers(
                                "StoreAvailabilityDrawer",
                                "availability"
                            );
                        }

                        // Setup modal if have open button
                        if (self.container.querySelector(selectors.modalOpenBtn)) {
                            self.modal = new theme.Modals(
                                "StoreAvailabilityModal",
                                "availability"
                            );
                        }

                        const title = self.container.querySelector(
                            selectors.productTitle
                        );
                        if (title) {
                            title.textContent = self.productTitle;
                        }
                    });
            },
        };

        return StoreAvailability;
    })();

    theme.VideoSection = (function () {
        const selectors = {
            videoParent: ".video-parent-section",
        };

        function videoSection(container) {
            this.container = container;
            this.sectionId = container.getAttribute("data-section-id");
            this.namespace = `.video-${this.sectionId}`;
            this.videoObject;

            theme.initWhenVisible({
                element: this.container,
                callback: this.init.bind(this),
                threshold: 500,
            });
        }

        videoSection.prototype = {
            ...videoSection.prototype,
            init() {
                const dataDiv = this.container.querySelector(".video-div");
                if (!dataDiv) {
                    return;
                }
                const { type } = dataDiv.dataset;

                switch (type) {
                    case "youtube":
                        var { videoId } = dataDiv.dataset;
                        this.initYoutubeVideo(videoId);
                        break;
                    case "vimeo":
                        var { videoId } = dataDiv.dataset;
                        this.initVimeoVideo(videoId);
                        break;
                    case "mp4":
                        this.initMp4Video();
                        break;
                }
            },

            initYoutubeVideo(videoId) {
                this.videoObject = new theme.YouTube(
                    `YouTubeVideo-${this.sectionId}`,
                    {
                        videoId,
                        videoParent: selectors.videoParent,
                    }
                );
            },

            initVimeoVideo(videoId) {
                this.videoObject = new theme.VimeoPlayer(
                    `Vimeo-${this.sectionId}`,
                    videoId,
                    {
                        videoParent: selectors.videoParent,
                    }
                );
            },

            initMp4Video() {
                const mp4Video = `Mp4Video-${this.sectionId}`;
                const mp4Div = document.getElementById(mp4Video);
                const parent = mp4Div.closest(selectors.videoParent);

                if (mp4Div) {
                    parent.classList.add("loaded");

                    const playPromise = document
                        .querySelector(`#${mp4Video}`)
                        .play();

                    // Edge does not return a promise (video still plays)
                    if (playPromise !== undefined) {
                        playPromise
                            .then(() => {
                                // playback normal
                            })
                            .catch(() => {
                                mp4Div.setAttribute("controls", "");
                                parent.classList.add("video-interactable");
                            });
                    }
                }
            },

            onUnload(evt) {
                const sectionId = evt.target.id.replace("shopify-section-", "");
                if (
                    this.videoObject &&
                    typeof this.videoObject.destroy === "function"
                ) {
                    this.videoObject.destroy();
                }
            },
        };

        return videoSection;
    })();

    theme.BackgroundImage = (function () {
        const selectors = {
            parallaxContainer: ".parallax-container",
        };

        function backgroundImage(container) {
            this.container = container;
            if (!container) {
                return;
            }

            const sectionId = container.getAttribute("data-section-id");
            this.namespace = `.${sectionId}`;

            theme.initWhenVisible({
                element: this.container,
                callback: this.init.bind(this),
            });
        }

        backgroundImage.prototype = {
            ...backgroundImage.prototype,
            init() {
                theme.loadImageSection(this.container);

                if (this.container.dataset && this.container.dataset.parallax) {
                    const parallaxContainer = this.container.querySelector(
                        selectors.parallaxContainer
                    );
                    const args = {
                        namespace: `${this.namespace}-parallax`,
                        desktopOnly: true,
                    };

                    theme.parallaxSections[this.namespace] = new theme.Parallax(
                        parallaxContainer,
                        args
                    );
                }
            },

            onUnload(evt) {
                if (!this.container) {
                    return;
                }
                if (
                    theme.parallaxSections[this.namespace] &&
                    typeof theme.parallaxSections[this.namespace].destroy ===
                        "function"
                ) {
                    theme.parallaxSections[this.namespace].destroy();
                }
                delete theme.parallaxSections[this.namespace];
            },
        };

        return backgroundImage;
    })();

    theme.CollectionHeader = (function () {
        let hasLoadedBefore = false;

        function CollectionHeader(container) {
            this.namespace = ".collection-header";

            const heroImageContainer = container.querySelector(".collection-hero");
            if (heroImageContainer) {
                if (hasLoadedBefore) {
                    this.checkIfNeedReload();
                }
                theme.loadImageSection(heroImageContainer);

                if (container.dataset && container.dataset.parallax) {
                    const parallaxContainer =
                        container.querySelector(".parallax-container");
                    const args = {
                        namespace: `${this.namespace}-parallax`,
                    };
                    theme.parallaxSections[this.namespace] = new theme.Parallax(
                        parallaxContainer,
                        args
                    );
                }
            } else if (theme.settings.overlayHeader) {
                theme.headerNav.disableOverlayHeader();
            }

            hasLoadedBefore = true;
        }

        CollectionHeader.prototype = {
            ...CollectionHeader.prototype, // A liquid variable in the header needs a full page refresh
            // if the collection header hero image setting is enabled
            // and the header is set to sticky. Only necessary in the editor.
            checkIfNeedReload() {
                if (!Shopify.designMode) {
                    return;
                }

                if (theme.settings.overlayHeader) {
                    const header = document.querySelector(".header-wrapper");
                    if (!header.classList.contains("header-wrapper--overlay")) {
                        location.reload();
                    }
                }
            },

            onUnload() {
                if (theme.parallaxSections[this.namespace]) {
                    theme.parallaxSections[this.namespace].destroy();
                    delete theme.parallaxSections[this.namespace];
                }
            },
        };

        return CollectionHeader;
    })();

    theme.CollectionSidebar = (function () {
        const selectors = {
            sidebarId: "CollectionSidebar",
            trigger: ".collection-filter__btn",
            mobileWrapper: "#CollectionInlineFilterWrap",
            filters: ".filter-wrapper",
            filterBar: ".collection-filter",
        };

        const config = {
            isOpen: false,
            namespace: ".collection-filters",
        };

        function CollectionSidebar() {
            // Do not load when no sidebar exists
            if (!document.getElementById(selectors.sidebarId)) {
                return;
            }

            document.addEventListener("filter:selected", this.close.bind(this));
            this.init();
        }

        function getScrollFilterTop() {
            const scrollTop =
                window.pageYOffset || document.documentElement.scrollTop;
            const elTop = document
                .querySelector(selectors.filterBar)
                .getBoundingClientRect().top;
            return elTop + scrollTop;
        }

        // Set a max-height on drawers when they're opened via CSS variable
        // to account for changing mobile window heights
        function sizeDrawer() {
            const header = document.getElementById("HeaderWrapper").offsetHeight;
            const filters = document.querySelector(selectors.filterBar).offsetHeight;
            const max = window.innerHeight - header - filters;
            document.documentElement.style.setProperty(
                "--maxFiltersHeight",
                `${max}px`
            );
        }

        CollectionSidebar.prototype = {
            ...CollectionSidebar.prototype,
            init() {
                config.isOpen = false;
                theme.a11y.unlockMobileScrolling(config.namespace);

                // This function runs on page load, and when the collection section loads
                // so we need to be mindful of not duplicating event listeners
                this.container = document.getElementById(selectors.sidebarId);
                this.trigger = document.querySelector(selectors.trigger);
                this.wrapper = document.querySelector(selectors.mobileWrapper);
                this.filters = this.wrapper.querySelector(selectors.filters);

                this.trigger.off("click");
                this.trigger.on("click", this.toggle.bind(this));
            },

            /*= ===========================================================================
        Open and close filter drawer
      ============================================================================== */
            toggle() {
                if (config.isOpen) {
                    this.close();
                } else {
                    this.open();
                }
            },

            open() {
                sizeDrawer();

                // Scroll to top of filter bar when opened
                const scrollTo = getScrollFilterTop();
                window.scrollTo({ top: scrollTo, behavior: "smooth" });

                this.trigger.classList.add("is-active");

                theme.utils.prepareTransition(this.filters, () => {
                    this.filters.classList.add("is-active");
                });
                config.isOpen = true;

                theme.a11y.lockMobileScrolling(config.namespace);

                window.on(`keyup${config.namespace}`, evt => {
                    if (evt.keyCode === 27) {
                        this.close();
                    }
                });
            },

            close() {
                this.trigger.classList.remove("is-active");

                theme.utils.prepareTransition(this.filters, () => {
                    this.filters.classList.remove("is-active");
                });
                config.isOpen = false;

                theme.a11y.unlockMobileScrolling(config.namespace);

                window.off(`keyup${config.namespace}`);
            },

            onSelect() {
                this.open();
            },

            onDeselect() {
                this.close();
            },
        };

        return CollectionSidebar;
    })();

    /*= ===========================================================================
    Collection JS sets up grids of products, even if not
    on the collection template.
    When on the collection template, also setup sorting, filters, grid options
  ============================================================================== */
    theme.Collection = (function () {
        let isAnimating = false;

        const selectors = {
            sortSelect: "#SortBy",
            sortBtn: ".filter-sort",

            colorSwatchImage: ".grid-product__color-image",
            colorSwatch: ".color-swatch--with-image",

            viewChange: ".grid-view-btn",
            productGrid: ".product-grid",

            collectionGrid: ".collection-grid__wrapper",
            sidebar: "#CollectionSidebar",
            activeTagList: ".tag-list--active-tags",
            tags: ".tag-list input",
            activeTags: ".tag-list a",
            tagsForm: ".filter-form",
            filterBar: ".collection-filter",
            priceRange: ".price-range",
            trigger: ".collapsible-trigger",

            filters: ".filter-wrapper",
            sidebarWrapper: "#CollectionSidebarFilterWrap",
            inlineWrapper: "#CollectionInlineFilterWrap",
        };

        const config = {
            mobileFiltersInPlace: false,
        };

        const classes = {
            activeTag: "tag--active",
            removeTagParent: "tag--remove",
            collapsibleContent: "collapsible-content",
            isOpen: "is-open",
        };

        function Collection(container) {
            this.container = container;
            this.containerId = container.id;
            this.sectionId = container.getAttribute("data-section-id");
            this.namespace = `.collection-${this.sectionId}`;
            this.isCollectionTemplate = this.container.dataset.collectionTemplate;
            this.ajaxRenderer = new theme.AjaxRenderer({
                sections: [
                    { sectionId: this.sectionId, nodeId: "CollectionAjaxContent" },
                ],
                onReplace: this.onReplaceAjaxContent.bind(this),
            });

            this.init(container);
        }

        Collection.prototype = {
            ...Collection.prototype,
            init(container) {
                config.mobileFiltersInPlace = false;

                // If container not set, section has been reinitialized.
                // Update this.container to refreshed DOM element
                if (!container) {
                    this.container = document.getElementById(this.containerId);
                }

                if (this.isCollectionTemplate) {
                    this.cloneFiltersOnMobile();
                    this.initSort();
                    this.initFilters();
                    this.initPriceRange();
                    this.initGridOptions();

                    // Has to init after the Collection JS because cloneFiltersOnMobile
                    this.sidebar = new theme.CollectionSidebar();
                }

                this.quickAdd = new theme.QuickAdd(this.container);
                this.quickShop = new theme.QuickShop(this.container);

                this.colorImages = this.container.querySelectorAll(
                    selectors.colorSwatchImage
                );
                if (this.colorImages.length) {
                    this.swatches = this.container.querySelectorAll(
                        selectors.colorSwatch
                    );
                    this.colorSwatchHovering();
                }
            },

            /*= ===========================================================================
        Collection sorting
      ============================================================================== */
            initSort() {
                this.queryParams = new URLSearchParams(window.location.search);
                this.sortSelect = document.querySelector(selectors.sortSelect);
                this.sortBtns = document.querySelectorAll(selectors.sortBtn);

                if (this.sortSelect) {
                    this.defaultSort = this.getDefaultSortValue();
                    this.sortSelect.on(`change${this.namespace}`, () => {
                        this.onSortChange();
                    });
                }

                if (this.sortBtns.length) {
                    this.sortBtns.forEach(btn => {
                        btn.addEventListener("click", () => {
                            document.dispatchEvent(new Event("filter:selected"));
                            const sortValue = btn.dataset.value;
                            this.onSortChange(sortValue);
                        });
                    });
                }
            },

            getSortValue() {
                return this.sortSelect.value || this.defaultSort;
            },

            getDefaultSortValue() {
                return this.sortSelect.getAttribute("data-default-sortby");
            },

            onSortChange(sortValue = null) {
                this.queryParams = new URLSearchParams(window.location.search);

                if (sortValue) {
                    this.queryParams.set("sort_by", sortValue);
                } else {
                    this.queryParams.set("sort_by", this.getSortValue());
                }

                this.queryParams.delete("page"); // Delete if it exists
                window.location.search = this.queryParams.toString();
            },

            /*= ===========================================================================
        Color swatch hovering
      ============================================================================== */
            colorSwatchHovering() {
                this.swatches.forEach(swatch => {
                    swatch.addEventListener("mouseenter", () => {
                        this.setActiveColorImage(swatch);
                    });

                    swatch.addEventListener(
                        "touchstart",
                        evt => {
                            evt.preventDefault();
                            this.setActiveColorImage(swatch);
                        },
                        { passive: true }
                    );
                });
            },

            setActiveColorImage(swatch) {
                const id = swatch.dataset.variantId;
                const image = swatch.dataset.variantImage;

                // Unset all active swatch images
                this.colorImages.forEach(el => {
                    el.classList.remove("is-active");
                });

                // Unset all active swatches
                this.swatches.forEach(el => {
                    el.classList.remove("is-active");
                });

                // Set active image and swatch
                const imageEl = this.container.querySelector(
                    `.grid-product__color-image--${id}`
                );
                imageEl.style.backgroundImage = `url(${image})`;
                imageEl.classList.add("is-active");
                swatch.classList.add("is-active");

                // Update product grid item href with variant URL
                const variantUrl = swatch.dataset.url;
                const gridItem = swatch.closest(".grid-item__link");
                gridItem.setAttribute("href", variantUrl);
            },

            /*= ===========================================================================
        Grid view options
      ============================================================================== */
            initGridOptions() {
                const grid = this.container.querySelector(selectors.productGrid);
                const viewBtns = this.container.querySelectorAll(
                    selectors.viewChange
                );
                this.container
                    .querySelectorAll(selectors.viewChange)
                    .forEach(btn => {
                        btn.addEventListener("click", () => {
                            viewBtns.forEach(el => {
                                el.classList.remove("is-active");
                            });
                            btn.classList.add("is-active");
                            const newView = btn.dataset.view;
                            grid.dataset.view = newView;

                            // Set as cart attribute so we can access in liquid
                            theme.cart.updateAttribute("product_view", newView);

                            // Trigger resize to update layzloaded images
                            window.dispatchEvent(new Event("resize"));
                        });
                    });
            },

            /*= ===================
        Collection filters
      ==================== */
            initFilters() {
                const tags = document.querySelectorAll(selectors.tags);

                if (!tags.length) {
                    return;
                }

                document.addEventListener(
                    "matchSmall",
                    this.cloneFiltersOnMobile.bind(this)
                );
                this.bindBackButton();

                // Set mobile top value for filters if sticky header enabled
                if (theme.config.stickyHeader) {
                    this.setFilterStickyPosition();

                    document.addEventListener(
    "headerStickyChange",
    () => this.setFilterStickyPosition()
);
                    window.on(
                        "resize",
                        theme.utils.debounce(500, this.setFilterStickyPosition)
                    );
                }

                document.querySelectorAll(selectors.activeTags).forEach(tag => {
                    tag.addEventListener("click", this.onTagClick.bind(this));
                });

                document.querySelectorAll(selectors.tagsForm).forEach(form => {
                    form.addEventListener("input", this.onFormSubmit.bind(this));
                });
            },

            initPriceRange() {
                const priceRangeEls = document.querySelectorAll(
                    selectors.priceRange
                );
                priceRangeEls.forEach(
                    el =>
                        new theme.PriceRange(el, {
                            // onChange passes in formData
                            onChange: this.renderFromFormData.bind(this),
                        })
                );
            },

            cloneFiltersOnMobile() {
                if (config.mobileFiltersInPlace) {
                    return;
                }

                const sidebarWrapper = document.querySelector(
                    selectors.sidebarWrapper
                );
                if (!sidebarWrapper) {
                    return;
                }
                const filters = sidebarWrapper
                    .querySelector(selectors.filters)
                    .cloneNode(true);

                const inlineWrapper = document.querySelector(
                    selectors.inlineWrapper
                );

                inlineWrapper.innerHTML = "";
                inlineWrapper.append(filters);

                // Update collapsible JS
                theme.collapsibles.init(inlineWrapper);

                config.mobileFiltersInPlace = true;
            },

            renderActiveTag(parent, el) {
                const textEl = parent.querySelector(".tag__text");

                if (parent.classList.contains(classes.activeTag)) {
                    parent.classList.remove(classes.activeTag);
                } else {
                    parent.classList.add(classes.activeTag);

                    // If adding a tag, show new tag right away.
                    // Otherwise, remove it before ajax finishes
                    if (
                        el.closest("li").classList.contains(classes.removeTagParent)
                    ) {
                        parent.remove();
                    } else {
                        // Append new tag in both drawer and sidebar
                        document
                            .querySelectorAll(selectors.activeTagList)
                            .forEach(list => {
                                const newTag = document.createElement("li");
                                const newTagLink = document.createElement("a");
                                newTag.classList.add("tag", "tag--remove");
                                newTagLink.classList.add("btn", "btn--small");
                                newTagLink.innerText = textEl.innerText;
                                newTag.appendChild(newTagLink);

                                list.appendChild(newTag);
                            });
                    }
                }
            },

            onTagClick(evt) {
                const el = evt.currentTarget;

                document.dispatchEvent(new Event("filter:selected"));

                // Do not ajax-load collection links
                if (el.classList.contains("no-ajax")) {
                    return;
                }

                evt.preventDefault();
                if (isAnimating) {
                    return;
                }

                isAnimating = true;

                const parent = el.parentNode;
                const newUrl = new URL(el.href);

                this.renderActiveTag(parent, el);
                this.updateScroll(true);
                this.startLoading();
                this.renderCollectionPage(newUrl.searchParams);
            },

            onFormSubmit(evt) {
                const el = evt.target;

                document.dispatchEvent(new Event("filter:selected"));

                // Do not ajax-load collection links
                if (el.classList.contains("no-ajax")) {
                    return;
                }

                evt.preventDefault();
                if (isAnimating) {
                    return;
                }

                isAnimating = true;

                const parent = el.closest("li");
                const formEl = el.closest("form");
                const formData = new FormData(formEl);

                this.renderActiveTag(parent, el);
                this.updateScroll(true);
                this.startLoading();
                this.renderFromFormData(formData);
            },

            onReplaceAjaxContent(newDom, section) {
                const openCollapsibleIds = this.fetchOpenCollasibleFilters();

                openCollapsibleIds.forEach(selector => {
                    newDom
                        .querySelectorAll(`[data-collapsible-id=${selector}]`)
                        .forEach(this.openCollapsible);
                });

                const newContentEl = newDom.getElementById(section.nodeId);
                if (!newContentEl) {
                    return;
                }

                document.getElementById(section.nodeId).innerHTML =
                    newContentEl.innerHTML;

                // Update references to new product count in collection
                const page = document.getElementById(section.nodeId);
                const countEl = page.querySelector(
                    ".collection-filter__item--count"
                );
                if (countEl) {
                    const count = countEl.innerText;
                    document
                        .querySelectorAll("[data-collection-count]")
                        .forEach(el => {
                            el.innerText = count;
                        });
                }
            },

            renderFromFormData(formData) {
                const searchParams = new URLSearchParams(formData);
                this.renderCollectionPage(searchParams);
            },

            renderCollectionPage(searchParams, updateURLHash = true) {
                this.ajaxRenderer
                    .renderPage(
                        window.location.pathname,
                        searchParams,
                        updateURLHash
                    )
                    .then(() => {
                        theme.sections.reinit("collection-template");
                        this.updateScroll(false);
                        this.initPriceRange();
                        theme.reinitProductGridItem();

                        document.dispatchEvent(
                            new CustomEvent("collection:reloaded")
                        );

                        isAnimating = false;
                    });
            },

            updateScroll(animate) {
                let scrollTo = document.getElementById(
                    "CollectionAjaxContent"
                ).offsetTop;

                // Scroll below the sticky header
                if (theme.config.stickyHeader) {
                    scrollTo -= document.querySelector("#SiteHeader").offsetHeight;
                }

                if (!theme.config.bpSmall) {
                    scrollTo -= 10;
                }

                if (animate) {
                    window.scrollTo({ top: scrollTo, behavior: "smooth" });
                } else {
                    window.scrollTo({ top: scrollTo });
                }
            },

            bindBackButton() {
                // Ajax page on back button
                window.off(`popstate${this.namespace}`);
                window.on(`popstate${this.namespace}`, state => {
                    if (state) {
                        const newUrl = new URL(window.location.href);
                        this.renderCollectionPage(newUrl.searchParams, false);
                    }
                });
            },

            fetchOpenCollasibleFilters() {
                const openDesktopCollapsible = Array.from(
                    document.querySelectorAll(
                        `${selectors.sidebar} ${selectors.trigger}.${classes.isOpen}`
                    )
                );

                const openMobileCollapsible = Array.from(
                    document.querySelectorAll(
                        `${selectors.inlineWrapper} ${selectors.trigger}.${classes.isOpen}`
                    )
                );

                return [...openDesktopCollapsible, ...openMobileCollapsible].map(
                    trigger => trigger.dataset.collapsibleId
                );
            },

            openCollapsible(el) {
                if (el.classList.contains(classes.collapsibleContent)) {
                    el.style.height = "auto";
                }

                el.classList.add(classes.isOpen);
            },

            /*= ===========================================================================
        Misc collection page helpers
      ============================================================================== */
            setFilterStickyPosition() {
                const header = document.querySelector("#SiteHeader");
const wrapper = document.querySelector("#HeaderWrapper");
const isMobile = window.matchMedia("(max-width: 768px)").matches;

let headerHeight = header.offsetHeight - 1;

if (isMobile) {
    const topRow = header.querySelector(".site-header__element--top");
    const searchRow = header.querySelector('[data-type="search"]');
    const searchHidden = wrapper.classList.contains(
        "header-wrapper--compressed"
    );

    headerHeight = Math.max(
        0,
        (topRow ? topRow.offsetHeight : 0) +
        (!searchHidden && searchRow ? searchRow.offsetHeight : 0) - 1
    );
}
                document.querySelector(
                    selectors.filterBar
                ).style.top = `${headerHeight}px`;

                // Also update top position of sticky sidebar
                const stickySidebar = document.querySelector(".grid__item--sidebar");
                if (stickySidebar) {
                    stickySidebar.style.top = `${headerHeight + 30}px`;
                }
            },

            startLoading() {
                document
                    .querySelector(selectors.collectionGrid)
                    .classList.add("unload");
            },

            forceReload() {
                this.init(this.container);
            },
        };

        return Collection;
    })();

    theme.FooterSection = (function () {
        const selectors = {
            locale: "[data-disclosure-locale]",
            currency: "[data-disclosure-currency]",
        };

        const ids = {
            mobileNav: "MobileNav",
            footerNavWrap: "FooterMobileNavWrap",
            footerNav: "FooterMobileNav",
        };

        function FooterSection(container) {
            this.container = container;
            this.localeDisclosure = null;
            this.currencyDisclosure = null;

            theme.initWhenVisible({
                element: this.container,
                callback: this.init.bind(this),
                threshold: 1000,
            });
        }

        FooterSection.prototype = {
            ...FooterSection.prototype,
            init() {
                const localeEl = this.container.querySelector(selectors.locale);
                const currencyEl = this.container.querySelector(selectors.currency);

                if (localeEl) {
                    this.localeDisclosure = new theme.Disclosure(localeEl);
                }

                if (currencyEl) {
                    this.currencyDisclosure = new theme.Disclosure(currencyEl);
                }

                // If on mobile, copy the mobile nav to the footer
                if (theme.config.bpSmall) {
                    this.initDoubleMobileNav();
                }

                // Re-hook up collapsible box triggers
                theme.collapsibles.init(this.container);
            },

            initDoubleMobileNav() {
                const menuPlaceholder = document.getElementById(ids.footerNavWrap);
                if (!menuPlaceholder) {
                    return;
                }

                const mobileNav = document.getElementById(ids.mobileNav);
                const footerNav = document.getElementById(ids.footerNav);
                const clone = mobileNav.cloneNode(true);
                const navEl = clone.querySelector(".slide-nav__wrapper");

                // Append cloned nav to footer, initialize JS, then show it
                footerNav.appendChild(navEl);
                new theme.MobileNav({
                    id: ids.footerNav,
                    inHeader: false,
                });

                menuPlaceholder.classList.remove("hide");
            },

            onUnload() {
                if (this.localeDisclosure) {
                    this.localeDisclosure.destroy();
                }

                if (this.currencyDisclosure) {
                    this.currencyDisclosure.destroy();
                }
            },
        };

        return FooterSection;
    })();

    theme.HeaderSection = (function () {
        const selectors = {
            headerFooter: "#MobileNavFooter",
            footerMenus: "#FooterMenus",
        };

        const namespace = ".header";

        function HeaderSection(container) {
            this.container = container;
            this.sectionId = this.container.getAttribute("data-section-id");

            this.init();
        }

        HeaderSection.prototype = {
            ...HeaderSection.prototype,
            init() {
                // Reload any slideshow if header is reloaded to make sure
                // sticky header works as expected
                // (can be anywhere in sections.instance array)
                if (Shopify && Shopify.designMode) {
                    theme.sections.reinit("slideshow-section");

                    // Set a timer to resize the header in case the logo changes size
                    setTimeout(() => {
                        window.dispatchEvent(new Event("resize"));
                    }, 500);
                }

                theme.headerNav.init();
                theme.announcementBar.init();
                theme.headerSearch.init();

                // Enable header cart drawer when not on cart page
                if (!document.body.classList.contains("template-cart")) {
                    new theme.HeaderCart();
                }
                new theme.MobileNav({
                    id: "MobileNav",
                    inHeader: true,
                });

                if (theme.config.bpSmall) {
                    this.cloneFooter();
                }

                window.on(
                    `resize${namespace}`,
                    theme.utils.debounce(300, theme.sizeDrawer)
                );
            },

            cloneFooter() {
                const headerFooter = document.querySelector(selectors.headerFooter);
                if (!headerFooter) {
                    return;
                }

                const footerMenus = document.querySelector(selectors.footerMenus);

                const clone = footerMenus.cloneNode(true);
                clone.id = "";

                // Append cloned footer menus to mobile nav
                headerFooter.appendChild(clone);

                // If localization form, update IDs so they don't match footer
                const localizationForm =
                    headerFooter.querySelector(".multi-selectors");
                if (localizationForm) {
                    // Loop disclosure buttons and update ids and aria attributes
                    localizationForm
                        .querySelectorAll("[data-disclosure-toggle]")
                        .forEach(el => {
                            const controls = el.getAttribute("aria-controls");
                            const describedby = el.getAttribute("aria-describedby");

                            el.setAttribute("aria-controls", `${controls}-header`);
                            el.setAttribute(
                                "aria-describedby",
                                `${describedby}-header`
                            );

                            const list = document.getElementById(controls);
                            if (list) {
                                list.id = `${controls}-header`;
                            }

                            const label = document.getElementById(describedby);
                            if (label) {
                                label.id = `${describedby}-header`;
                            }

                            // Initialize language/currency selectors
                            const parent = el.parentNode;
                            if (parent) {
                                new theme.Disclosure(parent);
                            }
                        });
                }
            },

            onUnload() {},
        };

        return HeaderSection;
    })();

    theme.Toolbar = (function () {
        const selectors = {
            locale: "[data-disclosure-locale]",
            currency: "[data-disclosure-currency]",
        };

        function Toolbar(container) {
            this.container = container;
            this.sectionId = this.container.getAttribute("data-section-id");

            this.init();
        }

        Toolbar.prototype = {
            ...Toolbar.prototype,
            init() {
                this.initDisclosures();
                theme.announcementBar.init();
            },

            initDisclosures() {
                const localeEl = this.container.querySelector(selectors.locale);
                const currencyEl = this.container.querySelector(selectors.currency);

                if (localeEl) {
                    this.localeDisclosure = new theme.Disclosure(localeEl);
                }

                if (currencyEl) {
                    this.currencyDisclosure = new theme.Disclosure(currencyEl);
                }
            },

            onBlockSelect(evt) {
                theme.announcementBar.onBlockSelect(evt.detail.blockId);
            },

            onBlockDeselect() {
                theme.announcementBar.onBlockDeselect();
            },

            onUnload() {
                theme.announcementBar.unload();

                if (this.localeDisclosure) {
                    this.localeDisclosure.destroy();
                }

                if (this.currencyDisclosure) {
                    this.currencyDisclosure.destroy();
                }
            },
        };

        return Toolbar;
    })();

    theme.Product = (function () {
        const videoObjects = {};

        const classes = {
            onSale: "on-sale",
            disabled: "disabled",
            isModal: "is-modal",
            loading: "loading",
            loaded: "loaded",
            hidden: "hide",
            interactable: "video-interactable",
            visuallyHide: "visually-invisible",
        };

        const selectors = {
            productVideo: ".product__video",
            videoParent: ".product__video-wrapper",
            slide: ".product-main-slide",
            currentSlide: ".is-selected",
            startingSlide: ".starting-slide",
            variantType: ".variant-wrapper",
            blocks: "[data-product-blocks]",
            blocksHolder: "[data-blocks-holder]",
        };

        function Product(container) {
            this.container = container;
            const sectionId = (this.sectionId =
                container.getAttribute("data-section-id"));
            const productId = (this.productId =
                container.getAttribute("data-product-id"));

            this.inModal = container.dataset.modal === "true";
            this.modal;

            this.settings = {
                enableHistoryState: container.dataset.history === "true" || false,
                namespace: `.product-${sectionId}`,
                inventory: false,
                inventoryThreshold: 10,
                modalInit: false,
                hasImages: true,
                imageSetName: null,
                imageSetIndex: null,
                currentImageSet: null,
                imageSize: "620x",
                currentSlideIndex: 0,
                videoLooping: container.dataset.videoLooping,
            };

            // Overwrite some settings when loaded in modal
            if (this.inModal) {
                this.settings.enableHistoryState = false;
                this.settings.namespace = `.product-${sectionId}-modal`;
                this.modal = document.getElementById(`QuickShopModal-${productId}`);
            }

            this.selectors = {
                variantsJson: "[data-variant-json]",
                currentVariantJson: "[data-current-variant-json]",
                form: ".product-single__form",

                media: "[data-product-media-type-model]",
                closeMedia: ".product-single__close-media",
                photoThumbs: "[data-product-thumb]",
                thumbSlider: "[data-product-thumbs]",
                thumbScroller: ".product__thumbs--scroller",
                mainSlider: "[data-product-photos]",
                imageContainer: "[data-product-images]",
                productImageMain: "[data-product-image-main]",

                priceWrapper: "[data-product-price-wrap]",
                price: "[data-product-price]",
                comparePrice: "[data-compare-price]",
                savePrice: "[data-save-price]",
                priceA11y: "[data-a11y-price]",
                comparePriceA11y: "[data-compare-price-a11y]",
                unitWrapper: "[data-unit-price-wrapper]",
                unitPrice: "[data-unit-price]",
                unitPriceBaseUnit: "[data-unit-base]",
                sku: "[data-sku]",
                inventory: "[data-product-inventory]",
                incomingInventory: "[data-incoming-inventory]",
                colorLabel: "[data-variant-color-label]",

                addToCart: "[data-add-to-cart]",
                addToCartText: "[data-add-to-cart-text]",

                originalSelectorId: "[data-product-select]",
                singleOptionSelector: "[data-variant-input]",
                variantColorSwatch: ".variant__input--color-swatch",

                availabilityContainer: "[data-store-availability-holder]",
            };

            this.cacheElements();

            this.firstProductImage = this.cache.mainSlider.querySelector("img");

            if (!this.firstProductImage) {
                this.settings.hasImages = false;
            }

            const dataSetEl = this.cache.mainSlider.querySelector("[data-set-name]");
            if (dataSetEl) {
                this.settings.imageSetName = dataSetEl.dataset.setName;
            }

            this.init();
        }

        Product.prototype = {
            ...Product.prototype,
            init() {
                if (this.inModal) {
                    this.container.classList.add(classes.isModal);
                    document.addEventListener(
                        `modalOpen.QuickShopModal-${this.productId}`,
                        this.openModalProduct.bind(this)
                    );
                    document.addEventListener(
                        `modalClose.QuickShopModal-${this.productId}`,
                        this.closeModalProduct.bind(this)
                    );
                }

                if (!this.inModal) {
                    this.formSetup();
                    this.productSetup();
                    this.videoSetup();
                    this.initProductSlider();
                    this.customMediaListners();
                    this.addIdToRecentlyViewed();
                }

                // Quick add hook
                window.off(`quickadd:loaded:${this.sectionId}`);
                window.on(
                    `quickadd:loaded:${this.sectionId}`,
                    this.initQuickAddForm.bind(this)
                );
            },

            cacheElements() {
                this.cache = {
                    form: this.container.querySelector(this.selectors.form),
                    mainSlider: this.container.querySelector(
                        this.selectors.mainSlider
                    ),
                    thumbSlider: this.container.querySelector(
                        this.selectors.thumbSlider
                    ),
                    thumbScroller: this.container.querySelector(
                        this.selectors.thumbScroller
                    ),
                    productImageMain: this.container.querySelector(
                        this.selectors.productImageMain
                    ),

                    // Price-related
                    priceWrapper: this.container.querySelector(
                        this.selectors.priceWrapper
                    ),
                    comparePriceA11y: this.container.querySelector(
                        this.selectors.comparePriceA11y
                    ),
                    comparePrice: this.container.querySelector(
                        this.selectors.comparePrice
                    ),
                    price: this.container.querySelector(this.selectors.price),
                    savePrice: this.container.querySelector(
                        this.selectors.savePrice
                    ),
                    priceA11y: this.container.querySelector(
                        this.selectors.priceA11y
                    ),
                };
            },

            formSetup() {
                this.initQtySelector();
                this.initAjaxProductForm();
                this.availabilitySetup();
                this.initVariants();

                // We know the current variant now so setup image sets
                if (this.settings.imageSetName) {
                    this.updateImageSet();
                }
            },

            availabilitySetup() {
                const container = this.container.querySelector(
                    this.selectors.availabilityContainer
                );
                if (container) {
                    this.storeAvailability = new theme.StoreAvailability(container);
                }
            },

            productSetup() {
                this.setImageSizes();
                this.initImageZoom();
                this.initModelViewerLibraries();
                this.initShopifyXrLaunch();

                if (window.SPR) {
                    SPR.initDomEls();
                    SPR.loadBadges();
                }
            },

            setImageSizes() {
                if (!this.settings.hasImages) {
                    return;
                }

                // Get srcset image src, works on most modern browsers
                // otherwise defaults to settings.imageSize
                const currentImage = this.firstProductImage.currentSrc;

                if (currentImage) {
                    this.settings.imageSize = theme.Images.imageSize(currentImage);
                }
            },

            addIdToRecentlyViewed() {
                const id = this.container.getAttribute("data-product-id");

                if (!id) {
                    return;
                }

                // Remove current product if already in recently viewed array
                const i = theme.recentlyViewedIds.indexOf(id);
                if (i > -1) {
                    theme.recentlyViewedIds.splice(i, 1);
                }

                // Add id to array
                theme.recentlyViewedIds.unshift(id);

                if (theme.config.hasLocalStorage) {
                    window.localStorage.setItem(
                        "recently-viewed",
                        JSON.stringify(theme.recentlyViewedIds)
                    );
                }
            },

            initVariants() {
                const variantJson = this.container.querySelector(
                    this.selectors.variantsJson
                );

                if (!variantJson) {
                    return;
                }

                this.variantsObject = JSON.parse(variantJson.innerHTML);

                const options = {
                    container: this.container,
                    enableHistoryState: this.settings.enableHistoryState,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId,
                    variants: this.variantsObject,
                };

                const swatches = this.container.querySelectorAll(
                    this.selectors.variantColorSwatch
                );
                if (swatches.length) {
                    swatches.forEach(swatch => {
                        swatch.addEventListener("change", evt => {
                            const color = swatch.dataset.colorName;
                            const index = swatch.dataset.colorIndex;
                            this.updateColorName(color, index);
                        });
                    });
                }

                this.variants = new theme.Variants(options);

                // Product availability on page load
                if (this.storeAvailability) {
                    const variant_id = this.variants.currentVariant
                        ? this.variants.currentVariant.id
                        : this.variants.variants[0].id;

                    this.storeAvailability.updateContent(variant_id);
                    this.container.on(
                        `variantChange${this.settings.namespace}`,
                        this.updateAvailability.bind(this)
                    );
                }

                this.container.on(
                    `variantChange${this.settings.namespace}`,
                    this.updateCartButton.bind(this)
                );
                this.container.on(
                    `variantImageChange${this.settings.namespace}`,
                    this.updateVariantImage.bind(this)
                );
                this.container.on(
                    `variantPriceChange${this.settings.namespace}`,
                    this.updatePrice.bind(this)
                );
                this.container.on(
                    `variantUnitPriceChange${this.settings.namespace}`,
                    this.updateUnitPrice.bind(this)
                );

                if (this.container.querySelectorAll(this.selectors.sku).length) {
                    this.container.on(
                        `variantSKUChange${this.settings.namespace}`,
                        this.updateSku.bind(this)
                    );
                }

                const inventoryEl = this.container.querySelector(
                    this.selectors.inventory
                );
                if (inventoryEl) {
                    this.settings.inventory = true;
                    this.settings.inventoryThreshold = inventoryEl.dataset.threshold;
                    this.container.on(
                        `variantChange${this.settings.namespace}`,
                        this.updateInventory.bind(this)
                    );
                }

                // Update individual variant availability on each selection
                if (theme.settings.dynamicVariantsEnable) {
                    const currentVariantJson = this.container.querySelector(
                        this.selectors.currentVariantJson
                    );

                    if (currentVariantJson) {
                        const variantType = this.container.querySelector(
                            selectors.variantType
                        );

                        if (variantType) {
                            new theme.VariantAvailability({
                                container: this.container,
                                namespace: this.settings.namespace,
                                type: variantType.dataset.type,
                                variantsObject: this.variantsObject,
                                currentVariantObject: JSON.parse(
                                    currentVariantJson.innerHTML
                                ),
                            });
                        }
                    }
                }

                // image set names variant change listeners
                if (this.settings.imageSetName) {
                    const variantWrapper = this.container.querySelector(
                        `.variant-input-wrap[data-handle="${this.settings.imageSetName}"]`
                    );
                    if (variantWrapper) {
                        this.settings.imageSetIndex = variantWrapper.dataset.index;
                        this.container.on(
                            `variantChange${this.settings.namespace}`,
                            this.updateImageSet.bind(this)
                        );
                    } else {
                        this.settings.imageSetName = null;
                    }
                }
            },

            initQtySelector() {
                this.container.querySelectorAll(".js-qty__wrapper").forEach(el => {
                    new theme.QtySelector(el, {
                        namespace: ".product",
                    });
                });
            },

            initAjaxProductForm() {
                if (theme.settings.cartType === "dropdown") {
                    new theme.AjaxProduct(this.cache.form, ".add-to-cart");
                }
            },

            /*= ===========================================================================
        Variant change methods
      ============================================================================== */
            updateColorName(color, index) {
                // Updates on radio button change, not variant.js
                this.container.querySelector(
                    `${this.selectors.colorLabel}[data-index="${index}"`
                ).textContent = color;
            },

            updateCartButton(evt) {
                const { variant } = evt.detail;
                const cartBtn = this.container.querySelector(
                    this.selectors.addToCart
                );
                const cartBtnText = this.container.querySelector(
                    this.selectors.addToCartText
                );

                if (variant) {
                    if (variant.available) {
                        // Available, enable the submit button and change text
                        cartBtn.classList.remove(classes.disabled);
                        cartBtn.disabled = false;
                        const { defaultText } = cartBtnText.dataset;
                        cartBtnText.textContent = defaultText;
                    } else {
                        // Sold out, disable the submit button and change text
                        cartBtn.classList.add(classes.disabled);
                        cartBtn.disabled = true;
                        cartBtnText.textContent = theme.strings.soldOut;
                    }
                } else {
                    // The variant doesn't exist, disable submit button
                    cartBtn.classList.add(classes.disabled);
                    cartBtn.disabled = true;
                    cartBtnText.textContent = theme.strings.unavailable;
                }
            },

            updatePrice(evt) {
                const { variant } = evt.detail;

                if (variant) {
                    // If no price element, form initiated later than rest of
                    // product page. Update cached elements
                    if (!this.cache.price) {
                        this.cacheElements();
                    }

                    // Regular price
                    this.cache.price.innerHTML = theme.Currency.formatMoney(
                        variant.price,
                        theme.settings.moneyFormat
                    );

                    // Sale price, if necessary
                    if (variant.compare_at_price > variant.price) {
                        this.cache.comparePrice.innerHTML =
                            theme.Currency.formatMoney(
                                variant.compare_at_price,
                                theme.settings.moneyFormat
                            );
                        this.cache.priceWrapper.classList.remove(classes.hidden);
                        this.cache.price.classList.add(classes.onSale);
                        if (this.cache.comparePriceA11y) {
                            this.cache.comparePriceA11y.setAttribute(
                                "aria-hidden",
                                "false"
                            );
                        }
                        if (this.cache.priceA11y) {
                            this.cache.priceA11y.setAttribute(
                                "aria-hidden",
                                "false"
                            );
                        }

                        let savings = variant.compare_at_price - variant.price;

                        if (theme.settings.saveType == "percent") {
                            savings = `${Math.round(
                                (savings * 100) / variant.compare_at_price
                            )}%`;
                        } else {
                            savings = theme.Currency.formatMoney(
                                savings,
                                theme.settings.moneyFormat
                            );
                        }

                        this.cache.savePrice.classList.remove(classes.hidden);
                        this.cache.savePrice.innerHTML =
                            theme.strings.savePrice.replace(
                                "[saved_amount]",
                                savings
                            );
                    } else {
                        if (this.cache.priceWrapper) {
                            this.cache.priceWrapper.classList.add(classes.hidden);
                        }
                        this.cache.savePrice.classList.add(classes.hidden);
                        this.cache.price.classList.remove(classes.onSale);
                        if (this.cache.comparePriceA11y) {
                            this.cache.comparePriceA11y.setAttribute(
                                "aria-hidden",
                                "true"
                            );
                        }
                        if (this.cache.priceA11y) {
                            this.cache.priceA11y.setAttribute("aria-hidden", "true");
                        }
                    }
                }
            },

            updateUnitPrice(evt) {
                const { variant } = evt.detail;

                if (variant && variant.unit_price) {
                    this.container.querySelector(
                        this.selectors.unitPrice
                    ).innerHTML = theme.Currency.formatMoney(
                        variant.unit_price,
                        theme.settings.moneyFormat
                    );
                    this.container.querySelector(
                        this.selectors.unitPriceBaseUnit
                    ).innerHTML = theme.Currency.getBaseUnit(variant);
                    this.container
                        .querySelector(this.selectors.unitWrapper)
                        .classList.remove(classes.hidden);
                } else {
                    this.container
                        .querySelector(this.selectors.unitWrapper)
                        .classList.add(classes.hidden);
                }
            },

            imageSetArguments(variant) {
                var variant =
                    variant || (this.variants ? this.variants.currentVariant : null);
                if (!variant) return;

                const setValue = (this.settings.currentImageSet =
                    this.getImageSetName(variant[this.settings.imageSetIndex]));
                const set = `${this.settings.imageSetName}_${setValue}`;

                // Always start on index 0
                this.settings.currentSlideIndex = 0;

                // Return object that adds cellSelector to mainSliderArgs
                return {
                    cellSelector: `[data-group="${set}"]`,
                    imageSet: set,
                    initialIndex: this.settings.currentSlideIndex,
                };
            },

            updateImageSet(evt) {
                // If called directly, use current variant
                const variant = evt
                    ? evt.detail.variant
                    : this.variants
                    ? this.variants.currentVariant
                    : null;
                if (!variant) {
                    return;
                }

                const setValue = this.getImageSetName(
                    variant[this.settings.imageSetIndex]
                );

                // Already on the current image group
                if (this.settings.currentImageSet === setValue) {
                    return;
                }

                this.initProductSlider(variant);
            },

            // Show/hide thumbnails based on current image set
            updateImageSetThumbs(set) {
                this.cache.thumbSlider
                    .querySelectorAll(".product__thumb-item")
                    .forEach(thumb => {
                        thumb.classList.toggle(
                            classes.hidden,
                            thumb.dataset.group !== set
                        );
                    });
            },

            getImageSetName(string) {
                return string
                    .toLowerCase()
                    .replace(/[^a-z0-9]+/g, "-")
                    .replace(/-$/, "")
                    .replace(/^-/, "");
            },

            updateSku(evt) {
                const { variant } = evt.detail;
                let newSku = "";
                let hideSku = true;

                if (variant) {
                    if (variant.sku) {
                        newSku = variant.sku;
                        hideSku = false;
                    }

                    this.container
                        .querySelectorAll(this.selectors.sku)
                        .forEach(el => {
                            el.classList.toggle(classes.hidden, hideSku);
                            el.querySelector("[data-sku-id]").textContent = newSku;
                        });
                }
            },

            updateInventory(evt) {
                const { variant } = evt.detail;

                // Hide stock if no inventory management or policy is continue
                if (
                    !variant ||
                    !variant.inventory_management ||
                    variant.inventory_policy === "continue"
                ) {
                    this.toggleInventoryQuantity(variant, false);
                    this.toggleIncomingInventory(false);
                    return;
                }

                if (
                    variant.inventory_management === "shopify" &&
                    window.inventories &&
                    window.inventories[this.productId]
                ) {
                    const variantInventoryObject =
                        window.inventories[this.productId][variant.id];

                    // Hide stock if policy is continue
                    if (variantInventoryObject.policy === "continue") {
                        this.toggleInventoryQuantity(variant, false);
                        this.toggleIncomingInventory(false);
                        return;
                    }

                    const { quantity } = variantInventoryObject;
                    let showInventory = true;
                    let showIncomingInventory = false;

                    if (
                        quantity <= 0 ||
                        quantity > this.settings.inventoryThreshold
                    ) {
                        showInventory = false;
                    }

                    this.toggleInventoryQuantity(variant, showInventory, quantity);

                    // Only show incoming inventory when:
                    // - inventory notice itself is hidden
                    // - have incoming inventory
                    // - current quantity is below theme setting threshold
                    if (
                        !showInventory &&
                        variantInventoryObject.incoming === "true" &&
                        quantity <= this.settings.inventoryThreshold
                    ) {
                        showIncomingInventory = true;
                    }

                    this.toggleIncomingInventory(
                        showIncomingInventory,
                        variant.available,
                        variantInventoryObject.next_incoming_date
                    );
                }
            },

            updateAvailability(evt) {
                const { variant } = evt.detail;
                if (!variant) {
                    return;
                }

                this.storeAvailability.updateContent(variant.id);
            },

            toggleInventoryQuantity(variant, show, qty) {
                if (!this.settings.inventory) {
                    show = false;
                }

                const el = this.container.querySelector(this.selectors.inventory);
                const salesPoint = el.closest(".product-block");

                if (parseInt(qty) <= parseInt(this.settings.inventoryThreshold)) {
                    el.parentNode.classList.add("inventory--low");
                    el.textContent = theme.strings.stockLabel.replace(
                        "[count]",
                        qty
                    );
                } else {
                    el.parentNode.classList.remove("inventory--low");
                    el.textContent = theme.strings.inStockLabel;
                }

                if (variant && variant.available) {
                    el.parentNode.classList.remove(classes.hidden);
                    if (salesPoint) {
                        salesPoint.classList.remove(classes.hidden);
                    }
                } else {
                    el.parentNode.classList.add(classes.hidden);
                    if (salesPoint) {
                        salesPoint.classList.add(classes.hidden);
                    }
                }
            },

            toggleIncomingInventory(show, available, date) {
                const el = this.container.querySelector(
                    this.selectors.incomingInventory
                );
                const salesPoint = el.closest(".product-block");

                if (!el) {
                    return;
                }

                const textEl = el.querySelector(".js-incoming-text");

                if (show) {
                    let string = available
                        ? theme.strings.willNotShipUntil.replace("[date]", date)
                        : theme.strings.willBeInStockAfter.replace("[date]", date);

                    if (!date) {
                        string = theme.strings.waitingForStock;
                    }

                    el.classList.remove(classes.hidden);
                    if (salesPoint) {
                        salesPoint.classList.remove(classes.hidden);
                    }
                    textEl.textContent = string;
                } else {
                    el.classList.add(classes.hidden);
                }
            },

            /*= ===========================================================================
        Product videos
      ============================================================================== */
            videoSetup() {
                const productVideos = this.cache.mainSlider.querySelectorAll(
                    selectors.productVideo
                );

                if (!productVideos.length) {
                    return false;
                }

                productVideos.forEach(vid => {
                    const type = vid.dataset.videoType;
                    if (type === "youtube") {
                        this.initYoutubeVideo(vid);
                    } else if (type === "mp4") {
                        this.initMp4Video(vid);
                    }
                });
            },

            initYoutubeVideo(div) {
                videoObjects[div.id] = new theme.YouTube(div.id, {
                    videoId: div.dataset.youtubeId,
                    videoParent: selectors.videoParent,
                    autoplay: false, // will handle this in callback
                    style: div.dataset.videoStyle,
                    loop: div.dataset.videoLoop,
                    events: {
                        onReady: this.youtubePlayerReady.bind(this),
                        onStateChange: this.youtubePlayerStateChange.bind(this),
                    },
                });
            },

            // Comes from YouTube SDK
            // Get iframe ID with evt.target.getIframe().id
            // Then access product video players with videoObjects[id]
            youtubePlayerReady(evt) {
                const iframeId = evt.target.getIframe().id;

                if (!videoObjects[iframeId]) {
                    // No youtube player data
                    return;
                }

                const obj = videoObjects[iframeId];
                const player = obj.videoPlayer;

                if (obj.options.style !== "sound") {
                    player.mute();
                }

                obj.parent.classList.remove("loading");
                obj.parent.classList.add("loaded");

                // If we have an element, it is in the visible/first slide,
                // and is muted, play it
                if (this._isFirstSlide(iframeId) && obj.options.style !== "sound") {
                    player.playVideo();
                }
            },

            _isFirstSlide(id) {
                return this.cache.mainSlider.querySelector(
                    `${selectors.startingSlide} ` + `#${id}`
                );
            },

            youtubePlayerStateChange(evt) {
                const iframeId = evt.target.getIframe().id;
                const obj = videoObjects[iframeId];

                switch (evt.data) {
                    case -1: // unstarted
                        // Handle low power state on iOS by checking if
                        // video is reset to unplayed after attempting to buffer
                        if (obj.attemptedToPlay) {
                            obj.parent.classList.add("video-interactable");
                        }
                        break;
                    case 0: // ended
                        if (obj && obj.options.loop === "true") {
                            obj.videoPlayer.playVideo();
                        }
                        break;
                    case 3: // buffering
                        obj.attemptedToPlay = true;
                        break;
                }
            },

            initMp4Video(div) {
                videoObjects[div.id] = {
                    id: div.id,
                    type: "mp4",
                };

                if (this._isFirstSlide(div.id)) {
                    this.playMp4Video(div.id);
                }
            },

            stopVideos() {
                for (const [id, vid] of Object.entries(videoObjects)) {
                    if (vid.videoPlayer) {
                        if (typeof vid.videoPlayer.stopVideo === "function") {
                            vid.videoPlayer.stopVideo(); // YouTube player
                        }
                    } else if (vid.type === "mp4") {
                        this.stopMp4Video(vid.id); // MP4 player
                    }
                }
            },

            _getVideoType(video) {
                return video.getAttribute("data-video-type");
            },

            _getVideoDivId(video) {
                return video.id;
            },

            playMp4Video(id) {
                const player = this.container.querySelector(`#${id}`);
                const playPromise = player.play();

                player.setAttribute("controls", "");
                player.focus();

                // When existing focus on the element, go back to thumbnail
                player.addEventListener(
                    "focusout",
                    this.returnFocusToThumbnail.bind(this)
                );

                if (playPromise !== undefined) {
                    playPromise
                        .then(() => {
                            // Playing as expected
                        })
                        .catch(error => {
                            // Likely low power mode on iOS, show controls
                            player.setAttribute("controls", "");
                            player
                                .closest(selectors.videoParent)
                                .setAttribute("data-video-style", "unmuted");
                        });
                }
            },

            stopMp4Video(id) {
                const player = this.container.querySelector(`#${id}`);
                player.removeEventListener(
                    "focusout",
                    this.returnFocusToThumbnail.bind(this)
                );
                if (player && typeof player.pause === "function") {
                    player.removeAttribute("controls");
                    player.pause();
                }
            },

            returnFocusToThumbnail(evt) {
                // Only return focus to active thumbnail if relatedTarget
                // is a thumbnail, otherwise user may have clicked elsewhere on the page
                if (
                    evt.relatedTarget &&
                    evt.relatedTarget.classList.contains("product__thumb")
                ) {
                    const thumb = this.container.querySelector(
                        `.product__thumb-item[data-index="${this.settings.currentSlideIndex}"] a`
                    );
                    if (thumb) {
                        thumb.focus();
                    }
                }
            },

            /*= ===========================================================================
        Product images
      ============================================================================== */
            initImageZoom() {
                const container = this.container.querySelector(
                    this.selectors.imageContainer
                );
                if (!container) {
                    return;
                }
                const imageZoom = new theme.Photoswipe(container, this.sectionId);
                container.addEventListener("photoswipe:afterChange", evt => {
                    if (this.flickity) {
                        this.flickity.goToSlide(evt.detail.index);
                    }
                });
            },

            getThumbIndex(target) {
                return target.dataset.index;
            },

            updateVariantImage(evt) {
                const { variant } = evt.detail;
                const sizedImgUrl = theme.Images.getSizedImageUrl(
                    variant.featured_media.preview_image.src,
                    this.settings.imageSize
                );

                const newImage = this.container.querySelector(
                    `.product__thumb[data-id="${variant.featured_media.id}"]`
                );
                const imageIndex = this.getThumbIndex(newImage);

                // If there is no index, slider is not initalized
                if (typeof imageIndex === "undefined") {
                    return;
                }

                // Go to that variant image's slide
                if (this.flickity) {
                    this.flickity.goToSlide(imageIndex);
                }
            },

            initProductSlider(variant) {
                // Stop if only a single image, but add active class to first slide
                if (
                    this.cache.mainSlider.querySelectorAll(selectors.slide).length <=
                    1
                ) {
                    const slide = this.cache.mainSlider.querySelector(
                        selectors.slide
                    );
                    if (slide) {
                        slide.classList.add("is-selected");
                    }
                    return;
                }

                // Destroy slider in preparation of new initialization
                if (this.flickity && typeof this.flickity.destroy === "function") {
                    this.flickity.destroy();
                }

                // If variant argument exists, slideshow is reinitializing because of the
                // image set feature enabled and switching to a new group.
                // currentSlideIndex
                if (!variant) {
                    const activeSlide = this.cache.mainSlider.querySelector(
                        selectors.startingSlide
                    );
                    this.settings.currentSlideIndex = this._slideIndex(activeSlide);
                }

                let mainSliderArgs = {
                    adaptiveHeight: true,
                    avoidReflow: true,
                    initialIndex: this.settings.currentSlideIndex,
                    childNav: this.cache.thumbSlider,
                    childNavScroller: this.cache.thumbScroller,
                    childVertical:
                        this.cache.thumbSlider.dataset.position === "beside",
                    pageDots: true, // mobile only with CSS
                    wrapAround: true,
                    callbacks: {
                        onInit: this.onSliderInit.bind(this),
                        onChange: this.onSlideChange.bind(this),
                    },
                };

                // Override default settings if image set feature enabled
                if (this.settings.imageSetName) {
                    const imageSetArgs = this.imageSetArguments(variant);
                    mainSliderArgs = { ...mainSliderArgs, ...imageSetArgs };
                    this.updateImageSetThumbs(mainSliderArgs.imageSet);
                }

                this.flickity = new theme.Slideshow(
                    this.cache.mainSlider,
                    mainSliderArgs
                );
            },

            onSliderInit(slide) {
                // If slider is initialized with image set feature active,
                // initialize any videos/media when they are first slide
                if (this.settings.imageSetName) {
                    this.prepMediaOnSlide(slide);
                }
            },

            onSlideChange(index) {
                if (!this.flickity) return;

                const prevSlide = this.cache.mainSlider.querySelector(
                    `.product-main-slide[data-index="${this.settings.currentSlideIndex}"]`
                );

                // If imageSetName exists, use a more specific selector
                const nextSlide = this.settings.imageSetName
                    ? this.cache.mainSlider.querySelectorAll(
                          ".flickity-slider .product-main-slide"
                      )[index]
                    : this.cache.mainSlider.querySelector(
                          `.product-main-slide[data-index="${index}"]`
                      );

                prevSlide.setAttribute("tabindex", "-1");
                nextSlide.setAttribute("tabindex", 0);

                // Pause any existing slide video/media
                this.stopMediaOnSlide(prevSlide);

                // Prep next slide video/media
                this.prepMediaOnSlide(nextSlide);

                // Update current slider index
                this.settings.currentSlideIndex = index;
            },

            stopMediaOnSlide(slide) {
                // Stop existing video
                const video = slide.querySelector(selectors.productVideo);
                if (video) {
                    const videoType = this._getVideoType(video);
                    const videoId = this._getVideoDivId(video);
                    if (videoType === "youtube") {
                        if (videoObjects[videoId].videoPlayer) {
                            videoObjects[videoId].videoPlayer.stopVideo();
                            return;
                        }
                    } else if (videoType === "mp4") {
                        this.stopMp4Video(videoId);
                        return;
                    }
                }

                // Stop existing media
                const currentMedia = slide.querySelector(this.selectors.media);
                if (currentMedia) {
                    currentMedia.dispatchEvent(
                        new CustomEvent("mediaHidden", {
                            bubbles: true,
                            cancelable: true,
                        })
                    );
                }
            },

            prepMediaOnSlide(slide) {
                const video = slide.querySelector(selectors.productVideo);
                if (video) {
                    this.flickity.reposition();
                    const videoType = this._getVideoType(video);
                    const videoId = this._getVideoDivId(video);
                    if (videoType === "youtube") {
                        if (
                            videoObjects[videoId].videoPlayer &&
                            videoObjects[videoId].options.style !== "sound"
                        ) {
                            videoObjects[videoId].videoPlayer.playVideo();
                            return;
                        }
                    } else if (videoType === "mp4") {
                        this.playMp4Video(videoId);
                    }
                }

                const nextMedia = slide.querySelector(this.selectors.media);
                if (nextMedia) {
                    nextMedia.dispatchEvent(
                        new CustomEvent("mediaVisible", {
                            bubbles: true,
                            cancelable: true,
                        })
                    );
                    slide
                        .querySelector(".shopify-model-viewer-ui__button")
                        .setAttribute("tabindex", 0);
                    slide
                        .querySelector(".product-single__close-media")
                        .setAttribute("tabindex", 0);
                }
            },

            _slideIndex(el) {
                return el.getAttribute("data-index");
            },

            /*= ===========================================================================
        Products when in quick view modal
      ============================================================================== */
            openModalProduct() {
                let initialized = false;

                if (!this.settings.modalInit) {
                    this.blocksHolder = this.container.querySelector(
                        selectors.blocksHolder
                    );
                    const { url } = this.blocksHolder.dataset;

                    fetch(url)
                        .then(response => response.text())
                        .then(html => {
                            const parser = new DOMParser();
                            const doc = parser.parseFromString(html, "text/html");
                            const blocks = doc.querySelector(selectors.blocks);

                            // Because the same product could be opened in quick view
                            // on the page we load the form elements from, we need to
                            // update any `id`, `for`, and `form` attributes
                            blocks.querySelectorAll("[id]").forEach(el => {
                                // Update input `id`
                                const val = el.getAttribute("id");
                                el.setAttribute("id", `${val}-modal`);

                                // Update related label if it exists
                                const label = blocks.querySelector(`[for="${val}"]`);
                                if (label) {
                                    label.setAttribute("for", `${val}-modal`);
                                }

                                // Update any collapsible elements
                                const collapsibleTrigger = blocks.querySelector(
                                    `[aria-controls="${val}"]`
                                );
                                if (collapsibleTrigger) {
                                    collapsibleTrigger.setAttribute(
                                        "aria-controls",
                                        `${val}-modal`
                                    );
                                }
                            });

                            // Update any elements with `form` attribute.
                            // Form element already has `-modal` appended
                            const form = blocks.querySelector(this.selectors.form);
                            const formId = form.getAttribute("id");
                            blocks.querySelectorAll("[form]").forEach(el => {
                                el.setAttribute("form", formId);
                            });

                            this.blocksHolder.innerHTML = "";
                            this.blocksHolder.append(blocks);
                            this.blocksHolder.classList.add(
                                "product-form-holder--loaded"
                            );

                            this.cacheElements();

                            this.formSetup();
                            this.updateModalProductInventory();

                            if (Shopify && Shopify.PaymentButton) {
                                Shopify.PaymentButton.init();
                            }

                            // Re-hook up collapsible box triggers
                            theme.collapsibles.init(this.container);

                            document.dispatchEvent(
                                new CustomEvent("quickview:loaded", {
                                    detail: {
                                        productId: this.sectionId,
                                    },
                                })
                            );
                        });

                    this.productSetup();
                    this.videoSetup();

                    // Enable product slider in quick view
                    // 1. with image sets enabled, make sure we have this.variants before initializing
                    // 2. initialize normally, form data not required
                    if (this.settings.imageSetName) {
                        if (this.variants) {
                            this.initProductSlider();
                        } else {
                            document.addEventListener("quickview:loaded", evt => {
                                if (evt.detail.productId === this.sectionId) {
                                    this.initProductSlider();
                                }
                            });
                        }
                    } else {
                        this.initProductSlider();
                    }
                    this.customMediaListners();
                    this.addIdToRecentlyViewed();
                    this.settings.modalInit = true;
                } else {
                    initialized = true;
                }

                document.dispatchEvent(
                    new CustomEvent("quickview:open", {
                        detail: {
                            initialized,
                            productId: this.sectionId,
                        },
                    })
                );
            },

            // Recommended products load via JS and don't add variant inventory to the
            // global variable that we later check. This function scrapes a data div
            // to get that info and manually add the values.
            updateModalProductInventory() {
                window.inventories = window.inventories || {};
                this.container
                    .querySelectorAll(".js-product-inventory-data")
                    .forEach(el => {
                        const { productId } = el.dataset;
                        window.inventories[productId] = {};

                        el.querySelectorAll(".js-variant-inventory-data").forEach(
                            el => {
                                window.inventories[productId][el.dataset.id] = {
                                    quantity: el.dataset.quantity,
                                    policy: el.dataset.policy,
                                    incoming: el.dataset.incoming,
                                    next_incoming_date: el.dataset.date,
                                };
                            }
                        );
                    });
            },

            closeModalProduct() {
                this.stopVideos();
            },

            initQuickAddForm() {
                this.updateModalProductInventory();

                if (Shopify && Shopify.PaymentButton) {
                    Shopify.PaymentButton.init();
                }
            },

            /*= ===========================================================================
        Product media (3D)
      ============================================================================== */
            initModelViewerLibraries() {
                const modelViewerElements = this.container.querySelectorAll(
                    this.selectors.media
                );
                if (modelViewerElements.length < 1) return;

                theme.ProductMedia.init(modelViewerElements, this.sectionId);
            },

            initShopifyXrLaunch() {
                document.addEventListener("shopify_xr_launch", () => {
                    const currentMedia = this.container.querySelector(
                        `${this.selectors.productMediaWrapper}:not(.${self.classes.hidden})`
                    );
                    currentMedia.dispatchEvent(
                        new CustomEvent("xrLaunch", {
                            bubbles: true,
                            cancelable: true,
                        })
                    );
                });
            },

            customMediaListners() {
                document.querySelectorAll(this.selectors.closeMedia).forEach(el => {
                    el.addEventListener("click", () => {
                        const slide = this.cache.mainSlider.querySelector(
                            selectors.currentSlide
                        );
                        const media = slide.querySelector(this.selectors.media);
                        if (media) {
                            media.dispatchEvent(
                                new CustomEvent("mediaHidden", {
                                    bubbles: true,
                                    cancelable: true,
                                })
                            );
                        }
                    });
                });

                const modelViewers = this.container.querySelectorAll("model-viewer");
                if (modelViewers.length) {
                    modelViewers.forEach(el => {
                        el.addEventListener(
                            "shopify_model_viewer_ui_toggle_play",
                            evt => {
                                this.mediaLoaded(evt);
                            }
                        );

                        el.addEventListener(
                            "shopify_model_viewer_ui_toggle_pause",
                            evt => {
                                this.mediaUnloaded(evt);
                            }
                        );
                    });
                }
            },

            mediaLoaded(evt) {
                this.container
                    .querySelectorAll(this.selectors.closeMedia)
                    .forEach(el => {
                        el.classList.remove(classes.hidden);
                    });

                if (this.flickity) {
                    this.flickity.setDraggable(false);
                }
            },

            mediaUnloaded(evt) {
                this.container
                    .querySelectorAll(this.selectors.closeMedia)
                    .forEach(el => {
                        el.classList.add(classes.hidden);
                    });

                if (this.flickity) {
                    this.flickity.setDraggable(true);
                }
            },

            onUnload() {
                theme.ProductMedia.removeSectionModels(this.sectionId);

                if (this.flickity && typeof this.flickity.destroy === "function") {
                    this.flickity.destroy();
                }
            },
        };

        return Product;
    })();

    theme.RecentlyViewed = (function () {
        let init = false;
        let maxProducts = 6;

        if (window.innerWidth < 850) {
            maxProducts = 3;
        }

        function RecentlyViewed(container) {
            if (!container) {
                return;
            }

            this.container = container;
            this.sectionId = this.container.getAttribute("data-section-id");

            theme.initWhenVisible({
                element: this.container,
                callback: this.init.bind(this),
                threshold: 600,
            });
        }

        RecentlyViewed.prototype = {
            ...RecentlyViewed.prototype,
            init() {
                if (init) {
                    return;
                }

                init = true;

                // Stop if no data
                if (!theme.recentlyViewedIds.length) {
                    this.container.classList.add("hide");
                    return;
                }

                this.outputContainer = document.getElementById(
                    `RecentlyViewed-${this.sectionId}`
                );
                const currentId = this.container.getAttribute("data-product-id");

                let url = `${theme.routes.search}?view=recently-viewed&type=product&q=`;

                let products = "";
                let i = 0;
                theme.recentlyViewedIds.forEach(val => {
                    // Skip current product
                    if (val === currentId) {
                        return;
                    }

                    // Stop at max
                    if (i >= maxProducts) {
                        return;
                    }

                    products += `id:${val} OR `;
                    i++;
                });

                url += encodeURIComponent(products);

                fetch(url)
                    .then(response => response.text())
                    .then(html => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, "text/html");
                        const count = doc.querySelectorAll(".grid-product").length;

                        if (count > 0) {
                            const results = doc.querySelector(".product-grid");
                            this.outputContainer.append(results);

                            new theme.QuickAdd(this.outputContainer);
                            new theme.QuickShop(this.outputContainer);
                        } else {
                            this.container.classList.add("hide");
                        }
                    });
            },

            onUnload() {
                init = false;
            },
        };

        return RecentlyViewed;
    })();

    theme.VendorProducts = (function () {
        let maxProducts = 6;
        if (window.innerWidth < 850) {
            maxProducts = 3;
        }

        function VendorProducts(container) {
            if (!container) {
                return;
            }

            this.container = container;
            this.sectionId = this.container.getAttribute("data-section-id");
            this.currentProduct = this.container.getAttribute("data-product-id");

            theme.initWhenVisible({
                element: this.container,
                callback: this.init.bind(this),
                threshold: 600,
            });
        }

        VendorProducts.prototype = {
            ...VendorProducts.prototype,
            init() {
                this.outputContainer = document.getElementById(
                    `VendorProducts-${this.sectionId}`
                );
                this.vendor = this.container.getAttribute("data-vendor");
                let url = `${theme.routes.collections}/vendors?view=vendor-ajax&q=${this.vendor}`;

                // remove double `/` in case shop might have /en or language in URL
                url = url.replace("//", "/");

                fetch(url)
                    .then(response => response.text())
                    .then(html => {
                        let count = 0;
                        const products = [];
                        const modals = [];
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, "text/html");

                        const allProds = doc.querySelectorAll(".grid-product");

                        // Do not add current product to output
                        allProds.forEach(el => {
                            const id = el.dataset.productId;

                            if (count === maxProducts) {
                                return;
                            }

                            if (id === this.currentProduct) {
                                return;
                            }

                            const modal = doc.querySelector(
                                `.modal[data-product-id="${id}"]`
                            );
                            if (modal) {
                                modals.push(modal);
                            }

                            count++;
                            products.push(el);
                        });

                        this.outputContainer.innerHTML = "";

                        if (products.length === 0) {
                            this.container.classList.add("hide");
                        } else {
                            this.outputContainer.classList.remove("hide");
                            this.outputContainer.append(...products);

                            if (modals.length) {
                                this.outputContainer.append(...modals);
                                new theme.QuickShop(this.outputContainer);
                            }

                            new theme.QuickAdd(this.outputContainer);
                        }
                    });
            },
        };

        return VendorProducts;
    })();

    theme.Testimonials = (function () {
        const defaults = {
            adaptiveHeight: true,
            avoidReflow: true,
            pageDots: true,
            prevNextButtons: false,
        };

        function Testimonials(container) {
            this.container = container;
            this.timeout;
            const sectionId = container.getAttribute("data-section-id");
            this.slideshow = container.querySelector(`#Testimonials-${sectionId}`);
            this.namespace = `.testimonial-${sectionId}`;

            if (!this.slideshow) {
                return;
            }

            theme.initWhenVisible({
                element: this.container,
                callback: this.init.bind(this),
                threshold: 600,
            });
        }

        Testimonials.prototype = {
            ...Testimonials.prototype,
            init() {
                // Do not wrap when only a few blocks
                if (this.slideshow.dataset.count <= 3) {
                    defaults.wrapAround = false;
                }

                this.flickity = new theme.Slideshow(this.slideshow, defaults);

                // Autoscroll to next slide on load to indicate more blocks
                if (this.slideshow.dataset.count > 2) {
                    this.timeout = setTimeout(() => {
                        this.flickity.goToSlide(1);
                    }, 1000);
                }
            },

            onUnload() {
                if (this.flickity && typeof this.flickity.destroy === "function") {
                    this.flickity.destroy();
                }
            },

            onDeselect() {
                if (this.flickity && typeof this.flickity.play === "function") {
                    this.flickity.play();
                }
            },

            onBlockSelect(evt) {
                const slide = this.slideshow.querySelector(
                    `.testimonials-slide--${evt.detail.blockId}`
                );
                const index = parseInt(slide.dataset.index);

                clearTimeout(this.timeout);

                if (this.flickity && typeof this.flickity.pause === "function") {
                    this.flickity.goToSlide(index);
                    this.flickity.pause();
                }
            },

            onBlockDeselect() {
                if (this.flickity && typeof this.flickity.play === "function") {
                    this.flickity.play();
                }
            },
        };

        return Testimonials;
    })();

    theme.isStorageSupported = function (type) {
        // Return false if we are in an iframe without access to sessionStorage
        if (window.self !== window.top) {
            return false;
        }

        const testKey = "test";
        let storage;
        if (type === "session") {
            storage = window.sessionStorage;
        }
        if (type === "local") {
            storage = window.localStorage;
        }

        try {
            storage.setItem(testKey, "1");
            storage.removeItem(testKey);
            return true;
        } catch (error) {
            return false;
        }
    };

    theme.reinitProductGridItem = function (scope) {
        // Refresh reviews app
        if (window.SPR) {
            SPR.initDomEls();
            SPR.loadBadges();
        }

        // Re-hook up collapsible box triggers
        theme.collapsibles.init();
    };

    // Set a max-height on drawers when they're opened via CSS variable
    // to account for changing mobile window heights
    theme.sizeDrawer = function () {
        const header = document.getElementById("HeaderWrapper").offsetHeight;
        const max = window.innerHeight - header;
        document.documentElement.style.setProperty("--maxDrawerHeight", `${max}px`);
    };

    /*= ===========================================================================
    Things that don't require DOM to be ready
  ============================================================================== */
    theme.config.hasSessionStorage = theme.isStorageSupported("session");
    theme.config.hasLocalStorage = theme.isStorageSupported("local");

    if (theme.config.hasLocalStorage) {
        const recentIds = window.localStorage.getItem("recently-viewed");
        if (recentIds && typeof recentIds !== undefined) {
            theme.recentlyViewedIds = JSON.parse(recentIds);
        }
    }

    // Trigger events when going between breakpoints
    theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
    matchMedia(theme.config.mediaQuerySmall).addListener(mql => {
        if (mql.matches) {
            theme.config.bpSmall = true;
            document.dispatchEvent(new CustomEvent("matchSmall"));
        } else {
            theme.config.bpSmall = false;
            document.dispatchEvent(new CustomEvent("unmatchSmall"));
        }
    });

    /*= ===========================================================================
    Things that require DOM to be ready
  ============================================================================== */
    function DOMready(callback) {
        if (document.readyState != "loading") callback();
        else document.addEventListener("DOMContentLoaded", callback);
    }

    // Load generic JS. Also reinitializes when sections are
    // added, edited, or removed in Shopify's editor
    theme.initGlobals = function () {
        theme.collapsibles.init();
        theme.videoModal();
        theme.animationObserver();
    };

    DOMready(() => {
        theme.sections = new theme.Sections();

        theme.sections.register("slideshow-section", theme.SlideshowSection);
        theme.sections.register("header", theme.HeaderSection);
        theme.sections.register("toolbar", theme.Toolbar);
        theme.sections.register("product", theme.Product);
        theme.sections.register("password-header", theme.PasswordHeader);
        theme.sections.register("photoswipe", theme.Photoswipe);
        theme.sections.register("product-recommendations", theme.Recommendations);
        theme.sections.register("background-image", theme.BackgroundImage);
        theme.sections.register("testimonials", theme.Testimonials);
        theme.sections.register("video-section", theme.VideoSection);
        theme.sections.register("map", theme.Maps);
        theme.sections.register("footer-section", theme.FooterSection);
        theme.sections.register("store-availability", theme.StoreAvailability);
        theme.sections.register("recently-viewed", theme.RecentlyViewed);
        theme.sections.register("vendor-products", theme.VendorProducts);
        theme.sections.register("newsletter-popup", theme.NewsletterPopup);
        theme.sections.register("collection-header", theme.CollectionHeader);
        theme.sections.register("collection-template", theme.Collection);

        theme.initGlobals();
        theme.rteInit();

        if (theme.settings.isCustomerTemplate) {
            theme.customerTemplates();
        }

        if (document.body.classList.contains("template-cart")) {
            const cartPageForm = document.getElementById("CartPageForm");
            if (cartPageForm) {
                const cartForm = new theme.CartForm(cartPageForm);

                const recommendations = document.querySelector(
                    '.cart-recommendations[data-location="page"]'
                );
                if (recommendations) {
                    new theme.QuickAdd(recommendations);
                    new theme.QuickShop(recommendations);
                }

                const noteBtn = cartPageForm.querySelector(".add-note");
                if (noteBtn) {
                    noteBtn.addEventListener("click", () => {
                        noteBtn.classList.toggle("is-active");
                        cartPageForm
                            .querySelector(".cart__note")
                            .classList.toggle("hide");
                    });
                }

                document.addEventListener("ajaxProduct:added", evt => {
                    cartForm.buildCart();
                });
            }
        }

        // Enable quick view/quick shop on search page
        if (document.body.classList.contains("template-search")) {
            const searchGrid = document.querySelector(".search-grid");
            if (searchGrid) {
                const searchProducts = searchGrid.querySelectorAll(".grid-product");
                if (searchProducts.length) {
                    new theme.QuickAdd(searchGrid);
                    new theme.QuickShop(searchGrid);
                }
            }
        }

        document.addEventListener("recommendations:loaded", evt => {
            if (evt && evt.detail && evt.detail.section) {
                new theme.QuickAdd(evt.detail.section);
                new theme.QuickShop(evt.detail.section);
            }
        });

        theme.pageTransitions();

        document.dispatchEvent(new CustomEvent("page:loaded"));
    });
})();
